/**
 * English (US) translations
 */
export const enUsTranslations = {
  'whatsappTemplates.title': 'Send a WhatsApp template',
  'whatsappTemplates.subtitle':
    'Choose an approved message and personalize it before sending.',
  'whatsappTemplates.subtitleCompact': 'Personalize and send a message.',
  'whatsappTemplates.choose': 'Choose a template',
  'whatsappTemplates.chooseHelp':
    'Search by name or by the message you want to send.',
  'whatsappTemplates.chooseHelpCompact': 'Search by name or message.',
  'whatsappTemplates.search': 'Search templates…',
  'whatsappTemplates.language': 'Language',
  'whatsappTemplates.category': 'Category',
  'whatsappTemplates.allLanguages': 'All languages',
  'whatsappTemplates.allCategories': 'All categories',
  'whatsappTemplates.category.utility': 'Utility',
  'whatsappTemplates.category.marketing': 'Marketing',
  'whatsappTemplates.category.authentication': 'Authentication',
  'whatsappTemplates.results': '{count} templates',
  'whatsappTemplates.showUnavailable': 'Show unavailable ({count})',
  'whatsappTemplates.noTextPreview': 'This template has no text preview.',
  'whatsappTemplates.noResults': 'No matching templates',
  'whatsappTemplates.noResultsHelp':
    'Try another search or show unavailable templates.',
  'whatsappTemplates.empty': 'This account has no templates',
  'whatsappTemplates.emptyHelp':
    'Create and approve a template in WhatsApp Manager, then refresh this list.',
  'whatsappTemplates.unavailable.notApproved':
    'Meta does not currently allow this template to be sent. Check its status.',
  'whatsappTemplates.unavailable.namedParameters':
    'Comos does not yet support sending named parameters.',
  'whatsappTemplates.unavailable.mediaHeader':
    'Comos does not yet support template media or location headers.',
  'whatsappTemplates.unavailable.unsupportedFormat':
    'This template includes a format or action that Comos cannot yet send.',
  'whatsappTemplates.unavailable.authentication':
    'Authentication templates require a flow that is not yet available here.',
  'whatsappTemplates.unavailable.invalidDefinition':
    'We could not interpret all template data. Refresh the list or choose another template.',
  'whatsappTemplates.personalize': 'Personalize',
  'whatsappTemplates.personalizeHelp':
    'Fill in the details. The approved text stays unchanged.',
  'whatsappTemplates.noFields':
    'This template is ready to review. No additional details are required.',
  'whatsappTemplates.linkField': 'Link for “{label}”',
  'whatsappTemplates.field.header': 'Header detail {number}',
  'whatsappTemplates.field.body': 'Message detail {number}',
  'whatsappTemplates.urlPrefix': 'Fixed portion: {prefix}',
  'whatsappTemplates.suffixPlaceholder': 'End of the link',
  'whatsappTemplates.valuePlaceholder': 'Enter a value…',
  'whatsappTemplates.invalidSuffix':
    'Enter only the end of the link, without spaces or a full URL.',
  'whatsappTemplates.invalidField':
    'Enter a value without line breaks, tabs or more than four consecutive spaces.',
  'whatsappTemplates.required': 'Required',
  'whatsappTemplates.suffixHelp':
    'This will be appended to the fixed portion of the approved link.',
  'whatsappTemplates.preview': 'Preview',
  'whatsappTemplates.previewHelp': 'This is how the message content will look.',
  'whatsappTemplates.previewDisclaimer':
    'Appearance may vary by device. Preview buttons are not interactive.',
  'whatsappTemplates.details': 'Template details',
  'whatsappTemplates.technicalName': 'Meta name',
  'whatsappTemplates.status': 'Meta status',
  'whatsappTemplates.approved': 'Approved',
  'whatsappTemplates.from': 'From',
  'whatsappTemplates.to': 'To',
  'whatsappTemplates.context': 'Account and recipient',
  'whatsappTemplates.invalidNumber':
    'Enter a valid number with country code, for example +56912345678.',
  'whatsappTemplates.missingSender':
    'Choose a WhatsApp account to see its templates.',
  'whatsappTemplates.refresh': 'Refresh',
  'whatsappTemplates.loadError':
    'We could not load templates. Please try again.',
  'whatsappTemplates.cancel': 'Close',
  'whatsappTemplates.send': 'Send template',
  'whatsappTemplates.review': 'Review message',
  'whatsappTemplates.remaining': '{count} required details remaining',
  'whatsappTemplates.ready': 'Ready to send',
  'whatsappTemplates.checkRequirements':
    'Check the sender, recipient and template availability above.',
  'whatsappTemplates.selectionRequired': 'Choose a template to continue',
  'whatsappTemplates.sent': 'Template sent.',
  'whatsappTemplates.replyRequired':
    'You can write freely once the contact replies.',
  'whatsappTemplates.noticeTitle': 'This conversation needs a template',
  'whatsappTemplates.noticeExpired':
    'Send a template to resume the conversation.',
  'whatsappTemplates.noticeNew': 'Send a template to start the conversation.',
  'whatsappTemplates.noticeWaitingTitle': 'Template sent · Waiting for a reply',
  'whatsappTemplates.noticeWaiting': 'Template sent. Waiting for a reply.',
  'whatsappTemplates.chooseAction': 'Choose template',
  'whatsappTemplates.anotherAction': 'Another template',
  'whatsappTemplates.windowHelpTitle': 'How WhatsApp reply windows work',
  'whatsappTemplates.windowHelpExpiredTitle': 'Resume the conversation',
  'whatsappTemplates.windowHelpNewTitle': 'Start the conversation',
  'whatsappTemplates.windowHelpWaitingTitle': 'Waiting for a reply',
  'whatsappTemplates.windowHelpExpired':
    'More than 24 h have passed since their last message.',
  'whatsappTemplates.windowHelpNew': 'No reply window is open yet.',
  'whatsappTemplates.windowHelpTemplate': 'You send a template',
  'whatsappTemplates.windowHelpTemplateDetail':
    'A message approved by WhatsApp.',
  'whatsappTemplates.windowHelpSent': 'Template sent',
  'whatsappTemplates.windowHelpSentDetail':
    'Sending another does not open the window.',
  'whatsappTemplates.windowHelpReply': 'The contact replies',
  'whatsappTemplates.windowHelpWindow': '24 h for free-form messages',
  'whatsappTemplates.windowHelpRule':
    'Each new message from the contact resets the 24 h.',
  'whatsappTemplates.windowHelpClose': 'Close help',
  'propertyLinks.selectedText': 'Link portion',
  'propertyLinks.useWholeText': 'Use entire text',
  'propertyLinks.keepExample': 'Keep current link',
  'propertyLinks.viewExternal': 'View configuration',
  'propertyLinks.configureComos': 'Configure website',
  'propertyLinks.editExternal': 'Edit configuration',
  'propertyLinks.back': 'Back',
  'propertyLinks.reviewLink': 'Review link',
  'propertyLinks.setupProgress': 'Setup steps',
  'propertyLinks.saving': 'Saving…',
  'propertyLinks.autosaveHelp': 'The order is saved automatically.',
  'propertyLinks.autoSaveError':
    'The change could not be confirmed. Please try again.',
  'propertyLinks.resetConfirmation':
    'The default order will be restored and the external website configuration removed. This change will be saved immediately.',
  'propertyLinks.incompleteMappings':
    'Complete both columns. Each Comos value can have only one equivalent.',
  'propertyLinks.sourceHelp.id': 'Identifier assigned by Comos',
  'propertyLinks.sourceHelp.sourceId':
    'Original identifier from the import system',
  'propertyLinks.sourceHelp.sourceCode':
    'Listing code received from the source',
  'propertyLinks.sourceHelp.sourceSystem':
    'System the property was imported from',
  'propertyLinks.sourceHelp.mercadoLibreCode': 'Mercado Libre listing code',
  'propertyLinks.sourceHelp.name': 'Stored property name',
  'propertyLinks.sourceHelp.locality': 'Locality name',
  'propertyLinks.sourceHelp.localityCode': 'Stored locality code',
  'propertyLinks.sourceHelp.region': 'Region name',
  'propertyLinks.sourceHelp.regionCode': 'Stored region code',
  'propertyLinks.sourceHelp.countryCode': 'Country code',
  'propertyLinks.sourceHelp.neighborhood': 'Neighborhood name',
  'propertyLinks.sourceHelp.operation': 'Property operation type',
  'propertyLinks.sourceHelp.propertyType': 'Property category',
  'propertyLinks.sourceHelp.identifier': 'Identifier imported from this system',
  'propertyLinks.exampleStep': 'Example link',
  'propertyLinks.pasteExample': 'Paste a property link',
  'propertyLinks.pasteExampleHelp':
    'Use a link from your website. Then choose which parts change for each property.',
  'propertyLinks.useExample': 'Use link',
  'propertyLinks.invalidExample':
    'Enter a complete http:// or https:// link without credentials, spaces or fragments (#).',
  'propertyLinks.markVariables': 'Which parts change?',
  'propertyLinks.markVariablesHelp':
    'Click a part of the link to configure it. Parts connected to Comos values change for each property.',
  'propertyLinks.editPortion': 'Choose source for',
  'propertyLinks.needsVariable':
    'Mark at least one value that changes for each property.',
  'propertyLinks.chooseSource': 'Which value does this represent?',
  'propertyLinks.selectSubstring': 'Use only part of the text',
  'propertyLinks.selectSubstringHelp':
    'Select only the characters that change. For example, 4512 within house-4512.',
  'propertyLinks.identifierOptions': 'Identifier options',
  'propertyLinks.editPart': 'Configure this part of the link',
  'propertyLinks.partBehavior': 'How is this part filled in?',
  'propertyLinks.variableMode': 'Comos value',
  'propertyLinks.variableModeHelp': 'Changes for each property.',
  'propertyLinks.fixedMode': 'Always the same text',
  'propertyLinks.fixedModeHelp': 'Repeats unchanged in every link.',
  'propertyLinks.applyPart': 'Apply change',
  'propertyLinks.fixedText': 'Text to include in the link',
  'propertyLinks.fixedTextPlaceholder': 'For example, property',
  'propertyLinks.fixedTextHelp':
    'Enter ordinary text. Spaces and special characters are automatically encoded for the URL.',
  'propertyLinks.customizeValues': 'Customize values',
  'propertyLinks.mappingHelp':
    'When Comos provides the value on the left, the link uses the text on the right. Other values stay unchanged. This applies wherever this value is used.',
  'propertyLinks.mappingFrom': 'Value received from Comos',
  'propertyLinks.mappingTo': 'Text used by your website',
  'propertyLinks.mappingToPlaceholder':
    'Enter the equivalent used by your website',
  'propertyLinks.chooseValue': 'Choose a value',
  'propertyLinks.addMapping': 'Add equivalent',
  'propertyLinks.removeMapping': 'Remove',
  'propertyLinks.examplePreview': 'This is how the link will look',
  'propertyLinks.examplePreviewHelp':
    'Preview with fictional data. It does not check whether the link exists on your website.',
  'propertyLinks.exampleValues': 'Change example values',
  'propertyLinks.exampleValue': 'Example for',
  'propertyLinks.replaceExample': 'Replace example link',
  'propertyLinks.replaceExampleHelp':
    'This removes the variables and equivalents from this draft. Your saved configuration remains active until you save changes.',

  'common.saveFeedback.saving': 'Saving…',
  'common.saveFeedback.saved': 'Saved',
  'common.saveFeedback.retry': 'Retry',
  'settings.employees.responseWait.unit': 'seconds',
  'settings.tenant.title': 'General settings',
  'settings.tenant.domains': 'Settings sections',
  'settings.tenant.unsaved': 'Unsaved changes',
  'settings.tenant.saved': 'No pending changes',
  'settings.tenant.reset': 'Reset',
  'settings.tenant.description':
    'Manage settings that apply to everyone in your company.',
  'settings.tenant.properties.title': 'Properties',
  'settings.tenant.properties.description':
    'Configure how property information is shared and displayed.',
  // Company property links
  'propertyLinks.nativeIdentifier': 'Property identifier',
  'propertyLinks.customIdentifier': 'Custom identifier',
  'propertyLinks.openSource': 'Open source',
  'propertyLinks.title': 'Property links',
  'propertyLinks.description':
    'Choose the property links your company shares in Comos, including AI Agents.',
  'propertyLinks.priority': 'Destination priority',
  'propertyLinks.priorityHelp':
    'The first available link is used. Unconfigured destinations keep their position and are skipped.',
  'propertyLinks.destination.comos': 'Comos website',
  'propertyLinks.destination.external': 'External website',
  'propertyLinks.destination.source': 'Original source',
  'propertyLinks.moveUp': 'Move up',
  'propertyLinks.moveDown': 'Move down',
  'propertyLinks.path': 'Property page path',
  'propertyLinks.identifierValue': 'Identifier value',
  'propertyLinks.rawValue': 'Original value',
  'propertyLinks.normalizedValue': 'Normalized value',
  'propertyLinks.namespace': 'Identifier namespace',
  'propertyLinks.anyNamespace': 'Any namespace',
  'propertyLinks.exactNamespace': 'A specific namespace',
  'propertyLinks.nullNamespace': 'No assigned namespace',
  'propertyLinks.unlabelled': 'Unlabelled identifier',
  'propertyLinks.configureExternal': 'Configure external website',
  'propertyLinks.removeExternal': 'Remove website',
  'propertyLinks.removeExternalHelp':
    'The external website configuration will be removed immediately. Links will use the remaining available destinations in priority order.',
  'propertyLinks.queryValue': 'Query parameter value',
  'propertyLinks.moreParameters': 'Load more identifier categories',
  'propertyLinks.parameterError': 'Identifier categories could not be loaded.',
  'propertyLinks.invalidQuery':
    'Check the fixed text under Additional parameters. Use %26 for &, %23 for # and %20 for spaces. Each % must be followed by two hexadecimal digits (0–9, A–F). Click that part of the link to correct it.',
  'propertyLinks.invalidTemplate':
    'Review the link, variables and value equivalents before saving.',
  'propertyLinks.noLink': 'No sharing link is available for this property.',
  'propertyLinks.previewError':
    'The preview could not be completed. Try again.',
  'propertyLinks.reason.website_unavailable':
    'No compatible published Comos website',
  'propertyLinks.reason.external_unconfigured':
    'External website not configured',
  'propertyLinks.reason.missing_parameter':
    'A required property value is missing',
  'propertyLinks.reason.ambiguous_identifier':
    'More than one identifier matches',
  'propertyLinks.reason.invalid_url': 'These values cannot form a valid link',
  'propertyLinks.reason.source_unavailable': 'No valid source link',
  'propertyLinks.noPermission':
    'You do not have permission to view these settings.',
  'propertyLinks.loading': 'Loading…',
  'propertyLinks.invalidSavedPolicy':
    'The saved settings are invalid. Comos is using the application defaults until you save valid settings or reset to default.',
  'propertyLinks.resetDefault': 'Reset',
  'propertyLinks.resetDefaultHelp':
    'Reset property links to their default configuration',
  'propertyLinks.loadError': 'Property link settings could not be loaded.',
  'propertyLinks.saveError':
    'The save could not be confirmed. Your draft is preserved; try again.',
  'propertyLinks.retry': 'Retry',
  'propertyLinks.save': 'Save changes',
  'propertyLinks.cancel': 'Cancel',
  'propertyLinks.unavailable': 'Property link settings are not available yet.',
  'propertyLinks.copy': 'Copy link',
  'propertyLinks.shareAction': 'Share',
  'propertyLinks.copied': 'Link copied',
  'propertyLinks.copyError': 'The link could not be copied. Try again.',
  'propertyLinks.resolutionError':
    'The sharing link could not be prepared. Refresh the property before sharing.',
  'propertyLinks.unconfigured': 'not configured',
  'propertyLinks.shareTitle': 'Which property would you like to share?',
  'composer.attachments.title': 'Add to message',
  'emojiPicker.title': 'Emojis',
  'emojiPicker.open': 'Add emoji',
  'emojiPicker.close': 'Close emojis',
  'emojiPicker.keyboard': 'Return to keyboard',
  'emojiPicker.search': 'Search emojis…',
  'emojiPicker.clearSearch': 'Clear search',
  'emojiPicker.categories': 'Emoji categories',
  'emojiPicker.select': 'Select an emoji',
  'emojiPicker.noResults': 'No emojis found',
  'emojiPicker.oneResult': '1 emoji found',
  'emojiPicker.manyResults': '%n emojis found',
  'emojiPicker.loading': 'Loading emojis…',
  'emojiPicker.loadError': 'Emojis could not be loaded',
  'emojiPicker.retry': 'Try again',
  'emojiPicker.tones.neutral': 'Default skin tone',
  'emojiPicker.tones.light': 'Light skin tone',
  'emojiPicker.tones.mediumLight': 'Medium-light skin tone',
  'emojiPicker.tones.medium': 'Medium skin tone',
  'emojiPicker.tones.mediumDark': 'Medium-dark skin tone',
  'emojiPicker.tones.dark': 'Dark skin tone',
  'composer.attachments.file': 'File',
  'composer.attachments.quickTemplate': 'Use quick template',
  'composer.attachments.whatsappTemplate': 'Use WhatsApp template',
  'composer.attachments.manageQuickTemplates': 'Manage quick templates',
  'composer.attachments.manageWhatsAppTemplates': 'Manage WhatsApp templates',
  'propertyLinks.share': 'Share property',
  'propertyLinks.insert': 'Add',
  'propertyLinks.insertHelp':
    'Select a property to insert its link into your draft.',
  'propertyLinks.field.id': 'Comos property ID',
  'propertyLinks.field.sourceId': 'Source ID',
  'propertyLinks.field.sourceCode': 'Source code',
  'propertyLinks.field.sourceSystem': 'Source system',
  'propertyLinks.field.mercadoLibreCode': 'Mercado Libre code',
  'propertyLinks.field.name': 'Property name',
  'propertyLinks.field.locality': 'Locality',
  'propertyLinks.field.localityCode': 'Locality code',
  'propertyLinks.field.region': 'Region',
  'propertyLinks.field.regionCode': 'Region code',
  'propertyLinks.field.countryCode': 'Country code',
  'propertyLinks.field.neighborhood': 'Neighborhood',
  'propertyLinks.field.operation': 'Operation',
  'propertyLinks.field.propertyType': 'Property type',

  // Shared notices and frontend updates
  'shared.notices.dismiss': 'Dismiss notice',
  'appUpdates.title': 'A new version of Comos is available',
  'appUpdates.mobileTitle': 'A new version is available',
  'appUpdates.message':
    'The page will reload and return you to the same place.',
  'appUpdates.mobileMessage': 'The page will reload.',
  'appUpdates.action': 'Update now',
  'appUpdates.confirmTitle': 'Update Comos?',
  'appUpdates.confirmMessage': 'The page will reload to use the new version.',
  'appUpdates.confirm': 'Update',
  'appUpdates.cancel': 'Cancel',

  // Funnel terminal outcomes
  'crm.funnelStatus.terminalPositive': 'Successful closing status',
  'crm.funnelStatus.terminalNegative': 'Unsuccessful closing status',
  'crm.funnelStatus.archiveExplanation':
    'Conversations are archived when entering this status and restored when returning to an in-progress status.',
  'crm.funnelStatus.outcomeLabel': 'Terminal status',
  'crm.funnelStatus.inProgress': 'No',
  'crm.funnelStatus.closedPositive': 'Positive',
  'crm.funnelStatus.closedNegative': 'Negative',
  'crm.funnelStatus.system': 'System',
  'reports.dashboard.outcomes.label': 'Status entries during the period',
  'reports.dashboard.outcomes.positive': 'Won',
  'reports.dashboard.outcomes.negative': 'Lost',
  'communications.timeline.emptyTitle': 'No interactions yet',
  'communications.timeline.emptyDescription':
    'Start the conversation by sending a message or making a call',
  'communications.timeline.historyLabel': 'Conversation history',
  'common.undo': 'Undo',
  'communications.conversation.archivePending':
    'Conversation #{id} will be archived in 5 seconds…',
  'communications.conversation.bulkArchivePending':
    '{count} conversations will be archived in 5 seconds…',
  'communications.conversation.autoArchived':
    'The conversation has been archived.',
  'communications.conversation.autoRestored':
    'The conversation has been restored.',
  'communications.conversation.activeDuplicate':
    'An active conversation already exists for this contact in this funnel. This conversation was not moved or restored.',
  'communications.conversation.moveToOpenBeforeRestore':
    'Move the conversation to an in-progress status to restore it automatically.',
  'communications.conversationCard.tags': 'Conversation tags',
  'communications.conversationCard.tags.other': 'Other tags',
  'communications.conversationCard.tags.more.one': 'Show 1 more tag',
  'communications.conversationCard.tags.more.many': 'Show {count} more tags',
  'communications.conversationCard.property.code': 'Code {id}',
  'communications.conversationCard.property.imageAlt': 'Photo of {name}',
  'communications.conversationCard.property.imageUnavailable':
    'Photo unavailable',
  'communications.conversationCard.property.loading': 'Loading property…',
  'communications.conversationCard.property.unavailable':
    'Property unavailable',
  'communications.conversationCard.property.error':
    'Property temporarily unavailable',
  'communications.conversationCard.property.fallbackType': 'Property',
  'communications.conversationCard.property.temporaryRentShort': 'Temp. rent',
  'communications.conversationCard.property.priceUnavailable':
    'Price not provided',
  'communications.conversationCard.property.operationUnavailable':
    'Operation not provided',

  // Shared - Actions
  'shared.actions.back': 'Back',
  'shared.actions.cancel': 'Cancel',
  'shared.actions.apply': 'Apply',
  'shared.actions.close': 'Close',
  'shared.actions.save': 'Save',
  'shared.actions.delete': 'Delete',
  'shared.actions.send': 'Send',
  'shared.date.today': 'Today',
  'shared.pagination.previous': 'Previous page',
  'shared.pagination.next': 'Next page',
  'shared.pagination.page': 'Page {current} of {total}',
  'shared.pagination.compactPage': 'Page {current}/{total}',
  'shared.modal.dialogLabel': 'Dialog',
  'shared.advancedFilters.button': 'Filters',
  'shared.advancedFilters.title': 'Advanced filters',
  'shared.advancedFilters.description':
    'Adjust the criteria to find the right conversations.',
  'shared.advancedSorts.button': 'Sort',
  'shared.advancedSorts.title': 'Sort conversations',
  'shared.advancedSorts.description':
    'Define the order in which you want to review the results.',

  // Shared - Auth bootstrap
  'shared.auth.bootstrap.error.title': 'We could not complete your sign-in',
  'shared.auth.bootstrap.error.retryAction': 'Try again',
  'shared.auth.bootstrap.error.reauthAction': 'Sign in again',
  'shared.auth.bootstrap.error.manualRecoveryAction': 'Sign in another way',
  'shared.auth.bootstrap.error.timeout':
    'Authentication is taking longer than expected. Please try again.',
  'shared.auth.bootstrap.error.temporaryUnavailable':
    'Authentication is temporarily unavailable. Please try again.',
  'shared.auth.bootstrap.error.backendUnavailable':
    'We could not finish loading your local user. Please try again.',
  'shared.auth.bootstrap.error.sessionInvalid':
    'Your session is no longer valid. Sign in again to continue.',
  'shared.auth.bootstrap.error.localUserLinkFailed':
    'We could not link your sign-in to a local user. Contact your administrator.',
  'shared.auth.bootstrap.error.manualRecovery':
    'For your security, we could not match this sign-in method to your Comos account. Use your usual sign-in method or contact support.',
  'shared.auth.bootstrap.error.accessDenied':
    'Your account does not have access to this application.',
  'shared.auth.bootstrap.error.permissionsUnavailable':
    'We could not retrieve your permissions yet. Please try again.',
  'shared.api.retry.unauthorized':
    'Your session has ended. Sign in again. If you do not have an invitation, contact your team administrator.',
  'shared.api.retry.forbidden':
    'You cannot do this. Make sure your account has the required permissions and try again.',

  // Shared - Searchable Select
  'shared.searchableSelect.placeholder': 'Select or search...',
  'shared.searchableSelect.searchPlaceholder': 'Search...',
  'shared.searchableSelect.emptyLabel': 'No results',
  'shared.searchableSelect.emptyDescription': 'Try another search',
  'shared.dropdown.mobileTitle': 'Options',
  'shared.multiSelect.placeholder': 'Select options',
  'shared.multiSelect.searchPlaceholder': 'Search...',
  'shared.multiSelect.selectAll': 'Select all',
  'shared.multiSelect.clear': 'Clear',
  'shared.multiSelect.emptyLabel': 'No results',
  'shared.multiSelect.emptyDescription': 'Try another search term.',
  'shared.multiSelect.selectedSummary': '{count} selected',

  // Shared - Expandable Section
  'shared.expandableSection.show': 'Show',
  'shared.expandableSection.hide': 'Hide',
  'shared.expandableSection.viewMore': 'View more',
  'shared.expandableSection.viewLess': 'View less',
  'shared.expandableSection.moreContent': 'More content',

  // Shared - Property Selector
  'shared.propertySelector.none': 'No property',
  'shared.propertySelector.open': 'Open property',
  'shared.propertySelector.tooltip':
    'Assign a property of interest to this conversation',
  'shared.property.label': 'Property',
  'shared.property.ofInterest': 'Property of interest',
  'shared.property.noneAssigned': 'No property assigned',
  'shared.property.searchTitle': 'Property search',
  'shared.property.idLabel': 'Property ID {id}',
  'shared.property.ofInterestRemoved': 'Property of interest removed',
  'shared.property.ofInterestCleared': 'Property of interest cleared',
  'shared.property.ofInterestUpdated': 'Property of interest updated',
  'shared.property.ofInterestWithId': 'Property of interest {id}',
  'shared.inline.copy': 'Copy',
  'shared.inline.copied': 'Copied!',
  'shared.inline.openLink': 'Open link',
  'shared.copyableValue.copy': 'Copy: {label}',
  'shared.copyableValue.copied': 'Copied: {label}',
  'shared.colorInput.picker': 'Color picker: {label}',
  'shared.colorInput.hex': 'Hex code: {label}',
  'shared.fileInput.upload': 'Upload',
  'shared.fileInput.replace': 'Replace',
  'shared.fileInput.uploadHint': 'Upload a file',
  'shared.fileInput.replaceHint': 'Replace the file',
  'shared.fileInput.errors.type':
    'This file type is not allowed. Please choose a valid file.',
  'shared.fileInput.errors.size':
    'The file is too large. The maximum size is {size} MB.',
  'shared.fileInput.errors.generic': 'Could not validate the file',
  'shared.inline.actions': 'More actions',
  'shared.inline.pressToEdit': 'Press to edit',
  'shared.inline.select': 'Select',

  // Communications - Contact sidepanel
  'communications.conversation.operationConflict':
    'Another operation is updating this conversation. Please try again.',
  'communications.contactPanel.title': 'Details',
  'communications.contactPanel.error.title': 'Error loading data',
  'communications.contactPanel.error.description':
    'Unable to load the contact information. Please try again.',
  'communications.contactPanel.error.close': 'Close',
  'communications.contactPanel.conversations.title': 'Conversation',
  'communications.contactPanel.conversations.empty':
    'This contact has no conversations',
  'communications.contactPanel.conversations.error.title':
    'Error loading conversations',
  'communications.contactPanel.conversations.error.description':
    'Unable to load conversations.',
  'communications.contactPanel.conversations.customFields.create':
    'Create conversation custom field',
  'communications.contactPanel.conversations.fields.error.title':
    'Error loading data',
  'communications.contactPanel.conversations.fields.error.description':
    'Unable to load the conversation. Please try again.',
  'communications.contactPanel.conversations.fields.emptySelect':
    'Select a conversation to view its details',
  'communications.contactPanel.conversations.fields.status': 'Status',
  'communications.contactPanel.conversations.fields.assignee': 'Assigned',
  'communications.contactPanel.conversations.fields.tasks': 'Tasks',
  'communications.contactPanel.conversations.fields.noneStatus': 'No status',
  'communications.contactPanel.conversations.fields.unassigned': 'Unassigned',
  'communications.contactPanel.conversations.fields.noTasks': 'No tasks',
  'communications.contactPanel.conversations.fields.viewTasks': 'View tasks',
  'communications.contactPanel.conversations.fields.taskCountSingular':
    '{count} task',
  'communications.contactPanel.conversations.fields.taskCountPlural':
    '{count} tasks',
  'communications.contactPanel.conversations.fields.taskModalTitle':
    'Conversation tasks',
  'communications.contactPanel.conversations.fields.newTask': 'New',
  'communications.testConversation.badge': 'Test',
  'communications.interactions.actions.newCall': 'New call',
  'communications.interactions.actions.newMessage': 'New message',
  'communications.interactions.actions.importConversations':
    'Import conversations',
  'communications.testConversations.actions.create': 'New test conversation',
  'communications.testConversations.actions.confirmCreate':
    'Create conversation',
  'communications.testConversations.actions.replyAsContact': 'Reply as contact',
  'communications.testConversations.form.fromPhoneRequired':
    'You must select a source number',
  'communications.testConversations.form.initialMessageRequired':
    'You must enter an initial message',
  'communications.testConversations.form.replyRequired':
    'You must enter a message',
  'communications.testConversations.form.lineLabel': 'WhatsApp line',
  'communications.testConversations.form.contactNameLabel': 'Contact name',
  'communications.testConversations.form.contactNamePlaceholder': 'Test buyer',
  'communications.testConversations.form.initialMessageLabel':
    'Initial message',
  'communications.testConversations.form.initialMessagePlaceholder':
    'Hi, I am interested in a property and would like more information.',
  'communications.testConversations.form.messageLabel': 'Message',
  'communications.testConversations.form.replyPlaceholder':
    'I would like to schedule a visit, how should we proceed?',
  'communications.testConversations.contactAddress.readOnlyTooltip':
    'This test identity is managed automatically.',
  'communications.contactPanel.section.viewMoreCount': 'Show {count} more',
  'communications.contactPanel.contact.info.title': 'Information',
  'communications.contactPanel.contact.info.updateError':
    'Unable to update the field. Please try again.',
  'communications.contactPanel.contact.info.error.title':
    'Error loading information',
  'communications.contactPanel.contact.info.error.description':
    'Unable to load the contact information. Please try again.',
  'communications.contactPanel.contact.info.firstName': 'First name',
  'communications.contactPanel.contact.info.firstNamePlaceholder':
    'Enter first name...',
  'communications.contactPanel.contact.info.lastName': 'Last name',
  'communications.contactPanel.contact.info.lastNamePlaceholder':
    'Enter last name...',
  'communications.contactPanel.contact.info.nationalId': 'National ID',
  'communications.contactPanel.contact.info.nationalIdPlaceholder':
    'Enter national ID...',
  'communications.contactPanel.contact.info.companyPosition': 'Job title',
  'communications.contactPanel.contact.info.companyPositionPlaceholder':
    'Enter job title...',
  'communications.contactPanel.contact.customFields.create':
    'Create contact custom field',
  'communications.contactPanel.contact.customFields.error.title':
    'Error loading data',
  'communications.contactPanel.contact.customFields.error.description':
    'Unable to load custom fields. Please try again.',
  'communications.contactPanel.contact.addresses.title': 'Contact addresses',
  'communications.contactPanel.contact.addresses.error.title':
    'Error loading addresses',
  'communications.contactPanel.contact.addresses.error.description':
    'Unable to load contact addresses. Please try again.',
  'communications.contactPanel.contact.addresses.empty':
    'Add an address to this contact',
  'communications.contactPanel.contact.addresses.addError':
    'Unable to add the address. Please try again.',
  'communications.contactPanel.contact.addresses.updateError':
    'Unable to update the address. Please try again.',
  'communications.contactPanel.contact.addresses.deleteError':
    'Unable to delete the address. Please try again.',
  'communications.contactPanel.contact.addresses.email': 'Email',
  'communications.contactPanel.contact.addresses.phone': 'Phone',
  'communications.contactPanel.contact.addresses.whatsapp': 'WhatsApp',
  'communications.contactPanel.contact.addresses.placeholder':
    'Enter the address...',
  'communications.contactPanel.contact.addresses.deleteConfirm':
    'Do you want to delete this address?',
  'communications.filters.propertyOfInterest': 'Property of interest',
  'communications.realtimeNotice.reconnecting': 'Reconnecting',
  'communications.realtimeNotice.delayed': 'Live updates interrupted',
  'communications.realtimeNotice.description':
    "New messages and status changes may take longer to appear. We'll try to reconnect automatically.",
  'communications.realtimeNotice.explanation': 'About live updates',
  'communications.conversationHeader.backToConversations':
    'Back to conversations',
  'communications.conversationHeader.viewContactProfile':
    'View contact profile',
  'communications.conversationHeader.moreActions': 'More actions',
  'communications.conversationHeader.tasks.overdueCount': '{count} overdue',
  'communications.conversationHeader.tasks.upcomingCount': '{count} upcoming',
  'communications.conversationHeader.tasks.clickToView': 'Click to view',
  'communications.contactPanel.contact.company.title': 'Company',
  'communications.contactPanel.contact.company.error.title':
    'Error loading company',
  'communications.contactPanel.contact.company.error.description':
    'Unable to load company information. Please try again.',
  'communications.contactPanel.contact.company.empty': 'Add a company',
  'communications.contactPanel.contact.company.none': 'No company',
  'communications.contactPanel.contact.company.name': 'Name',
  'communications.contactPanel.contact.company.namePlaceholder':
    'Enter company name...',
  'communications.contactPanel.contact.company.updateSuccess':
    'Company updated successfully',
  'communications.contactPanel.contact.company.updateError':
    'Unable to update company. Please try again.',
  'communications.contactPanel.contact.company.deleteSuccess':
    'Company removed successfully',
  'communications.contactPanel.contact.company.deleteError':
    'Unable to remove company. Please try again.',
  'communications.contactPanel.contact.company.deleteModal.title':
    'Delete company',
  'communications.contactPanel.contact.company.deleteModal.description':
    'Are you sure you want to delete this company? This action cannot be undone.',
  'communications.messageBox.whatsapp.emptyState.noAvailableSender':
    'No WhatsApp sender is currently available.',
  'communications.messageBox.whatsapp.emptyState.addContactAddress':
    'Add a WhatsApp address to this contact to chat',
  'communications.messageBox.whatsapp.emptyState.selectAddresses':
    'Select the WhatsApp addresses to chat',
  'communications.messageBox.whatsapp.compactPlaceholder': 'Write a message…',
  'communications.whatsappExpirationAlert.remaining': '{timeLeft} remaining',
  'communications.whatsappExpirationAlert.expired.label': 'Session expired',
  'communications.whatsappExpirationAlert.notActive.label': 'No active session',
  'communications.whatsappExpirationAlert.explanation':
    'About the reply window',
  'communications.attachment.remove': 'Remove file',
  'communications.attachment.uploading': 'Uploading file…',
  'communications.attachment.ready': 'Ready to send',
  'communications.attachment.failed': 'Upload failed',
  'communications.attachment.errorExplanation':
    'Unable to upload the file. Remove it and attach it again to try once more.',
  'communications.messageBox.whatsapp.compactFromLabel': 'From',
  'communications.messageBox.whatsapp.fromLabel': 'From',
  'communications.messageBox.whatsapp.toLabel': 'To',
  'communications.messageBox.whatsapp.accountLabel': 'WhatsApp account',
  'communications.messageBox.whatsapp.selectedAccountUnavailable':
    'Selected account unavailable',
  'communications.whatsappExpirationAlert.notActive.title':
    'Start a WhatsApp conversation.',
  'communications.whatsappExpirationAlert.notActive.description':
    'You will be able to write free messages when the customer sends you a message. Try sending a template.',
  'communications.whatsappExpirationAlert.expired.title':
    'This conversation has expired.',
  'communications.whatsappExpirationAlert.expired.description':
    'It will reactivate when the customer sends you a message. Try sending a template.',
  'communications.whatsappExpirationAlert.warning.title':
    'This conversation will expire in {timeLeft}.',
  'communications.whatsappExpirationAlert.warning.description':
    'Extend it by getting the customer to send you a message.',
  'communications.whatsappExpirationAlert.active':
    'This conversation will expire in {timeLeft}.',
  'communications.panel.unassigned': 'Unassigned',
  'communications.panel.allAssignees': 'All',
  'communications.panel.assigneesCount': '{count} assignees',
  'communications.panel.noFunnel.title': 'No funnel selected',
  'communications.panel.noFunnel.description':
    'Please select or create a funnel to view the conversations',
  'communications.panel.searchLabel': 'Search',
  'communications.panel.searchPlaceholder': 'Search conversations...',
  'communications.panel.funnelTooltip':
    'Viewing the conversations for funnel {funnelName}',
  'communications.panel.assigneeTooltip':
    'Viewing the conversations assigned to {assignee}',
  'communications.viewSwitcher.cards': 'List',
  'communications.viewSwitcher.pipeline': 'Columns',
  'communications.viewSwitcher.table': 'Table',
  'communications.viewSwitcher.tooltip': 'Viewing conversations as {view}',
  'calls.page.title': 'Calls',
  'calls.page.actions.reports': 'Reports',
  'calls.page.actions.featured': 'Featured',
  'calls.page.error.title': 'Unable to load calls',
  'calls.page.error.description':
    'Try refreshing the page or check your connection.',
  'calls.page.error.searchTooBroad':
    'The search took too long. Use a more specific number, contact, or agent.',
  'calls.page.error.retry': 'Retry',
  'calls.search.validation.tooShort': 'Enter at least 3 characters to search.',
  'calls.search.validation.tooLong': 'Use no more than 100 characters.',
  'calls.search.validation.tooManyWords': 'Use no more than 5 words.',
  'calls.search.validation.noIndexableWord':
    'Include 3 consecutive letters or numbers in at least one word.',
  'calendar.agenda.title': 'Agenda',
  'calendar.agenda.actions.newTask': 'New task',
  'calendar.agenda.loading': 'Loading tasks...',
  'calendar.agenda.loadingMore': 'Loading more tasks...',
  'calendar.agenda.error.title': 'Error loading tasks',
  'calendar.agenda.error.description':
    'Unable to load tasks. Please try again.',
  'calendar.agenda.error.retry': 'Retry',
  'calendar.agenda.view.list': 'List',
  'calendar.agenda.view.calendar': 'Calendar',
  'calendar.agenda.filters.button': 'Filters',
  'calendar.agenda.filters.activeButton': 'Active filters',
  'calendar.agenda.filters.clear': 'Clear filters',
  'calendar.agenda.filters.status.all': 'All statuses',
  'calendar.agenda.filters.status.scheduled': 'Scheduled',
  'calendar.agenda.filters.status.completed': 'Completed',
  'calendar.agenda.filters.status.cancelled': 'Cancelled',
  'calendar.agenda.filters.assignee.all': 'All assignees',
  'calendar.agenda.filters.task.all': 'All tasks',
  'calendar.agenda.filters.task.none': 'No conversation',
  'settings.customFields.includeTime.label': 'Include time',
  'settings.customFields.includeTime.warning':
    'When this option is enabled, the field keeps the same key and stored value, but the interface will allow users to capture and display time in addition to the date.',

  // Users
  'users.title': 'Users',
  'users.pagination.fetch': 'Show',
  'users.pagination.records': 'records',
  'users.pagination.summary': '{count} records',
  'users.actions.invite': 'Invite User',
  'users.actions.resendAccess': 'Resend access',
  'users.actions.cancelInvite': 'Cancel invitation',
  'users.actions.deactivate': 'Deactivate',
  'users.actions.reactivate': 'Reactivate',
  'users.error.title': 'Error loading users',
  'users.error.description': 'Unable to load users. Please try again.',
  'users.error.retry': 'Retry',
  'users.invite.success': 'Invitation sent successfully',
  'users.invite.email': 'Email',
  'users.invite.emailPlaceholder': 'user@example.com',
  'users.invite.emailInvalid': 'The email is invalid',
  'users.invite.firstName': 'First name',
  'users.invite.firstNamePlaceholder': 'Jane',
  'users.invite.lastName': 'Last name',
  'users.invite.lastNamePlaceholder': 'Doe',
  'users.invite.personalPhone': 'Personal phone',
  'users.invite.personalPhonePlaceholder': '+56912345678',
  'users.invite.personalPhoneHelp':
    'Important: complete this field so the user can receive WhatsApp notifications.',
  'users.invite.profile': 'Profile',
  'users.invite.team': 'Team',
  'users.invite.team.none': 'No specific team',
  'users.invite.modal.title': 'Invite user',
  'users.invite.modal.description':
    'When you invite a user, they will receive an email with instructions to join Comos.',
  'users.invite.modal.cancel': 'Cancel',
  'users.invite.userAlreadyExists':
    'A user with that email already exists. If needed, resend onboarding from the table.',
  'users.table.user': 'User',
  'users.table.firstName': 'First name',
  'users.table.lastName': 'Last name',
  'users.table.email': 'Email',
  'users.table.status': 'Status',
  'users.table.profile': 'Profile',
  'users.table.team': 'Team',
  'users.table.phone': 'Personal phone',
  'users.table.phoneLabel': 'Phone',
  'users.table.phoneInvalid':
    'The phone number is invalid. Use international format, for example +56912345678.',
  'users.status.pending': 'Pending',
  'users.status.active': 'Active',
  'users.status.inactive': 'Inactive',
  'users.status.cancelled': 'Cancelled',
  'users.profile.agent': 'Agent',
  'users.profile.admin': 'Administrator',
  'users.team.none': 'No team',
  'users.team.fallback': 'Team {id}',
  'users.filters.status.all': 'All statuses',
  'users.filters.status.active': 'Active',
  'users.filters.status.inactive': 'Inactive',
  'users.filters.status.currentAll': 'Status: All',
  'users.filters.status.current': 'Status: {value}',
  'users.filters.profile.all': 'All profiles',
  'users.filters.profile.admin': 'Administrators',
  'users.filters.profile.agent': 'Agents',
  'users.filters.profile.currentAll': 'Profile: All',
  'users.filters.profile.current': 'Profile: {value}',
  'users.filters.team.all': 'All teams',
  'users.filters.team.fallback': 'Team {id}',
  'users.filters.team.currentAll': 'Team: All',
  'users.filters.team.current': 'Team: {name}',
  'users.filters.search.placeholder': 'Search users...',
  'users.filters.search.currentAll': 'Search: All',
  'users.filters.search.current': 'Search: "{value}"',
  'users.filters.clearWithCount': 'Clear ({count})',
  'users.filters.active': 'Active filters:',
  'users.empty.title': 'No users found',
  'users.empty.filteredDescription':
    'Try adjusting the filters to see more results',
  'users.empty.defaultDescription':
    'There are no users registered in the system',

  // Catalog - Products
  'catalog.products.table.name': 'Name',
  'catalog.products.table.description': 'Description',
  'catalog.products.table.price': 'Price',
  'catalog.products.table.source': 'Source',
  'catalog.products.table.updated': 'Updated',
  'catalog.products.table.actions.edit': 'Edit',
  'catalog.products.table.actions.delete': 'Delete',
  'catalog.products.table.emptyState.title': 'No products found',
  'catalog.products.table.emptyState.description':
    'Add a product or change your filters',
  'catalog.products.error.title': 'Unable to load products',
  'catalog.products.error.description':
    'Try refreshing the page or check your connection.',
  'catalog.products.error.retry': 'Retry',
  'catalog.products.confirmDelete.title': 'Delete product',
  'catalog.products.confirmDelete.confirm': 'Delete',
  'catalog.products.confirmDelete.cancel': 'Cancel',
  'catalog.products.confirmDelete.messagePrefix':
    'Are you sure you want to delete',
  'catalog.products.confirmDelete.fallbackName': 'this product',
  'catalog.products.confirmDelete.messageSuffix':
    '? This action cannot be undone.',
  'catalog.products.form.edit': 'Edit product',
  'catalog.products.form.create': 'Create new product',
  'catalog.products.form.name': 'Name',
  'catalog.products.form.description': 'Description',
  'catalog.products.form.price': 'Price',
  'catalog.products.form.currency': 'Currency',
  'catalog.products.form.sourceUrl': 'Source URL',
  'catalog.products.form.sourceUrlPlaceholder': 'https://example.com/product',
  'catalog.products.form.customFields': 'CUSTOM FIELDS',
  'catalog.products.form.saveChanges': 'Save changes',
  'catalog.products.form.createButton': 'Create product',
  'catalog.products.form.cancel': 'Cancel',
  'catalog.products.title': 'Products',
  'catalog.products.import': 'Import',
  'catalog.products.new': 'New product',
  'catalog.products.filters.searchLabel': 'Search',
  'catalog.products.filters.searchPlaceholder': 'Search by name or description',
  'catalog.products.filters.currencyAll': 'All currencies',
  'catalog.products.filters.clear': 'Clear filters',
  'catalog.products.alert.create.success': 'Product created successfully',
  'catalog.products.alert.create.error': 'Error creating product',
  'catalog.products.alert.update.success': 'Product updated successfully',
  'catalog.products.alert.update.error': 'Error updating product',
  'catalog.products.alert.delete.success': 'Product deleted successfully',
  'catalog.products.alert.delete.error': 'Error deleting product',

  // Catalog - Properties
  'catalog.properties.title': 'Properties',
  'catalog.properties.new': 'New',
  'catalog.properties.table.codigo': 'Code',
  'catalog.properties.table.name': 'Name',
  'catalog.properties.table.address': 'Public address',
  'catalog.properties.table.price': 'Price',
  'catalog.properties.table.cadastralId': 'Cadastral ID (ROL)',
  'catalog.properties.table.commonExpenses': 'Common expenses',
  'catalog.properties.table.operation': 'Operation',
  'catalog.properties.table.assigned': 'Assigned',
  'catalog.properties.table.propertyType': 'Type',
  'catalog.properties.table.updated': 'Updated',
  'catalog.properties.table.emptyState.title': 'No properties found',
  'catalog.properties.table.emptyState.description':
    'Run an import or change your filters',
  'catalog.properties.error.title': 'Unable to load properties',
  'catalog.properties.error.description':
    'Try refreshing the page or check your connection.',
  'catalog.properties.filters.searchLabel': 'Search',
  'catalog.properties.filters.searchPlaceholder':
    'Search by title, location or description',
  'catalog.properties.filters.operationAll': 'All operations',
  'catalog.properties.filters.operationSale': 'Sale',
  'catalog.properties.filters.operationRent': 'Rent',
  'catalog.properties.filters.operationSaleAndRent': 'For sale and rent',
  'catalog.properties.filters.operationTemporaryRent': 'Temporary rent',
  'catalog.properties.filters.activeStatusLabel': 'Status',
  'catalog.properties.filters.activeStatusActive': 'Active',
  'catalog.properties.filters.activeStatusInactive': 'Inactive',
  'catalog.properties.filters.activeStatusAll': 'All',
  'catalog.properties.filters.assignedAll': 'All agents',
  'catalog.properties.filters.assignedUnassigned': 'Unassigned',
  'catalog.properties.filters.salePriceRange': 'Sale',
  'catalog.properties.filters.rentPriceRange': 'Rent',
  'catalog.properties.filters.rangeFrom': 'From',
  'catalog.properties.filters.rangeTo': 'To',
  'catalog.properties.filters.region': 'Region',
  'catalog.properties.filters.locality': 'Locality',
  'catalog.properties.filters.regionAll': 'All regions',
  'catalog.properties.filters.localityAll': 'All localities',
  'catalog.properties.filters.clear': 'Clear filters',
  'catalog.properties.toolbar.sortLabel': 'Sort',
  'catalog.properties.toolbar.sort.updatedDesc': 'Updated',
  'catalog.properties.toolbar.sort.createdDesc': 'Newest',
  'catalog.properties.toolbar.sort.priceDesc': 'Highest price',
  'catalog.properties.toolbar.sort.priceAsc': 'Lowest price',
  'catalog.properties.toolbar.viewLabel': 'View',
  'catalog.properties.toolbar.view.visual': 'Cards',
  'catalog.properties.toolbar.view.compact': 'Table',
  'catalog.properties.toolbar.showToolbar': 'Show toolbar',
  'catalog.properties.toolbar.hideToolbar': 'Hide toolbar',
  'catalog.properties.toolbar.filters': 'Filters',
  'catalog.properties.toolbar.filtersWithCount': 'Filters ({count})',
  'catalog.properties.header.actionsMenu': 'Actions',
  'catalog.properties.activeFilters.clearAll': 'Clear all',
  'catalog.properties.activeFilters.remove': 'Remove filter {label}',
  'catalog.properties.assigned.unassigned': 'Unassigned',
  'catalog.properties.list.warning.noPhoto': 'No photo',
  'catalog.properties.list.warning.noPrice': 'No price',
  'catalog.properties.list.warning.noLocation': 'No location',
  'catalog.properties.list.warning.unassigned': 'Unassigned',
  'catalog.properties.list.status.active': 'Active',
  'catalog.properties.list.status.inactive': 'Inactive',
  'catalog.properties.list.placeholder.noImageTitle': 'No image',
  'catalog.properties.list.badge.syncManaged': 'MeLi',
  'catalog.properties.list.provider.meli': 'Mercado Libre',
  'catalog.properties.list.provider.wasi': 'Wasi',
  'catalog.properties.list.provider.toppropiedades': 'Top Propiedades',
  'catalog.properties.list.provider.kiteprop': 'KiteProp',
  'catalog.properties.publications.page.title': 'Publications',
  'catalog.properties.publications.page.subtitle':
    'Monitor the latest portal publications across all your properties.',
  'catalog.properties.publications.filters.title': 'Filters',
  'catalog.properties.publications.filters.subtitle':
    'Narrow the publication list using the same displayed portal state.',
  'catalog.properties.publications.filters.status.all': 'All statuses',
  'catalog.properties.publications.filters.portal.all': 'All portals',
  'catalog.properties.publications.filters.clear': 'Clear filters',
  'catalog.properties.publications.filters.clearWithCount': 'Filters ({count})',
  'catalog.properties.publications.table.code': 'Code',
  'catalog.properties.publications.table.property': 'Property',
  'catalog.properties.publications.table.operation': 'Operation',
  'catalog.properties.publications.table.portal': 'Portal',
  'catalog.properties.publications.table.publication': 'Publication',
  'catalog.properties.publications.table.status': 'Status',
  'catalog.properties.publications.table.mode': 'Mode',
  'catalog.properties.publications.table.type': 'Type',
  'catalog.properties.publications.table.origin': 'Origin',
  'catalog.properties.publications.table.lastActivity': 'Last activity',
  'catalog.properties.publications.table.actions': 'Actions',
  'catalog.properties.publications.status.draft': 'Draft',
  'catalog.properties.publications.status.published': 'Published',
  'catalog.properties.publications.status.paused': 'Paused',
  'catalog.properties.publications.status.unpublished': 'Unpublished',
  'catalog.properties.publications.status.error': 'Error',
  'catalog.properties.publications.status.paymentRequired': 'Payment pending',
  'catalog.properties.publications.status.underReview': 'Under review',
  'catalog.properties.publications.status.closed': 'Closed',
  'catalog.properties.publications.statusTooltip.draft':
    'The publication exists in Comos, but it is not active in the portal yet.',
  'catalog.properties.publications.statusTooltip.published':
    'The publication is active in the portal and Comos still manages it.',
  'catalog.properties.publications.statusTooltip.paused':
    'The publication still exists, but the portal currently keeps it paused.',
  'catalog.properties.publications.statusTooltip.unpublished':
    'The publication is no longer active in the portal.',
  'catalog.properties.publications.statusTooltip.error':
    'The last action on this publication failed and needs review.',
  'catalog.properties.publications.statusTooltip.paymentRequired':
    'The publication was created, but the portal still requires completing the payment or activating the matching plan.',
  'catalog.properties.publications.statusTooltip.underReview':
    'The portal temporarily stopped this publication while it reviews it.',
  'catalog.properties.publications.statusTooltip.closed':
    'The portal marked this publication as closed or inactive.',
  'catalog.properties.publications.statusTooltip.referenceOnly':
    'Comos knows this publication only as a reference and does not manage it.',
  'catalog.properties.publications.statusTooltip.queuedPublish':
    'Comos already queued the publish action and is waiting for portal confirmation.',
  'catalog.properties.publications.statusTooltip.unknown':
    'Comos does not have enough information yet to determine the real state of this publication.',
  'catalog.properties.publications.mode.managedPublish': 'Published from Comos',
  'catalog.properties.publications.mode.managedPublishTooltip':
    'This publication is managed directly from Comos.',
  'catalog.properties.publications.mode.managedSync': 'Imported',
  'catalog.properties.publications.mode.managedSyncTooltip':
    'This publication entered Comos from the portal sync flow.',
  'catalog.properties.publications.mode.observedExternal': 'Reference',
  'catalog.properties.publications.mode.observedExternalTooltip':
    'This row exists as an external reference and is not managed from Comos.',
  'catalog.properties.publications.mode.unknown': 'Unknown',
  'catalog.properties.publications.mode.unknownTooltip':
    'Comos does not have enough information yet to classify how this row is managed.',
  'catalog.properties.publications.type.connected': 'Linked',
  'catalog.properties.publications.type.connectedTooltip':
    'This is the active local row linked to the live portal listing.',
  'catalog.properties.publications.type.referenceOnly': 'Reference',
  'catalog.properties.publications.type.referenceOnlyTooltip':
    'This row is informational only and does not actively manage the portal listing.',
  'catalog.properties.publications.type.disconnected': 'Unlinked',
  'catalog.properties.publications.type.disconnectedTooltip':
    'This row exists locally, but it is not currently linked to a live portal listing.',
  'catalog.properties.publications.type.unknown': 'Unknown',
  'catalog.properties.publications.type.unknownTooltip':
    'Comos does not have enough information yet to classify the current linkage.',
  'catalog.properties.publications.origin.unknown': 'Unknown',
  'catalog.properties.publications.origin.meliTooltip':
    'This publication originated from Mercado Libre activity.',
  'catalog.properties.publications.origin.wasiTooltip':
    'This publication originated from Wasi activity.',
  'catalog.properties.publications.origin.toppropiedadesTooltip':
    'This publication originated from Top Propiedades activity.',
  'catalog.properties.publications.origin.unknownTooltip':
    'Comos does not have enough information yet to identify which provider originated this row.',
  'catalog.properties.publications.operation.SALE': 'Sale',
  'catalog.properties.publications.operation.RENT': 'Rent',
  'catalog.properties.publications.operation.TEMPORARY_RENT': 'Temporary rent',
  'catalog.properties.publications.operation.SALE_AND_RENT': 'Sale and rent',
  'catalog.properties.publications.operation.unknown': 'Unknown',
  'catalog.properties.publications.property.unknownName': 'Property pending',
  'catalog.properties.publications.property.unknownAddress': 'Address pending',
  'catalog.properties.publications.publication.unknown': 'Without code',
  'catalog.properties.publications.empty.title': 'No publications yet',
  'catalog.properties.publications.empty.description':
    'When your portals sync or you publish from Comos, the linked publications will appear here.',
  'catalog.properties.publications.error.title': 'Unable to load publications',
  'catalog.properties.publications.error.description':
    'Refresh the page or try again in a moment.',
  'catalog.properties.error.retry': 'Retry',
  'catalog.properties.list.actions.openMap': 'View map',
  'catalog.properties.list.badge.imported': 'Source: {source}',
  'catalog.properties.list.fallback.location': 'Location pending',
  'catalog.properties.list.fallback.address': 'Public address still missing',
  'catalog.properties.list.fallback.price': 'Price pending',
  'catalog.properties.list.fallback.metrics': 'Key details missing',
  'catalog.properties.list.metric.bedrooms': 'Bedrooms',
  'catalog.properties.list.metric.bathrooms': 'Bathrooms',
  'catalog.properties.list.metric.areaUsable': 'Usable area',
  'catalog.properties.list.metric.areaTotal': 'Total area',
  'catalog.properties.list.metric.parkingLots': 'Parking',
  'catalog.properties.list.updated': 'Updated {value}',
  'catalog.properties.form.operation': 'Operation',
  'catalog.properties.form.name': 'Name',
  'catalog.properties.form.description': 'Description',
  'catalog.properties.form.salePriceAmount': 'Sale price amount',
  'catalog.properties.form.salePriceCurrency': 'Sale price currency',
  'catalog.properties.form.rentPriceAmount': 'Rent price amount',
  'catalog.properties.form.rentPriceCurrency': 'Rent price currency',
  'catalog.properties.form.isActive': 'Property is active',
  'catalog.properties.form.cadastralId': 'Cadastral ID (ROL)',
  'catalog.properties.form.propertyType': 'Property type',
  'catalog.properties.form.condition': 'Condition',
  'catalog.properties.form.locality': 'Locality',
  'catalog.properties.form.region': 'Region',
  'catalog.properties.form.addressDisplay': 'Public address',
  'catalog.properties.form.streetName': 'Street name',
  'catalog.properties.form.streetNumber': 'Street number',
  'catalog.properties.form.unit': 'Unit / Apt.',
  'catalog.properties.form.neighborhood': 'Neighborhood',
  'catalog.properties.form.externalMedia.title': 'External media',
  'catalog.properties.form.externalMedia.help':
    'Add YouTube videos or Matterport virtual tours. Portals publish the first format they support.',
  'catalog.properties.form.externalMedia.provider.youtube': 'YouTube video',
  'catalog.properties.form.externalMedia.provider.matterport':
    'Matterport virtual tour',
  'catalog.properties.form.externalMedia.providerLabel':
    'External media provider {position}',
  'catalog.properties.form.externalMedia.urlLabel':
    'External media URL {position}',
  'catalog.properties.form.externalMedia.add': 'Add external media',
  'catalog.properties.form.externalMedia.remove': 'Remove',
  'catalog.properties.form.bedrooms': 'Bedrooms',
  'catalog.properties.form.bathrooms': 'Bathrooms',
  'catalog.properties.form.rooms': 'Rooms',
  'catalog.properties.form.parkingLots': 'Parking lots',
  'catalog.properties.form.warehouses': 'Warehouses',
  'catalog.properties.form.unitFloor': 'Unit floor',
  'catalog.properties.form.floors': 'Floors',
  'catalog.properties.form.apartmentsPerFloor': 'Apartments per floor',
  'catalog.properties.form.propertyAge': 'Property age',
  'catalog.properties.form.landAccess': 'Land access',
  'catalog.properties.form.landAccess.DIRT': 'Dirt',
  'catalog.properties.form.landAccess.SAND': 'Sand',
  'catalog.properties.form.landAccess.ASPHALT': 'Asphalt',
  'catalog.properties.form.landAccess.GRAVEL': 'Gravel',
  'catalog.properties.form.landAccess.OTHER': 'Other',
  'catalog.properties.form.orientation': 'Orientation',
  'catalog.properties.form.orientation.N': 'North',
  'catalog.properties.form.orientation.S': 'South',
  'catalog.properties.form.orientation.E': 'East',
  'catalog.properties.form.orientation.W': 'West',
  'catalog.properties.form.orientation.NE': 'North East',
  'catalog.properties.form.orientation.NW': 'North West',
  'catalog.properties.form.orientation.SE': 'South East',
  'catalog.properties.form.orientation.SW': 'South West',
  'catalog.properties.form.booleanState.unset': 'Not set',
  'catalog.properties.form.booleanState.yes': 'Yes',
  'catalog.properties.form.booleanState.no': 'No',
  'catalog.properties.form.featureState.legend':
    'Each click moves to the next state.',
  'catalog.properties.form.featureState.nextHint': 'Click → {state}',
  'catalog.properties.form.subsection.main.title': 'Main information',
  'catalog.properties.form.subsection.distribution.title': 'Distribution',
  'catalog.properties.form.subsection.building.title':
    'Building and orientation',
  'catalog.properties.form.subsection.main.description':
    'Core unit characteristics that portals usually expect first.',
  'catalog.properties.form.subsection.layout.title': 'Layout and building',
  'catalog.properties.form.subsection.layout.description':
    'Structural details about the building or the unit within it.',
  'catalog.properties.form.subsection.surfaces.title': 'Surfaces',
  'catalog.properties.form.surfaceUsable': 'Usable surface (m²)',
  'catalog.properties.form.surfaceUsableHelp': 'Indoor usable square meters.',
  'catalog.properties.form.surfaceUsableHelpOptional':
    'Only if it applies. Leave empty otherwise.',
  'catalog.properties.form.surfaceCovered': 'Covered surface (m²)',
  'catalog.properties.form.surfaceCoveredHelp':
    'Built or constructed square meters.',
  'catalog.properties.form.surfaceCoveredHelpOptional':
    'Only if there is built area.',
  'catalog.properties.form.surfaceTotal': 'Total surface (m²)',
  'catalog.properties.form.surfaceTotalHelpLot':
    'Published total area. For houses or land, this corresponds to the lot.',
  'catalog.properties.form.surfaceTotalHelpUnit':
    'Published total area of the unit.',
  'catalog.properties.form.surfaceOutdoor': 'Outdoor area (m²)',
  'catalog.properties.form.surfaceOutdoorHelp':
    'Patio, terrace, garden, or other exclusive outdoor areas.',
  'catalog.properties.form.surfaceOutdoorHelpApartment':
    'Terrace or other exclusive outdoor areas.',
  'catalog.properties.form.surfaceOutdoorHelpLot': 'Patio, terrace, or garden.',
  'catalog.properties.form.featuresHelp':
    'Toggle the amenities and feature flags that apply to this property.',
  'catalog.properties.form.featureGroup.conditions.title':
    'Conditions and visibility',
  'catalog.properties.form.featureGroup.conditions.description':
    'Commercial or publication-related aspects that are not always confirmed.',
  'catalog.properties.form.featureGroup.privateSpaces.title':
    'Private spaces and comfort',
  'catalog.properties.form.featureGroup.privateSpaces.description':
    'Amenities and finishes that belong to the unit itself.',
  'catalog.properties.form.featureGroup.commonAreas.title':
    'Common amenities and security',
  'catalog.properties.form.featureGroup.commonAreas.description':
    'Building or community equipment, including security-related items.',
  'catalog.properties.form.feature.furnished': 'Furnished',
  'catalog.properties.form.feature.petsAllowed': 'Pets allowed',
  'catalog.properties.form.feature.hasVirtualTour': 'Virtual tour',
  'catalog.properties.form.feature.hasBalcony': 'Balcony',
  'catalog.properties.form.feature.hasKitchen': 'Kitchen',
  'catalog.properties.form.feature.hasLift': 'Lift',
  'catalog.properties.form.feature.hasPlayground': 'Playground',
  'catalog.properties.form.feature.hasRoofGarden': 'Roof garden',
  'catalog.properties.form.feature.hasBusinessCenter': 'Business center',
  'catalog.properties.form.feature.hasCinemaHall': 'Cinema hall',
  'catalog.properties.form.feature.hasTennisCourt': 'Tennis court',
  'catalog.properties.form.feature.hasGarden': 'Garden',
  'catalog.properties.form.feature.hasPatio': 'Patio',
  'catalog.properties.form.feature.hasTerrace': 'Terrace',
  'catalog.properties.form.feature.hasLaundry': 'Laundry',
  'catalog.properties.form.feature.hasPool': 'Pool',
  'catalog.properties.form.feature.hasGym': 'Gym',
  'catalog.properties.form.feature.hasSecurity': 'Security',
  'catalog.properties.form.feature.hasHeating': 'Heating',
  'catalog.properties.form.feature.hasAirConditioning': 'Air conditioning',
  'catalog.properties.form.feature.hasInternetAccess': 'Internet access',
  'catalog.properties.validation.nameRequired': 'Name is required',
  'catalog.properties.validation.nameTooLong':
    'Name must be {max} characters or fewer',
  'catalog.properties.validation.invalidUrl': 'Invalid URL',
  'catalog.properties.validation.nonNegativeNumber':
    '{field} must be a positive number',
  'catalog.properties.validation.nonNegativeInteger':
    '{field} must be a positive whole number',
  'catalog.properties.form.surfacesHelp':
    'Use the measurements from the original source. If a value does not exist, leave it empty.',
  'catalog.properties.form.commonExpensesAmount': 'Common expenses (CLP)',
  'catalog.properties.form.sourceUrl': 'Source URL',
  'catalog.properties.form.sourceUrlPlaceholder':
    'https://example.com/property',
  'catalog.properties.propertyType.HOUSE': 'House',
  'catalog.properties.propertyType.APARTMENT': 'Apartment',
  'catalog.properties.propertyType.PARCEL': 'Rural property',
  'catalog.properties.propertyType.APARTMENT_STUDIO': 'Apartment - Studio',
  'catalog.properties.propertyType.OFFICE': 'Office',
  'catalog.properties.propertyType.RETAIL': 'Retail',
  'catalog.properties.propertyType.WAREHOUSE': 'Warehouse',
  'catalog.properties.propertyType.LAND': 'Land',
  'catalog.properties.propertyType.PARKING': 'Parking',
  'catalog.properties.propertyType.INDUSTRIAL': 'Industrial',
  'catalog.properties.propertyType.OTHER': 'Other',
  'catalog.properties.propertyCondition.USED': 'Used',
  'catalog.properties.propertyCondition.NEW': 'New',
  'catalog.properties.price.saleLabel': 'Sale',
  'catalog.properties.price.rentLabel': 'Rent',
  'catalog.properties.operation.SALE': 'Sale',
  'catalog.properties.operation.RENT': 'Rent',
  'catalog.properties.operation.SALE_AND_RENT': 'Sale & rent',
  'catalog.properties.operation.TEMPORARY_RENT': 'Temporary rent',
  'catalog.properties.import.title': 'Import properties',
  'catalog.properties.import.description.tabular':
    'Upload an export file (CSV/XLS/XLSX) to start an import or update.',
  'catalog.properties.import.description.spreadsheet':
    'Upload an export file (XLS/XLSX) to start an import or update.',
  'catalog.properties.import.confirm': 'Start import',
  'catalog.properties.import.file.label.tabular': 'File (CSV/XLS/XLSX)',
  'catalog.properties.import.file.label.spreadsheet': 'File (XLS/XLSX)',
  'catalog.properties.import.provider.label': 'Provider',
  'catalog.properties.import.provider.option.prop360': 'Prop360 (Convecta)',
  'catalog.properties.import.provider.option.kutt': 'Kutt',
  'catalog.properties.import.provider.option.ilist': 'Ilist',
  'catalog.properties.import.provider.option.globalbrokers': 'Global Brokers',
  'catalog.properties.import.alert.success':
    'The import of your properties has started. It may take a few minutes to complete.',
  'catalog.properties.import.alert.noFile.tabular':
    'Please select a CSV, XLS, or XLSX file.',
  'catalog.properties.import.alert.noFile.spreadsheet':
    'Please select an XLS or XLSX file.',
  'catalog.properties.import.alert.filterValueRequired':
    'You must enter a value to filter by.',
  'catalog.properties.import.filter.toggle':
    'Import only properties that match',
  'catalog.properties.import.filter.columnLabel': 'Column',
  'catalog.properties.import.filter.valueLabel': 'Value to match',
  'catalog.properties.import.filter.column.agente': 'Agente',
  'catalog.properties.import.filter.column.oficina': 'Oficina',
  'catalog.properties.import.filter.column.type1': 'Tipo 1',
  'catalog.properties.import.filter.column.status': 'Status',
  'catalog.properties.import.filter.column.region': 'Region',
  'catalog.properties.import.filter.matchType.equals': 'Equals',
  'catalog.properties.import.filter.matchType.contains': 'Contains',
  'catalog.properties.import.filter.matchType.startsWith': 'Starts with',
  'catalog.properties.import.syncMissingPolicy.label':
    'If a property stops arriving',
  'catalog.properties.import.syncMissingPolicy.help':
    'Choose whether to keep it or disable it when it stops arriving from the import.',
  'catalog.properties.import.syncMissingPolicy.option.upsert': 'Keep it',
  'catalog.properties.import.syncMissingPolicy.option.replace': 'Disable it',
  'catalog.properties.import.kutt.filter.column.comuna': 'Comuna',
  'catalog.properties.import.kutt.filter.column.region': 'Region',
  'catalog.properties.import.kutt.filter.column.propertyType': 'Property type',
  'catalog.properties.import.kutt.filter.column.operation': 'Operation',
  'catalog.properties.import.kutt.filter.column.status': 'Status',
  'catalog.properties.import.ilist.filter.column.agent': 'Agent',
  'catalog.properties.import.ilist.filter.column.locality': 'Comuna',
  'catalog.properties.import.ilist.filter.column.province': 'Province',
  'catalog.properties.import.ilist.filter.column.propertyType': 'Property type',
  'catalog.properties.import.ilist.filter.column.status': 'Capture status',
  'catalog.properties.import.globalbrokers.filter.column.locality': 'Comuna',
  'catalog.properties.import.globalbrokers.filter.column.status':
    'Publication status',
  'catalog.properties.import.globalbrokers.filter.column.propertyType':
    'Property type',
  'catalog.properties.import.globalbrokers.filter.column.operation':
    'Operation',
  'catalog.properties.import.globalbrokers.filter.column.currency': 'Currency',
  'catalog.properties.import.assignment.label': 'Assignment',
  'catalog.properties.import.assignment.mode.keep': "Don't assign",
  'catalog.properties.import.assignment.mode.forceUser':
    'Assign all to user...',
  'catalog.properties.import.assignment.mode.auto': 'Auto-assign',
  'catalog.properties.import.assignment.userPlaceholder': 'Select a user',
  'catalog.properties.import.assignment.userEmpty': 'No users found',
  'catalog.properties.import.assignment.alert.userRequired':
    'Please select a user to assign properties to.',
  'catalog.properties.import.assignment.help.keep':
    "Doesn't assign or change the current assignee for imported properties.",
  'catalog.properties.import.assignment.help.forceUser':
    'Assigns all imported properties to the selected user (overwrites current assignment).',
  'catalog.properties.import.assignment.help.auto':
    'Uses the "Agente" column to match users by name. The name must be the same as the user\'s name in the platform (overwrites current assignment).',
  'catalog.properties.confirmDeactivate.title': 'Deactivate property',
  'catalog.properties.confirmDeactivate.confirm': 'Deactivate',
  'catalog.properties.confirmDeactivate.cancel': 'Cancel',
  'catalog.properties.confirmDeactivate.fallbackName': 'this property',
  'catalog.properties.confirmDeactivate.messagePrefix':
    'Are you sure you want to deactivate',
  'catalog.properties.confirmDeactivate.messageSuffix':
    '? The property will stop being active in Comos.',
  'catalog.properties.confirmDeactivate.publicationImpact':
    'If this property has linked active publications, they will also be unpublished in their respective portals.',
  'catalog.properties.import.button': 'Import',
  'catalog.properties.form.edit': 'Edit property',
  'catalog.properties.form.create': 'Create new property',
  'catalog.properties.form.namePlaceholder': 'Property name',
  'catalog.properties.form.descriptionPlaceholder': 'Describe the property',
  'catalog.properties.form.latitude': 'Latitude',
  'catalog.properties.form.longitude': 'Longitude',
  'catalog.properties.editor.unsavedChanges': 'Unsaved changes',
  'catalog.properties.location.edit': 'Edit location',
  'catalog.properties.location.add': 'Add location',
  'catalog.properties.location.apply': 'Apply location',
  'catalog.properties.location.saveWithProperty':
    'This location will be saved when you save the property.',
  'catalog.properties.location.noAddress': 'No address yet',
  'catalog.properties.location.adjustMap': 'Adjust on map',
  'catalog.properties.location.unitSummary': 'Apt.',
  'catalog.properties.location.mapStripSetHelp': 'Location set',
  'shared.location.map.thumbnailAlt': 'Property location on Google Maps',
  'shared.location.map.thumbnailUnavailable': 'Preview unavailable',
  'catalog.properties.location.mapStripHelp':
    'Set the exact location of the property.',
  'catalog.properties.location.placeOnMap': 'Locate on map',
  'catalog.properties.location.allCountries': 'All countries',
  'catalog.properties.location.searchCountry': 'Country',
  'catalog.properties.location.country': 'Property country',
  'catalog.properties.location.countryPlaceholder': 'Select country',
  'catalog.properties.location.changeCountry': 'Change',
  'catalog.properties.location.done': 'Done',
  'catalog.properties.location.countryHelp':
    'Filled from the selected address. Changing country clears the address details and map point.',
  'catalog.properties.location.region': 'Region / state',
  'catalog.properties.location.locality': 'City / locality',
  'catalog.properties.location.map.reverseError':
    'The address could not be found for this point. Check the country and enter the address details manually.',
  'shared.location.autocomplete.searchError':
    'Address search is unavailable. Try again or enter the details manually.',
  'shared.location.autocomplete.resolveError':
    'The address details could not be loaded. Try again or enter them manually.',
  'catalog.properties.location.preview.title': 'Map preview',
  'catalog.properties.location.preview.open': 'Open in Google Maps',
  'catalog.properties.location.preview.empty':
    'Add an address or coordinates to preview the property location.',
  'catalog.properties.location.preview.emptyAddress':
    'The map uses the address and coordinates you enter here.',
  'catalog.properties.location.preview.help':
    'Use the full address when possible. Coordinates help fine-tune the final map position.',
  'catalog.properties.location.autocomplete.title':
    'Find the address on the map',
  'catalog.properties.location.autocomplete.description':
    'Search an address in any country, then adjust the map point or enter the details manually.',
  'catalog.properties.location.autocomplete.placeholder':
    'Search street, building, neighborhood, or city',
  'catalog.properties.location.regionPlaceholder':
    'Enter or select a region / state',
  'catalog.properties.location.localityPlaceholder':
    'Enter or select a city / locality',
  'catalog.properties.location.neighborhoodPlaceholder':
    'Neighborhood or sector',
  'catalog.properties.location.addressPlaceholder':
    'Public address shown externally',
  'catalog.properties.location.streetNamePlaceholder': 'Street',
  'catalog.properties.location.streetNumberPlaceholder': '123',
  'catalog.properties.location.unitPlaceholder': 'Apt. 101',
  'catalog.properties.location.map.help':
    'Click on the map or drag the marker to adjust the final location.',
  'catalog.properties.location.map.empty':
    'Search an address or click on the map to define the location.',
  'catalog.properties.location.map.reverseLoading':
    'Updating the address from the selected point…',
  'shared.location.autocomplete.help':
    'Type at least 3 characters to search exact addresses.',
  'shared.location.autocomplete.loading': 'Searching addresses…',
  'shared.loading': 'Loading…',
  'shared.location.autocomplete.empty': 'No addresses found.',
  'shared.location.autocomplete.configurationMissing':
    'Google Maps is not configured yet.',
  'shared.location.map.configurationMissing':
    'Google Maps is not configured yet. Add VITE_GOOGLE_MAPS_API_KEY to enable the interactive map.',
  'shared.location.map.loadError': 'Unable to load Google Maps.',
  'shared.location.map.markerTitle': 'Property location marker',
  'catalog.properties.editor.createTitle': 'Create property',
  'catalog.properties.editor.editTitle': 'Edit property',
  'catalog.properties.editor.createSubtitle':
    'Start with the core information and continue with publishing once the property is saved.',
  'catalog.properties.editor.editSubtitle':
    'Keep the property data and publication readiness in one place.',
  'catalog.properties.editor.backToList': 'Back to properties',
  'catalog.properties.editor.save': 'Save',
  'catalog.properties.editor.create': 'Create',
  'catalog.properties.editor.sections.overview': 'Overview',
  'catalog.properties.editor.sections.overviewDescription':
    'Define the main listing information buyers and portals will see first.',
  'catalog.properties.editor.sections.pricing': 'Pricing',
  'catalog.properties.editor.sections.pricingDescription':
    'Set the sale and rent amounts that will feed portal publications.',
  'catalog.properties.editor.sections.location': 'Location',
  'catalog.properties.editor.sections.locationDescription':
    'Complete the public address and coordinates used for publishing and search.',
  'catalog.properties.editor.sections.media': 'Media',
  'catalog.properties.editor.sections.mediaDescription':
    'Manage the images and other files sent to portals.',
  'catalog.properties.editor.sections.publishing': 'Publishing',
  'catalog.properties.editor.sections.publishingDescription':
    'Configure portal-specific publication inputs and status.',
  'catalog.properties.editor.sections.characteristics':
    'Areas and characteristics',
  'catalog.properties.editor.sections.characteristicsDescription':
    'Capture the structural data used across imports, search, and publishing.',
  'catalog.properties.editor.sections.mainInformation': 'Main information',
  'catalog.properties.editor.sections.mainInformationDescription':
    'Complete the layout, building details, and surfaces that describe the unit.',
  'catalog.properties.editor.sections.features': 'Features',
  'catalog.properties.editor.sections.featuresDescription':
    'Mark the amenities, equipment, and special conditions associated with this property.',
  'catalog.properties.editor.sections.metadata': 'Source metadata',
  'catalog.properties.editor.sections.metadataDescription':
    'Keep source references and import traceability for this property.',
  'catalog.properties.editor.placeholders.name': 'Property name',
  'catalog.properties.editor.placeholders.description':
    'Describe the property and its main selling points.',
  'catalog.properties.editor.loadErrorTitle': 'Unable to load the property',
  'catalog.properties.editor.loadErrorDescription':
    'Review the property identifier or go back to the list and try again.',
  'catalog.properties.editor.publishing.title': 'Publishing',
  'catalog.properties.editor.publishing.description':
    'Review and manage the publications linked to this property.',
  'catalog.properties.editor.publishing.operationsTitle':
    'Publication by operation',
  'catalog.properties.editor.publishing.operationsDescription':
    'Review each operation status and manage its publication details.',
  'catalog.properties.editor.publishing.syncCardTitle': 'Sync',
  'catalog.properties.editor.publishing.syncTimeline.title': 'Activity',
  'catalog.properties.editor.publishing.syncTimeline.empty':
    'There are no sync events for this property yet.',
  'catalog.properties.editor.publishing.syncTimeline.syncApplied':
    'Data updated',
  'catalog.properties.editor.publishing.syncTimeline.syncSkipped':
    'No new updates',
  'catalog.properties.editor.publishing.syncTimeline.syncFailed':
    'Update failed',
  'catalog.properties.editor.publishing.publicationIdentifier':
    'Publication {value}',
  'catalog.properties.editor.publishing.publicationGeneric': 'Publication',
  'catalog.properties.editor.publishing.saveFirstTitle':
    'Save the property first',
  'catalog.properties.editor.publishing.saveFirstDescription':
    'The publishing section becomes available once the property exists in Comos.',
  'catalog.properties.editor.publishing.connectTitle':
    'Connect Mercado Libre first',
  'catalog.properties.editor.publishing.connectDescription':
    'Go to Integrations and connect Mercado Libre before managing publications.',
  'catalog.properties.editor.publishing.unsupportedTitle':
    'Unsupported operation',
  'catalog.properties.editor.publishing.unsupportedDescription':
    'This property operation is not publishable in Mercado Libre yet.',
  'catalog.properties.editor.publishing.syncModeTitle': 'Sync mode is active',
  'catalog.properties.editor.publishing.syncModeDescription':
    'Sync mode is active. Publishing actions from Comos are disabled.',
  'catalog.properties.editor.publishing.sourceOfTruthTitle': 'Source of truth',
  'catalog.properties.editor.publishing.sourceOfTruthSyncDescription':
    'This property is managed by an integration. Changes in Comos can be replaced in the next update.',
  'catalog.properties.editor.publishing.sourceOfTruthPublishDescription':
    'This property originated from Mercado Libre. Review publishing changes carefully to avoid overwriting the synced source unexpectedly.',
  'catalog.properties.editor.publishing.syncOwnership.modeSync': 'SYNC',
  'catalog.properties.editor.publishing.syncOwnership.modePublish': 'PUBLISH',
  'catalog.properties.editor.publishing.syncOwnership.sourceSystem':
    'Source system',
  'catalog.properties.editor.publishing.syncOwnership.sourceId': 'Source ID',
  'catalog.properties.editor.publishing.syncOwnership.sourceCode':
    'Source code',
  'catalog.properties.editor.publishing.syncOwnership.linkedPublicationsLabel':
    'Linked publications',
  'catalog.properties.editor.publishing.syncOwnership.linkedPublications':
    '{count} linked publications',
  'catalog.properties.editor.publishing.syncOwnership.assignmentTitle':
    'Agent assignment',
  'catalog.properties.editor.publishing.syncOwnership.assignmentResolved':
    'Assigned in Comos',
  'catalog.properties.editor.publishing.syncOwnership.assignmentResolvedDescription':
    'A Comos user was matched from the seller contact shared by Mercado Libre.',
  'catalog.properties.editor.publishing.syncOwnership.assignmentResolvedBySourceDescription':
    'Assigned automatically in Comos using the Mercado Libre seller {value}.',
  'catalog.properties.editor.publishing.syncOwnership.assignmentPending':
    'Pending manual review',
  'catalog.properties.editor.publishing.syncOwnership.assignmentPendingDescription':
    'Comos could not resolve an assigned user from the seller contact yet.',
  'catalog.properties.editor.publishing.syncOwnership.assignmentAmbiguous':
    'Multiple possible assignees',
  'catalog.properties.editor.publishing.syncOwnership.assignmentAmbiguousDescription':
    'Mercado Libre seller contact matches more than one Comos user and needs manual review.',
  'catalog.properties.editor.publishing.syncOwnership.assignmentSource.email':
    'email',
  'catalog.properties.editor.publishing.syncOwnership.assignmentSource.phone':
    'phone',
  'catalog.properties.editor.publishing.syncOwnership.fieldsTitle':
    'Managed fields',
  'catalog.properties.editor.publishing.syncOwnership.consequencesTitle':
    'What happens in this mode',
  'catalog.properties.editor.publishing.syncOwnership.field.title': 'Title',
  'catalog.properties.editor.publishing.syncOwnership.field.description':
    'Description',
  'catalog.properties.editor.publishing.syncOwnership.field.location':
    'Location',
  'catalog.properties.editor.publishing.syncOwnership.field.media': 'Media',
  'catalog.properties.editor.publishing.syncOwnership.field.status': 'Status',
  'catalog.properties.editor.publishing.syncOwnership.field.assignee':
    'Assignee',
  'catalog.properties.editor.publishing.syncOwnership.consequence.overwrite':
    'The next Mercado Libre sync can overwrite these fields in Comos.',
  'catalog.properties.editor.publishing.syncOwnership.consequence.publishLocked':
    'Publishing actions stay locked while this integration runs in sync mode.',
  'catalog.properties.editor.publishing.syncOwnership.consequence.publishSource':
    'Comos is the current source of truth for publication changes.',
  'catalog.properties.editor.publishing.syncOwnership.consequence.ignoreUnlinked':
    'Unlinked Mercado Libre items are ignored while the integration stays in publish mode.',
  'catalog.properties.editor.publishing.syncManagedPublicationHint':
    'This publication is managed by sync and can be overwritten by the next provider update.',
  'catalog.properties.editor.publishing.viewDetails': 'View details',
  'catalog.properties.editor.publishing.selected': 'Selected',
  'catalog.properties.editor.publishing.actions.viewTooltip':
    'Review this publication',
  'catalog.properties.editor.publishing.actions.selectedTooltip':
    'Currently selected publication',
  'catalog.properties.editor.publishing.actions.manage': 'Manage publication',
  'catalog.properties.editor.publishing.actions.manageTooltip':
    'Open the Mercado Libre publication settings',
  'catalog.properties.editor.publishing.actions.manageDescription':
    'manage this publication from Comos',
  'catalog.properties.editor.publishing.actions.openExternal':
    'Open publication',
  'catalog.properties.editor.publishing.actions.openExternalTooltip':
    'Open the public listing in the portal',
  'catalog.properties.editor.publishing.actions.openInMenuCaption': 'Open in…',
  'catalog.properties.editor.publishing.actions.openInProvider':
    'View on {provider}',
  'catalog.properties.editor.publishing.actions.repairSync': 'Sync now',
  'catalog.properties.editor.publishing.actions.publish': 'Publish',
  'catalog.properties.editor.publishing.actions.publishDescription':
    'publish or update this publication from Comos',
  'catalog.properties.editor.publishing.actions.publishTooltip':
    'Publish or update this publication on Mercado Libre',
  'catalog.properties.editor.publishing.actions.publishInactiveTooltip':
    'Activate the property in Comos before publishing or updating it on Mercado Libre.',
  'catalog.properties.editor.publishing.actions.publishIssuesTooltip':
    '{firstIssue}\n\nThere are {count} validation issues.\nReview the full details in the manage publication modal.',
  'catalog.properties.editor.publishing.actions.publishIssuesCount':
    'There are {count} validation issues.',
  'catalog.properties.editor.publishing.actions.publishIssuesDetailsHint':
    'Review the full details in the manage publication modal.',
  'catalog.properties.meli.actions.validating': 'Validating publication…',
  'catalog.properties.editor.publishing.actions.history': 'View activity',
  'catalog.properties.editor.publishing.actions.historyTooltip':
    'Open publication activity',
  'catalog.properties.editor.publishing.history.showOlderPublications':
    'View {count} previous publications',
  'catalog.properties.editor.publishing.history.hideOlderPublications':
    'Hide {count} previous publications',
  'catalog.properties.editor.publishing.actions.unpublish': 'Unpublish',
  'catalog.properties.editor.publishing.actions.unpublishDescription':
    'unpublish this publication from Comos',
  'catalog.properties.editor.publishing.actions.unpublishTooltip':
    'Remove this publication from Mercado Libre',
  'catalog.properties.editor.publishing.actions.integrationMissingTooltip':
    'Connect {provider} to {action}.',
  'catalog.properties.editor.publishing.actions.integrationDisconnectedTooltip':
    '{provider} is disconnected. Reconnect it to {action}.',
  'catalog.properties.editor.publishing.summary.pendingPublish':
    'Publishing this operation',
  'catalog.properties.editor.publishing.summary.updatedAt': 'Updated {value}',
  'catalog.properties.editor.publishing.summary.syncAssignmentAmbiguous':
    'Mercado Libre sync needs assignment review.',
  'catalog.properties.editor.publishing.summary.syncAssignmentPending':
    'Mercado Libre sync still has no assignee match.',
  'catalog.properties.editor.publishing.summary.syncAssignmentResolved':
    'Synced · assigned by {value}.',
  'catalog.properties.editor.publishing.summary.syncAssignmentResolvedGeneric':
    'Synced · assigned automatically.',
  'catalog.properties.editor.publishing.summary.publishSource':
    'Comos controls this publication from the editor.',
  'catalog.properties.editor.publishing.summary.referenceOnly':
    'Listed in {provider}. Not connected or managed from Comos.',
  'catalog.properties.editor.publishing.summary.referenceOnlyWithSource':
    'Imported from {source}. Not connected or managed from Comos.',
  'catalog.properties.editor.publishing.summary.paymentRequired':
    'Published, but Mercado Libre still requires payment.',
  'catalog.properties.publicationAlerts.billingBlocked.title':
    'Mercado Libre billing suspension',
  'catalog.properties.publicationAlerts.billingBlocked.summary':
    'Listing paused because of an outstanding balance',
  'catalog.properties.publicationAlerts.billingBlocked.description':
    'Resolve the outstanding balance in Mercado Libre. This pause does not change property availability in Comos.',
  'catalog.properties.publicationAlerts.billingPauseContinued.title':
    'Listing still paused in Mercado Libre',
  'catalog.properties.publicationAlerts.billingPauseContinued.summary':
    'Listing remains paused after the billing restriction cleared',
  'catalog.properties.publicationAlerts.billingPauseContinued.description':
    'Review the listing in Mercado Libre. This pause does not change property availability; use the existing property controls if its availability has changed.',
  'catalog.properties.publicationAlerts.paymentRequired.title':
    'Payment pending in the portal',
  'catalog.properties.publicationAlerts.paymentRequired.summary':
    'Mercado Libre still requires a payment step.',
  'catalog.properties.publicationAlerts.paymentRequired.description':
    'The publication was created, but the portal still requires completing the payment or activating the matching plan.',
  'catalog.properties.publicationAlerts.underReview.title':
    'Review pending in the portal',
  'catalog.properties.publicationAlerts.underReview.summary':
    'Mercado Libre temporarily inactivated this listing during review.',
  'catalog.properties.publicationAlerts.underReview.description':
    'Review the publication directly in Mercado Libre to understand the restriction and resolve it there.',
  'catalog.properties.editor.publishing.notPublishedDescription':
    'This operation is not published yet.',
  'catalog.properties.editor.publishing.status.referenceOnly':
    'External reference',
  'catalog.properties.editor.publishing.operationUnknown':
    'Operation not defined',
  'catalog.properties.editor.publishing.activity.externalId': 'ID {value}',
  'catalog.properties.editor.publishing.activity.synced': 'Synced',
  'catalog.properties.editor.publishing.activity.attempted': 'Attempted',
  'catalog.properties.editor.publishing.activity.updated': 'Updated',
  'catalog.properties.editor.publishing.activity.nextSync': 'Next sync',
  'catalog.properties.editor.publishing.syncedAt': 'Last sync: {value}',
  'catalog.properties.editor.publishing.target.meli': 'Mercado Libre',
  'catalog.properties.editor.publishing.target.meliPoi':
    'Mercado Libre + PortalInmobiliario',
  'catalog.properties.editor.confirmRepublish.title':
    'Update active publications',
  'catalog.properties.editor.confirmRepublish.description':
    'Saving these changes will update the active publications linked to this property in their respective portals.',
  'catalog.properties.editor.confirmRepublish.confirm': 'Save and update',
  'catalog.properties.editor.confirmRepublish.cancel': 'Cancel',
  'catalog.properties.editor.confirmDeactivate.title': 'Deactivate property',
  'catalog.properties.editor.confirmDeactivate.description':
    'Saving these changes will deactivate this property in Comos.',
  'catalog.properties.editor.confirmDeactivate.confirm': 'Save and deactivate',
  'catalog.properties.editor.confirmDeactivate.cancel': 'Cancel',
  'catalog.properties.table.actions.view': 'View',
  'catalog.properties.table.actions.edit': 'Edit',
  'catalog.properties.table.actions.deactivate': 'Deactivate',
  'catalog.properties.alert.create.success': 'Property created successfully',
  'catalog.properties.alert.create.error': 'Failed to create property',
  'catalog.properties.alert.update.success': 'Property updated successfully',
  'catalog.properties.alert.update.error': 'Failed to update property',
  'catalog.properties.alert.deactivate.success':
    'Property deactivated successfully',
  'catalog.properties.alert.deactivate.error': 'Failed to deactivate property',
  'catalog.properties.permissions.readRequiredTitle':
    'You do not have permission to view properties.',
  'catalog.properties.permissions.readRequiredDescription':
    'You need catalog read permissions to access this view.',
  'catalog.properties.publications.permissions.readRequiredTitle':
    'You do not have permission to view publications.',
  'catalog.properties.publications.permissions.readRequiredDescription':
    'You need integrations read permissions to review portal publications.',
  'catalog.properties.meli.modal.title': 'Mercado Libre publication',
  'catalog.properties.meli.modal.description':
    'Validate and manage this property publication in Mercado Libre.',
  'catalog.properties.meli.unsupportedOperation':
    'This property does not have a supported operation for Mercado Libre publishing.',
  'catalog.properties.meli.form.operation': 'Operation',
  'catalog.properties.meli.form.portalTarget': 'Portal',
  'catalog.properties.meli.form.selectedOperation': 'Selected operation',
  'catalog.properties.meli.form.listingType': 'Listing type',
  'catalog.properties.meli.form.listingType.default':
    'Use Mercado Libre default',
  'catalog.properties.meli.listingTypes.free': 'Free',
  'catalog.properties.meli.listingTypes.goldPremium': 'Gold Premium',
  'catalog.properties.meli.listingTypes.gold': 'Gold',
  'catalog.properties.meli.listingTypes.silver': 'Silver',
  'catalog.properties.meli.category.helpTitle':
    'The category is resolved automatically',
  'catalog.properties.meli.category.helpDescription':
    'Comos selects the Mercado Libre category from the property type and operation. You only need to complete the structured property data.',
  'catalog.properties.meli.category.resolvedLabel': 'Resolved category',
  'catalog.properties.meli.category.inlineDescription':
    'Comos calculates this category from the property type, operation, and structured fields.',
  'catalog.properties.meli.category.autoResolved':
    'Selected automatically from the property data.',
  'catalog.properties.meli.category.unavailable':
    'Complete the structured property data to resolve the category automatically.',
  'catalog.properties.meli.portalTarget.meli': 'Mercado Libre',
  'catalog.properties.meli.portalTarget.meliPoi':
    'Mercado Libre + Portal Inmobiliario',
  'catalog.properties.meli.images.title': 'Images',
  'catalog.properties.meli.images.description':
    'Select which property images will be used in this publication.',
  'catalog.properties.meli.images.empty':
    'Add property images in the media section before publishing.',
  'catalog.properties.meli.images.selectionHint':
    'If you do not select a subset, all property images will be used.',
  'catalog.properties.meli.validation.field.sellerContact': 'Seller contact',
  'catalog.properties.meli.validation.field.isSuitableForPets':
    'Suitable for pets',
  'catalog.properties.meli.validation.issue.missing_title':
    'Property title is required to publish to Mercado Libre.',
  'catalog.properties.meli.validation.issue.missing_description':
    'Property description is required to publish to Mercado Libre.',
  'catalog.properties.meli.validation.issue.missing_property_type':
    'Property type is required to publish to Mercado Libre.',
  'catalog.properties.meli.validation.issue.missing_condition':
    'Property condition is required to publish to Mercado Libre.',
  'catalog.properties.meli.validation.issue.missing_operation':
    'Property operation is required to publish to Mercado Libre.',
  'catalog.properties.meli.validation.issue.missing_sale_price':
    'A valid sale price is required to publish to Mercado Libre.',
  'catalog.properties.meli.validation.issue.missing_rent_price':
    'A valid rent price is required to publish to Mercado Libre.',
  'catalog.properties.meli.validation.issue.missing_sale_currency':
    'A valid sale currency is required to publish to Mercado Libre.',
  'catalog.properties.meli.validation.issue.missing_rent_currency':
    'A valid rent currency is required to publish to Mercado Libre.',
  'catalog.properties.meli.validation.issue.missing_address_line':
    'A public address is required to publish to Mercado Libre.',
  'catalog.properties.meli.validation.issue.missing_location_node':
    'A Mercado Libre classified location is required. Complete neighborhood or locality.',
  'catalog.properties.meli.validation.issue.missing_latitude':
    'Latitude is required to publish to Mercado Libre.',
  'catalog.properties.meli.validation.issue.missing_longitude':
    'Longitude is required to publish to Mercado Libre.',
  'catalog.properties.meli.validation.issue.missing_seller_contact':
    'A seller contact is required to publish to Mercado Libre.',
  'catalog.properties.meli.validation.issue.missing_pictures':
    'Add at least one image before publishing to Mercado Libre.',
  'catalog.properties.meli.validation.issue.resolved_location_required':
    'A valid location is required before publishing to Mercado Libre.',
  'catalog.properties.meli.validation.issue.required_area_total':
    'Total surface is required by Mercado Libre for the resolved category.',
  'catalog.properties.meli.validation.issue.required_area_usable':
    'Usable surface is required by Mercado Libre for the resolved category.',
  'catalog.properties.meli.validation.issue.required_bedrooms':
    'Bedrooms are required by Mercado Libre for the resolved category.',
  'catalog.properties.meli.validation.issue.required_bathrooms':
    'Bathrooms are required by Mercado Libre for the resolved category.',
  'catalog.properties.meli.validation.issue.required_parking_lots':
    'Parking lots are required by Mercado Libre for the resolved category. If the property has none, enter 0.',
  'catalog.properties.meli.validation.issue.inactive_property':
    'Activate this property in Comos before publishing or updating it on Mercado Libre.',
  'catalog.properties.meli.validation.issue.missing_category_required_attribute':
    'Complete {field}. Mercado Libre requires it for this property category.',
  'catalog.properties.meli.validation.issue.unsupported_external_media':
    'Use a valid YouTube video URL or Matterport share URL.',
  'catalog.properties.meli.currentPublication.syncManaged':
    'Linked to {provider}',
  'catalog.properties.meli.currentPublication.syncManagedDescription':
    'Changes detected in the source listing may sync into Comos and update this property.',
  'catalog.properties.meli.currentPublication.syncManagedSyncModeDescription':
    'You can review this publication from Comos, but {provider} controls the changes.',
  'catalog.properties.meli.currentPublication.syncManagedPublishModeDescription':
    'This publication originated in {provider} and can be synced back over changes made in Comos.',
  'catalog.properties.meli.currentPublication.paymentRequiredBadge':
    'Payment pending',
  'catalog.properties.meli.currentPublication.paymentRequiredDescription':
    'Mercado Libre created the listing, but the portal still requires a payment step before it becomes fully active.',
  'catalog.properties.meli.currentPublication.openExternal':
    'Open publication in Mercado Libre',
  'catalog.properties.meli.currentPublication.pendingPublish':
    'This publication is being sent to Mercado Libre.',
  'catalog.properties.meli.currentPublication.history.modalTitle':
    '{operation} publication activity',
  'catalog.properties.meli.currentPublication.history.modalDescription':
    'Review the complete activity trail for this operation in Mercado Libre.',
  'catalog.properties.meli.currentPublication.history.title': 'Activity',
  'catalog.properties.meli.currentPublication.history.empty':
    'There are no events for this publication yet.',
  'catalog.properties.meli.currentPublication.history.created': 'Created',
  'catalog.properties.meli.currentPublication.history.draft_prepared':
    'Draft prepared',
  'catalog.properties.meli.currentPublication.history.publish_enqueued':
    'Publish requested',
  'catalog.properties.meli.currentPublication.history.published': 'Published',
  'catalog.properties.meli.currentPublication.history.publish_failed':
    'Publish failed',
  'catalog.properties.meli.currentPublication.history.pause_enqueued':
    'Pause requested',
  'catalog.properties.meli.currentPublication.history.paused': 'Paused',
  'catalog.properties.meli.currentPublication.history.pause_failed':
    'Pause failed',
  'catalog.properties.meli.currentPublication.history.unpublish_enqueued':
    'Unpublish requested',
  'catalog.properties.meli.currentPublication.history.unpublished':
    'Unpublished',
  'catalog.properties.meli.currentPublication.history.unpublish_failed':
    'Unpublish failed',
  'catalog.properties.meli.currentPublication.history.sync_applied':
    'Data updated',
  'catalog.properties.meli.currentPublication.history.sync_skipped':
    'No new updates',
  'catalog.properties.meli.currentPublication.history.sync_failed':
    'Update failed',
  'catalog.properties.meli.currentPublication.history.attempted':
    'Last attempt',
  'catalog.properties.meli.currentPublication.history.synced': 'Last sync',
  'catalog.properties.meli.currentPublication.history.updated': 'Last update',
  'catalog.properties.meli.currentPublication.history.nextSync': 'Next sync',
  'catalog.properties.meli.currentPublication.history.error': 'Last error',
  'catalog.properties.publicationProblems.missingRemoteListing':
    'The listing is no longer present in the remote seller inventory.',
  'catalog.properties.meli.currentPublication.history.filter.all': 'All',
  'catalog.properties.meli.currentPublication.history.filter.lifecycle':
    'Publishing',
  'catalog.properties.meli.currentPublication.history.filter.sync': 'Sync',
  'catalog.properties.meli.currentPublication.history.details.itemId': 'Item',
  'catalog.properties.meli.currentPublication.history.details.action': 'Action',
  'catalog.properties.meli.currentPublication.history.details.code': 'Code',
  'catalog.properties.meli.currentPublication.history.details.portalTarget':
    'Target',
  'catalog.properties.meli.currentPublication.history.details.listingTypeId':
    'Plan',
  'catalog.properties.meli.currentPublication.history.details.categoryId':
    'Category',
  'catalog.properties.meli.currentPublication.history.details.status': 'Status',
  'catalog.properties.meli.currentPublication.history.details.paymentRequired':
    'Payment required',
  'catalog.properties.meli.currentPublication.history.details.reason': 'Reason',
  'catalog.properties.meli.currentPublication.history.details.remoteStatus':
    'Provider status',
  'catalog.properties.meli.currentPublication.history.details.propertyAction':
    'Property',
  'catalog.properties.meli.currentPublication.history.details.publicationAction':
    'Publication',
  'catalog.properties.meli.currentPublication.history.details.assigneeSource':
    'Assignee matched by',
  'catalog.properties.meli.currentPublication.history.details.assigneeResolution':
    'Assignment resolution',
  'catalog.properties.meli.currentPublication.history.value.assigneeSource.email':
    'Email',
  'catalog.properties.meli.currentPublication.history.value.assigneeSource.phone':
    'Phone',
  'catalog.properties.meli.currentPublication.history.value.assigneeSource.none':
    'No match',
  'catalog.properties.meli.currentPublication.history.value.assigneeResolution.resolved':
    'Resolved automatically',
  'catalog.properties.meli.currentPublication.history.value.assigneeResolution.ambiguous':
    'Manual review needed',
  'catalog.properties.meli.currentPublication.history.value.assigneeResolution.notFound':
    'No match',
  'catalog.properties.meli.currentPublication.history.value.paymentRequired.yes':
    'Yes',
  'catalog.properties.meli.currentPublication.history.value.paymentRequired.no':
    'No',
  'catalog.properties.meli.currentPublication.history.value.propertyAction.created':
    'Created',
  'catalog.properties.meli.currentPublication.history.value.propertyAction.updated':
    'Updated',
  'catalog.properties.meli.currentPublication.history.value.publicationAction.created':
    'Created',
  'catalog.properties.meli.currentPublication.history.value.publicationAction.updated':
    'Updated',
  'integrations.activity.type.connection_connected': 'Integration connected',
  'integrations.activity.type.connection_updated': 'Configuration updated',
  'integrations.activity.type.connection_disconnected':
    'Integration disconnected',
  'integrations.activity.type.sync_requested': 'Sync requested',
  'integrations.activity.type.sync_started': 'Sync started',
  'integrations.activity.type.sync_applied': 'Data synchronized',
  'integrations.activity.type.sync_skipped': 'No changes to apply',
  'integrations.activity.type.sync_failed': 'Sync failed',
  'integrations.activity.type.sync_completed': 'Sync completed',
  'integrations.activity.type.sync_superseded': 'Sync superseded',
  'integrations.activity.type.sync_reconciliation_applied':
    'Publication reconciled',
  'integrations.activity.type.publication_created': 'Publication created',
  'integrations.activity.type.publication_draft_prepared': 'Draft prepared',
  'integrations.activity.type.publication_publish_enqueued': 'Publish queued',
  'integrations.activity.type.publication_published': 'Publication published',
  'integrations.activity.type.publication_publish_failed': 'Publish failed',
  'integrations.activity.type.publication_pause_enqueued': 'Pause queued',
  'integrations.activity.type.publication_paused': 'Publication paused',
  'integrations.activity.type.publication_pause_failed': 'Pause failed',
  'integrations.activity.type.publication_unpublish_enqueued':
    'Unpublish queued',
  'integrations.activity.type.publication_unpublished':
    'Publication unpublished',
  'integrations.activity.type.publication_unpublish_failed': 'Unpublish failed',
  'integrations.activity.details.providerSubject': 'Source account',
  'integrations.activity.details.processedCount': 'Processed items',
  'integrations.activity.details.failedCount': 'Failed items',
  'integrations.activity.details.limit': 'Page size',
  'integrations.activity.details.previousStatus': 'Previous status',
  'integrations.activity.details.healthStatus': 'Health',
  'integrations.activity.details.previousHealthStatus': 'Previous health',
  'integrations.activity.details.sourceEventType': 'Source',
  'integrations.activity.details.staleReason': 'Reason',
  'integrations.activity.details.cursor': 'Cursor',
  'integrations.activity.details.failedItemCount': 'Failed items',
  'integrations.activity.details.phase': 'Phase',
  'integrations.activity.details.mappingSyncRevision': 'Current revision',
  'integrations.activity.details.reconciliationTriggered':
    'Reconciliation executed',
  'integrations.activity.value.sourceEventType.backfill': 'Backfill',
  'integrations.activity.value.sourceEventType.notification': 'Notification',
  'integrations.activity.value.staleReason.mapping_not_found':
    'Connection mapping not found',
  'integrations.activity.value.staleReason.missing_event_sync_revision':
    'Missing sync revision in queued run',
  'integrations.activity.value.staleReason.mapping_missing_sync_revision':
    'Current connection has no sync revision',
  'integrations.activity.value.staleReason.stale_sync_revision':
    'Replaced by a newer sync',
  'catalog.properties.meli.status.draft': 'Draft',
  'catalog.properties.meli.status.queuedPublish': 'Publishing',
  'catalog.properties.meli.status.published': 'Published',
  'catalog.properties.meli.status.paused': 'Paused',
  'catalog.properties.meli.status.unpublished': 'Unpublished',
  'catalog.properties.meli.status.error': 'Error',
  'catalog.properties.meli.status.notPublished': 'Not published',
  'catalog.properties.meli.draft.title': 'Validation',
  'catalog.properties.meli.draft.issuesCount': '{count} issues',
  'catalog.properties.meli.draft.selectedListingType':
    'Selected plan: {listingTypeName}',
  'catalog.properties.meli.draft.noIssues':
    'This publication is ready to be sent to Mercado Libre.',
  'catalog.properties.meli.draft.empty':
    'Validation updates automatically when you change the publication data.',
  'catalog.properties.meli.actions.publish': 'Publish',
  'catalog.properties.meli.actions.pause': 'Pause',
  'catalog.properties.meli.actions.unpublish': 'Unpublish',
  'catalog.properties.meli.actions.close': 'Close',
  'catalog.properties.meli.alert.fixDraftIssues':
    'Fix the issues before publishing to Mercado Libre.',
  'catalog.properties.meli.alert.publishQueued':
    'The publication is now being processed and will update shortly.',
  'catalog.properties.meli.alert.pauseQueued':
    'The pause is now being processed and will update shortly.',
  'catalog.properties.meli.alert.unpublishQueued':
    'The unpublish request is now being processed and will update shortly.',
  'catalog.properties.editor.publishing.alert.repairSyncQueued':
    'The repair sync was queued and the source listings will be replayed shortly.',
  'catalog.properties.media.title': 'Property media',
  'catalog.properties.media.description':
    'Upload the files that represent this property. They will be reused in the property record and portal publications.',
  'catalog.properties.media.empty':
    'No files have been added to this property yet.',
  'catalog.properties.media.upload': 'Upload files',
  'catalog.properties.media.countSingular': '{count} file',
  'catalog.properties.media.countPlural': '{count} files',
  'catalog.properties.media.dropzone.title':
    'Drag files here or select them from your computer',
  'catalog.properties.media.dropzone.helper':
    'Drop the files to attach them to the property.',
  'catalog.properties.media.preview': 'Preview',
  'catalog.properties.media.select': 'Use',
  'catalog.properties.media.selected': 'Using',
  'catalog.properties.media.reorder': 'Drag to reorder',
  'catalog.properties.media.remove': 'Remove',
  'catalog.properties.form.sourceSystem': 'Source system',
  'catalog.properties.form.sourceSystemPlaceholder':
    'prop360, ilist, toppropiedades…',
  'catalog.properties.form.sourceId': 'Source ID',
  'catalog.properties.form.sourceIdPlaceholder': 'Stable external identifier',
  'catalog.properties.form.sourceCode': 'Source code',
  'catalog.properties.form.sourceCodePlaceholder':
    'Commercial code or external reference',
  'catalog.properties.form.mercadoLibreCode': 'Mercado Libre code',
  'catalog.properties.form.mercadoLibreCodePlaceholder':
    'Internal Mercado Libre reference',

  // Sidebar - Menu Groups
  'sidebar.crm': 'CRM',
  'sidebar.automation': 'Automation',
  'sidebar.analytics': 'Analytics',
  'sidebar.catalog': 'Catalog',
  'sidebar.settings': 'Settings',

  // Sidebar - CRM Menu Items
  'sidebar.communications': 'Communications',
  'sidebar.notifications': 'Notifications',
  'sidebar.agenda': 'Agenda',
  'sidebar.contacts': 'Contacts',
  'communications.pipeline.empty.title': 'No conversations',
  'communications.pipeline.empty.description':
    'Drag and drop conversations here',
  'communications.pipeline.empty.noFunnel':
    'Select a funnel to view conversations',
  'communications.pipeline.actions.collapseColumn': 'Collapse column',
  'communications.pipeline.actions.expandColumn': 'Expand column',
  'communications.pipeline.actions.columnMenu': 'Column actions',
  'communications.pipeline.actions.hideAiStatuses': 'Hide all AI statuses',
  'communications.pipeline.actions.showAiStatuses': 'Show all AI statuses',
  'communications.pipeline.actions.hideAllStatuses': 'Hide all statuses',
  'communications.pipeline.actions.showAllStatuses': 'Show all statuses',
  'communications.pipeline.actions.quickAutomation': 'Create quick automation',
  'communications.pipeline.actions.quickAutomationTitle': 'Quick automation',
  'communications.pipeline.actions.quickAutomationConfirm': 'Create automation',
  'automations.quickHandoff.fields.funnel': 'Current funnel',
  'automations.quickHandoff.fields.currentFunnelFallback': 'Selected funnel',
  'automations.quickHandoff.fields.destinationStatus':
    'Human assistance status',
  'automations.quickHandoff.fields.enabledStatuses': 'AI-managed statuses',
  'automations.quickHandoff.fields.aiAgent': 'AI Agent',
  'automations.quickHandoff.fields.excludedContent':
    'Text that must not trigger handoff',
  'automations.quickHandoff.placeholders.destinationStatus':
    'Select the destination status',
  'automations.quickHandoff.placeholders.enabledStatuses':
    'Select AI-managed statuses',
  'automations.quickHandoff.placeholders.aiAgent': 'Select the AI Agent',
  'automations.quickHandoff.placeholders.excludedContent':
    'Enter the text to exclude',
  'automations.quickHandoff.empty.statuses':
    'This funnel has no available statuses',
  'automations.quickHandoff.empty.aiAgents':
    'No AI Agents have an associated user',
  'automations.quickHandoff.hints.noSuggestedStatuses':
    'No AI statuses were found automatically. Select at least one.',
  'automations.quickHandoff.hints.excludedContent':
    'If an outgoing message contains this text, the conversation will not be handed off.',
  'automations.quickHandoff.errors.employeePermissionTitle':
    'You cannot read AI Agents',
  'automations.quickHandoff.errors.employeePermissionDescription':
    'AI Agent read permission is required to configure this template.',
  'automations.quickHandoff.errors.userPermissionTitle':
    'You cannot read Users',
  'automations.quickHandoff.errors.userPermissionDescription':
    'User read permission is required to show names and configure this template.',
  'automations.quickHandoff.errors.setupTitle':
    'The configuration could not be loaded',
  'automations.quickHandoff.errors.setupDescription':
    'Check your connection or permissions and try again.',
  'automations.quickHandoff.errors.templateTitle':
    'The template requires technical review',
  'automations.quickHandoff.errors.templateDescription':
    'The current definition no longer matches the expected handoff contract.',
  'automations.quickHandoff.errors.contextTitle':
    'The current funnel is missing',
  'automations.quickHandoff.errors.contextDescription':
    'Select a funnel in Communications before creating this automation.',
  'automations.quickHandoff.errors.invalidDefinition':
    'Invalid template definition: the workflow definition is missing.',
  'automations.quickHandoff.errors.missingTrigger':
    'Invalid template definition: the workflow trigger is missing.',
  'automations.quickHandoff.errors.workflowCreate':
    'The workflow could not be created. You can try again.',
  'automations.quickHandoff.errors.triggerCreate':
    'The workflow was created, but its trigger could not be activated.',
  'automations.quickHandoff.actions.retryLoad': 'Try again',
  'automations.quickHandoff.actions.retryActivation': 'Retry activation',
  'automations.quickHandoff.partial.title': 'Activation pending',
  'automations.quickHandoff.partial.description':
    'Workflow {workflowId} was already created. Retry to attach its trigger without creating another.',
  'automations.quickHandoff.closeWarning':
    'Workflow {workflowId} was created but does not have a trigger yet. Closing means it must be recovered manually. Close anyway?',
  'automations.quickHandoff.alerts.created':
    'Automation created. Workflow {workflowId}, version {version}, trigger {triggerId}.',
  'automations.quickAutomation.fields.activationStatus':
    'Status that activates the automation',
  'automations.quickAutomation.fields.assigneeUser': 'User to assign',
  'automations.quickAutomation.placeholders.activationStatus':
    'Select a funnel status',
  'automations.quickAutomation.placeholders.assigneeUser': 'Select a User',
  'automations.quickAutomation.empty.statuses':
    'This funnel has no available statuses',
  'automations.quickAutomation.empty.users':
    'There are no available human Users',
  'automations.quickAutomation.errors.templateDescription':
    'The current definition no longer matches the expected quick-automation contract.',

  // AI Agent operations
  'automations.aiAgents.index.title': 'AI Agents',
  'automations.aiAgents.index.description':
    'Configure your agents and review how they are carrying out their work.',
  'automations.aiAgents.index.create': 'New AI Agent',
  'automations.aiAgents.index.assistance': 'AI assistance center',
  'automations.aiAgents.index.executions': 'View executions',
  'automations.aiAgents.index.edit': 'Edit',
  'automations.aiAgents.index.unnamed': 'Unnamed AI Agent',
  'automations.aiAgents.index.noDescription': 'No description',
  'automations.aiAgents.index.emptyTitle': 'No AI Agents yet',
  'automations.aiAgents.index.emptyDescription':
    'Create an AI Agent to start automating work.',
  'automations.aiAgents.index.errorTitle': 'We could not load your AI Agents',
  'automations.aiAgents.index.errorDescription':
    'Check your connection and try again.',
  'automations.aiAgents.actions.retry': 'Try again',
  'automations.aiAgents.actions.copyId': 'Copy ID',
  'automations.aiAgents.actions.copied': 'ID copied',
  'automations.aiAgents.actions.loadMore': 'Load more',
  'automations.aiAgents.actions.clearDates': 'Clear dates',
  'automations.aiAgents.form.constraints.add': 'Add',
  'automations.aiAgents.form.constraints.placeholder': 'Add constraints...',
  'automations.aiAgents.form.constraints.empty':
    'No constraints have been added',
  'automations.aiAgents.form.constraints.sizeWarningTitle':
    'Many constraints may reduce message review coverage',
  'automations.aiAgents.form.constraints.sizeWarningDescriptionSingular':
    'This AI Agent has {constraintCount} constraint and {characterCount} characters. Its messages will still be sent, but they may skip preventive quality review when the context is too large. Move reference information to the knowledge base and flow-specific rules to the funnel instructions.',
  'automations.aiAgents.form.constraints.sizeWarningDescriptionPlural':
    'This AI Agent has {constraintCount} constraints and {characterCount} characters. Its messages will still be sent, but they may skip preventive quality review when the context is too large. Move reference information to the knowledge base and flow-specific rules to the funnel instructions.',
  'automations.aiAgents.assistance.title': 'AI assistance center',
  'automations.aiAgents.assistance.description':
    'Review AI Agent blockers and delivered results that may need attention, then open the relevant execution or conversation.',
  'automations.aiAgents.assistance.back': 'Back to AI Agents',
  'automations.aiAgents.assistance.expandObjective': 'Show full objective',
  'automations.aiAgents.assistance.collapseObjective': 'Collapse objective',
  'automations.aiAgents.assistance.status.open': 'Open',
  'automations.aiAgents.assistance.status.resolved': 'Resolved',
  'automations.aiAgents.assistance.category.missingCapability':
    'Missing capability',
  'automations.aiAgents.assistance.category.configurationUnavailable':
    'Configuration unavailable',
  'automations.aiAgents.assistance.category.terminalToolFailure':
    'Terminal tool failure',
  'automations.aiAgents.assistance.category.repeatedToolFailure':
    'Repeated tool failure',
  'automations.aiAgents.assistance.category.terminalOperationFailure':
    'Could not be completed safely',
  'automations.aiAgents.assistance.category.messageFidelityReview':
    'Message needs review',
  'automations.aiAgents.assistance.capability':
    'Required capability: {capability}',
  'automations.aiAgents.assistance.requiredTool': 'Required action: {toolName}',
  'automations.aiAgents.assistance.requiredAnyTool':
    'Any compatible action: {toolNames}',
  'automations.aiAgents.assistance.toolAttempts':
    '{toolName} failed {attempts} times.',
  'automations.aiAgents.assistance.affectedTool': 'Affected action: {toolName}',
  'automations.aiAgents.assistance.reason.missingCapability':
    'The required capability is not available.',
  'automations.aiAgents.assistance.reason.configurationUnavailable':
    'The required configuration or integration is not available.',
  'automations.aiAgents.assistance.reason.terminalToolFailure':
    'The action could not be completed and needs review.',
  'automations.aiAgents.assistance.reason.repeatedToolFailure':
    'The action could not be completed after several attempts.',
  'automations.aiAgents.assistance.reason.terminalOperationFailure':
    'The action could not be completed safely after a correction attempt.',
  'automations.aiAgents.assistance.reason.messageFidelityReview':
    'A delivered response kept unresolved review issues.',
  'automations.aiAgents.assistance.advisory.messageFidelityReviewContext':
    'Affected action: {operation} · Unresolved review issues: {issueCount}',
  'automations.aiAgents.assistance.conversation':
    'Conversation {conversationId}',
  'automations.aiAgents.assistance.openConversation':
    'Go to conversation {conversationId}',
  'automations.aiAgents.assistance.openConversationLabel':
    'Open conversation {conversationId}',
  'automations.aiAgents.assistance.openExecution': 'Review execution',
  'automations.aiAgents.assistance.dismiss': 'Dismiss',
  'automations.aiAgents.assistance.dismissLabel': 'Dismiss assistance',
  'automations.aiAgents.assistance.dismissError':
    'We could not dismiss this assistance. Try again.',
  'automations.aiAgents.assistance.unknownAgent': 'Unknown AI Agent',
  'automations.aiAgents.assistance.filters.status': 'Assistance status',
  'automations.aiAgents.assistance.filters.category': 'Assistance category',
  'automations.aiAgents.assistance.filters.agent': 'AI Agent',
  'automations.aiAgents.assistance.filters.conversation': 'Conversation ID',
  'automations.aiAgents.assistance.filters.conversationPlaceholder':
    'Conversation ID',
  'automations.aiAgents.assistance.filters.applyConversation':
    'Apply conversation filter',
  'automations.aiAgents.assistance.filters.invalidConversation':
    'Enter a positive numeric conversation ID.',
  'automations.aiAgents.assistance.filters.allCategories': 'All categories',
  'automations.aiAgents.assistance.filters.allAgents': 'All AI Agents',
  'automations.aiAgents.assistance.filters.reset': 'Reset filters',
  'automations.aiAgents.assistance.emptyTitle': 'No assistance needed',
  'automations.aiAgents.assistance.emptyDescription':
    'No AI Agent work matches the selected filters.',
  'automations.aiAgents.assistance.partialDirectoryWarning':
    'Some AI Agent identities could not be loaded. Names and agent filters may be incomplete.',
  'automations.aiAgents.assistance.partialListWarning':
    'Some assistance records could not be loaded. Retry to refresh the list.',
  'automations.aiAgents.assistance.errorTitle':
    'We could not load AI Agent assistance',
  'automations.aiAgents.assistance.errorDescription':
    'Check your connection and try again.',
  'automations.aiAgents.executions.title': 'Executions',
  'automations.aiAgents.executions.description':
    'Review outcomes, blockers, and activity for {agentName}.',
  'automations.aiAgents.executions.back': 'Back to AI Agents',
  'automations.aiAgents.executions.unknownAgent': 'this AI Agent',
  'automations.aiAgents.executions.genericTitle': 'Execution',
  'automations.aiAgents.executions.contact': 'Contact',
  'automations.aiAgents.executions.startedAt': 'Started',
  'automations.aiAgents.executions.duration': 'Duration',
  'automations.aiAgents.executions.blocker': 'Blocker reason',
  'automations.aiAgents.executions.blockerReasonFallback':
    'The execution could not complete the required work.',
  'automations.aiAgents.executions.emptyTitle': 'No executions',
  'automations.aiAgents.executions.emptyDescription':
    'We found no executions for the selected range.',
  'automations.aiAgents.executions.errorTitle':
    'We could not load the executions',
  'automations.aiAgents.executions.errorDescription':
    'Check your connection and try again.',
  'automations.aiAgents.executions.status.completed': 'Completed',
  'automations.aiAgents.executions.status.failed': 'Failed',
  'automations.aiAgents.executions.status.running': 'Running',
  'automations.aiAgents.executions.status.blocked': 'Needs help',
  'automations.aiAgents.executions.status.unknown': 'No status',
  'automations.aiAgents.executions.dateRange.trigger': 'Filter by date range',
  'automations.aiAgents.executions.dateRange.title': 'Execution date range',
  'automations.aiAgents.executions.dateRange.presets': 'Quick ranges',
  'automations.aiAgents.executions.dateRange.from': 'From',
  'automations.aiAgents.executions.dateRange.to': 'To',
  'automations.aiAgents.executions.dateRange.close': 'Close date picker',
  'automations.aiAgents.executions.dateRange.all': 'All dates',
  'automations.aiAgents.executions.dateRange.today': 'Today',
  'automations.aiAgents.executions.dateRange.last7Days': 'Last 7 days',
  'automations.aiAgents.executions.dateRange.last30Days': 'Last 30 days',
  'automations.aiAgents.executions.dateRange.missing':
    'Select both a start and end date.',
  'automations.aiAgents.executions.dateRange.invalid': 'Enter valid dates.',
  'automations.aiAgents.executions.dateRange.order':
    'The start date must be before the end date.',
  'automations.aiAgents.executions.dateRange.beforeMin':
    'The start date is outside the allowed range.',
  'automations.aiAgents.executions.dateRange.afterMax':
    'The end date is outside the allowed range.',
  'automations.aiAgents.detail.title': 'Execution details',
  'automations.aiAgents.detail.description':
    'AI Agent outcome, context, and activity.',
  'automations.aiAgents.detail.back': 'Back to executions',
  'automations.aiAgents.detail.summary': 'Summary',
  'automations.aiAgents.detail.timeline': 'Timeline',
  'automations.aiAgents.detail.technical': 'Technical data',
  'automations.aiAgents.detail.errorTitle': 'We could not load this execution',
  'automations.aiAgents.detail.errorDescription':
    'Check your connection and try again.',
  'automations.aiAgents.detail.outcome': 'Outcome',
  'automations.aiAgents.detail.objective': 'Objective',
  'automations.aiAgents.detail.context': 'Work context',
  'automations.aiAgents.detail.plan': 'Plan',
  'automations.aiAgents.detail.actions': 'Actions performed',
  'automations.aiAgents.detail.blocker': 'The AI Agent needs help',
  'automations.aiAgents.detail.affectedWork': 'Pending work',
  'automations.aiAgents.detail.noObjective': 'No objective was recorded.',
  'automations.aiAgents.detail.noContext': 'No business context was recorded.',
  'automations.aiAgents.detail.noPlan': 'No plan was recorded.',
  'automations.aiAgents.detail.noActions': 'No external actions were recorded.',
  'automations.aiAgents.detail.contact': 'Contact',
  'automations.aiAgents.detail.funnel': 'Funnel',
  'automations.aiAgents.detail.funnelStatus': 'Current status',
  'automations.aiAgents.detail.latestInteraction': 'Latest message',
  'automations.aiAgents.detail.property': 'Property of interest',
  'automations.aiAgents.detail.moreContext': 'View complete context',
  'automations.aiAgents.detail.trigger': 'Execution trigger',
  'automations.aiAgents.detail.contactChannels': 'Contact channels',
  'automations.aiAgents.detail.statusInstructions':
    'Current status instructions',
  'automations.aiAgents.detail.recentInteractions': 'Recent interactions',
  'automations.aiAgents.detail.inbound': 'Inbound',
  'automations.aiAgents.detail.outbound': 'Outbound',
  'automations.aiAgents.detail.messagesShown':
    'Showing {shown} of {total} messages',
  'automations.aiAgents.detail.callsCount': '{count} calls',
  'automations.aiAgents.detail.propertyDetails': 'Property details',
  'automations.aiAgents.detail.active': 'Active',
  'automations.aiAgents.detail.inactive': 'Inactive',
  'automations.aiAgents.detail.bedrooms': '{count} bedrooms',
  'automations.aiAgents.detail.bathrooms': '{count} bathrooms',
  'automations.aiAgents.detail.rentPrice': 'Rent price',
  'automations.aiAgents.detail.salePrice': 'Sale price',
  'automations.aiAgents.detail.openSource': 'Open source',
  'automations.aiAgents.detail.phaseDetails': 'Phase details',
  'automations.aiAgents.detail.actionDetails': 'Action details',
  'automations.aiAgents.detail.plannedTasks': 'Planned work',
  'automations.aiAgents.detail.result': 'Result',
  'automations.aiAgents.detail.goalAchieved': 'Achieved',
  'automations.aiAgents.detail.goalNotAchieved': 'Not achieved',
  'automations.aiAgents.detail.reason': 'Reason',
  'automations.aiAgents.detail.validatorAction': 'Validation decision',
  'automations.aiAgents.detail.affectedTodo': 'Affected work',
  'automations.aiAgents.detail.nextTodo': 'Next work item',
  'automations.aiAgents.detail.remainingTodos': 'Remaining work items',
  'automations.aiAgents.detail.executedTools': 'Tools executed',
  'automations.aiAgents.detail.duration': 'Duration',
  'automations.aiAgents.detail.contextFacts': 'Collected context',
  'automations.aiAgents.detail.messages': 'Messages collected',
  'automations.aiAgents.detail.calls': 'Calls collected',
  'automations.aiAgents.detail.searchQuery': 'Search query',
  'automations.aiAgents.detail.resultsCount': 'Results',
  'automations.aiAgents.detail.sentMessages': 'Messages sent',
  'automations.aiAgents.detail.attemptedMessages': 'Messages attempted',
  'automations.aiAgents.detail.failedMessages': 'Messages failed',
  'automations.aiAgents.detail.updatedFields': 'Fields updated',
  'automations.aiAgents.detail.task': 'Task',
  'automations.aiAgents.detail.taskStatus': 'Task status',
  'automations.aiAgents.detail.taskDueDate': 'Due date',
  'automations.aiAgents.detail.selectedProperty': 'Selected property',
  'automations.aiAgents.detail.propertyCleared': 'Property selection cleared',
  'automations.aiAgents.detail.validator.completedTodo': 'Work item completed',
  'automations.aiAgents.detail.validator.completedObjective':
    'Objective completed',
  'automations.aiAgents.detail.validator.cancelledTodo': 'Work item cancelled',
  'automations.aiAgents.detail.validator.cancelledObjective':
    'Objective cancelled',
  'automations.aiAgents.detail.validator.keptInProgress':
    'Work item kept in progress',
  'automations.aiAgents.detail.validator.blockedTodo': 'Work item blocked',
  'automations.aiAgents.detail.validator.blockedObjective': 'Objective blocked',
  'automations.aiAgents.detail.validator.blockedReasonFallback':
    'The execution could not complete the required work.',
  'automations.aiAgents.detail.timelineEmptyTitle': 'No recorded activity',
  'automations.aiAgents.detail.timelineEmptyDescription':
    'This execution does not have phases or actions yet.',
  'automations.aiAgents.detail.cycle': 'Cycle {cycle}',
  'automations.aiAgents.detail.step': 'Step {number}',
  'automations.aiAgents.detail.technicalDescription':
    'Redacted inputs, outputs, and errors for technical support.',
  'automations.aiAgents.detail.technicalPreviewTruncated':
    'This redacted preview is truncated to keep the page responsive.',
  'automations.aiAgents.detail.loadFullTechnicalPayload':
    'Load complete payload',
  'automations.aiAgents.detail.noTechnicalData':
    'This step does not contain technical data.',
  'automations.aiAgents.detail.phase.fetchContext': 'Context collection',
  'automations.aiAgents.detail.phase.fetchContextDescription':
    'Gathered the information needed to work.',
  'automations.aiAgents.detail.phase.planner': 'Plan design',
  'automations.aiAgents.detail.phase.plannerDescription':
    'Defined the objective and actions to perform.',
  'automations.aiAgents.detail.phase.executor': 'Plan execution',
  'automations.aiAgents.detail.phase.executorDescription':
    'Decided and coordinated the plan actions.',
  'automations.aiAgents.detail.phase.validator': 'Validation',
  'automations.aiAgents.detail.phase.validatorDescription':
    'Evaluated the outcome and remaining work.',
  'automations.aiAgents.detail.phase.workflow': 'Plan actions',
  'automations.aiAgents.detail.phase.workflowDescription':
    'Ran the required tools.',
  'automations.aiAgents.detail.phase.unknown': 'AI Agent activity',
  'automations.aiAgents.detail.phase.unknownDescription':
    'Recorded activity during the execution.',
  'automations.aiAgents.detail.toolAction': 'Action',
  'automations.aiAgents.metadata.additionalTriggers': '{name} and {count} more',
  'automations.aiAgents.metadata.workspace.funnelStatus': 'Funnel status',
  'automations.aiAgents.metadata.triggers.messageReceived': 'Message received',
  'automations.aiAgents.metadata.triggers.whatsappMessageReceived':
    'WhatsApp message received',
  'automations.aiAgents.metadata.triggers.callCompleted': 'Call completed',
  'automations.aiAgents.metadata.triggers.callMissed': 'Missed call',
  'automations.aiAgents.metadata.triggers.taskCompleted': 'Task completed',
  'automations.aiAgents.metadata.triggers.taskCancelled': 'Task cancelled',
  'automations.aiAgents.metadata.triggers.funnelStatusChanged':
    'Funnel status changed',
  'automations.aiAgents.metadata.triggers.contactCreated': 'Contact created',
  'automations.aiAgents.metadata.triggers.contactUpdated': 'Contact updated',
  'automations.aiAgents.metadata.triggers.scheduledTime': 'Scheduled time',
  'automations.aiAgents.metadata.triggers.workflowStarted': 'Workflow started',
  'automations.aiAgents.metadata.triggers.manual': 'Manual trigger',
  'automations.aiAgents.metadata.tools.listWhatsappTemplates':
    'List WhatsApp templates',
  'automations.aiAgents.metadata.tools.getWhatsappTemplate':
    'Get WhatsApp template',
  'automations.aiAgents.metadata.tools.sendWhatsappTemplate':
    'Send WhatsApp template',
  'automations.aiAgents.metadata.tools.sendWhatsappMessage':
    'Send WhatsApp message',
  'automations.aiAgents.metadata.tools.listTasks': 'List tasks',
  'automations.aiAgents.metadata.tools.createTask': 'Create task',
  'automations.aiAgents.metadata.tools.updateTask': 'Update task',
  'automations.aiAgents.metadata.tools.completeTask': 'Complete task',
  'automations.aiAgents.metadata.tools.cancelTask': 'Cancel task',
  'automations.aiAgents.metadata.tools.getTask': 'Get task',
  'automations.aiAgents.metadata.tools.makePhoneCall': 'Make phone call',
  'automations.aiAgents.metadata.tools.updateFields': 'Update fields',
  'automations.aiAgents.metadata.tools.updateStatus': 'Update status',
  'automations.aiAgents.metadata.tools.replaceFollowUp':
    'Schedule next follow-up',
  'automations.aiAgents.metadata.tools.updateContactConversationFields':
    'Update contact and conversation details',
  'automations.aiAgents.metadata.tools.updateConversationStatus':
    'Change conversation status',
  'automations.aiAgents.metadata.tools.getFunnelStatuses':
    'Review funnel statuses',
  'automations.aiAgents.metadata.tools.listWhatsappPhones':
    'Review WhatsApp lines',
  'automations.aiAgents.metadata.tools.searchProperties': 'Search properties',
  'automations.aiAgents.metadata.tools.selectPropertyOfInterest':
    'Select property of interest',
  'automations.aiAgents.metadata.tools.escalateToHumanAssistance':
    'Request human assistance',
  'automations.aiAgents.metadata.tools.readyToScheduleVisit':
    'Refer for visit coordination',
  'automations.aiAgents.metadata.tools.searchKnowledgeBase':
    'Search knowledge base',
  'automations.aiAgents.metadata.tools.searchProducts': 'Search products',
  'automations.aiAgents.metadata.tools.deleteTask': 'Delete task',
  'automations.aiAgents.metadata.tools.createProduct': 'Create product',
  'automations.aiAgents.metadata.tools.deleteProduct': 'Delete product',
  'automations.aiAgents.metadata.tools.getProduct': 'Get product',
  'automations.aiAgents.metadata.tools.importProducts': 'Import products',
  'automations.aiAgents.metadata.tools.listProducts': 'List products',
  'automations.aiAgents.metadata.tools.updateProduct': 'Update product',
  'automations.aiAgents.metadata.tools.createProperty': 'Create property',
  'automations.aiAgents.metadata.tools.deleteProperty': 'Delete property',
  'automations.aiAgents.metadata.tools.getProperty': 'Get property',
  'automations.aiAgents.metadata.tools.importProp360': 'Import Prop360 file',
  'automations.aiAgents.metadata.tools.importProperties': 'Import properties',
  'automations.aiAgents.metadata.tools.listProperties': 'List properties',
  'automations.aiAgents.metadata.tools.updateProperty': 'Update property',
  'automations.aiAgents.metadata.tools.sendPlatformEmail': 'Send email',
  'automations.aiAgents.metadata.tools.callLanguageModel': 'Run language model',
  'automations.aiAgents.metadata.tools.createConversation':
    'Create conversation',
  'automations.aiAgents.metadata.tools.publishPhaseToolsCompleted':
    'Record completed actions',
  'automations.aiAgents.metadata.tools.getConversation': 'Get conversation',
  'automations.aiAgents.metadata.tools.getConversationCalls':
    'Get conversation calls',
  'automations.aiAgents.metadata.tools.conditionalGate': 'Evaluate a condition',
  'automations.aiAgents.metadata.tools.crawlWebsite': 'Crawl website',
  'automations.aiAgents.metadata.tools.getDateTime': 'Get date and time',
  'automations.aiAgents.metadata.tools.extractWebpageContent':
    'Extract webpage content',
  'automations.aiAgents.metadata.tools.fetchConversationHistory':
    'Get conversation history',
  'automations.aiAgents.metadata.tools.getHubspotContact':
    'Get HubSpot contact',
  'automations.aiAgents.metadata.tools.listUsers': 'List users',
  'automations.aiAgents.metadata.tools.extractConversationFields':
    'Extract conversation details',
  'automations.aiAgents.metadata.tools.getContact': 'Get contact',
  'automations.aiAgents.metadata.tools.getContactByProvider':
    'Get contact by channel',
  'automations.aiAgents.metadata.tools.getContactFields': 'Get contact fields',
  'automations.aiAgents.metadata.tools.getConversationFields':
    'Get conversation fields',
  'automations.aiAgents.metadata.tools.getConversationMessages':
    'Get conversation messages',
  'automations.aiAgents.metadata.tools.getFunnelAddress': 'Get funnel address',
  'automations.aiAgents.metadata.tools.getFunnelAddresses':
    'List funnel addresses',
  'automations.aiAgents.metadata.tools.updateContact': 'Update contact',
  'automations.aiAgents.metadata.tools.updateConversation':
    'Update conversation',
  'automations.aiAgents.metadata.tools.randomNumber': 'Generate random number',
  'automations.aiAgents.metadata.tools.roundRobinPick': 'Choose by rotation',
  'automations.aiAgents.metadata.tools.runParallel': 'Run actions in parallel',
  'automations.aiAgents.metadata.tools.runWorkflow': 'Run automation',
  'automations.aiAgents.metadata.tools.searchWeb': 'Search the web',
  'automations.aiAgents.metadata.tools.selectFromList': 'Select from a list',
  'automations.aiAgents.metadata.tools.sendWebhook': 'Send webhook',
  'automations.aiAgents.metadata.tools.syncHubspotContact':
    'Sync HubSpot contact',
  'automations.aiAgents.metadata.tools.matchTextPattern': 'Match text pattern',
  'automations.aiAgents.metadata.tools.wait': 'Wait',
  'automations.aiAgents.metadata.capabilities.noAction': 'No action required',
  'automations.aiAgents.metadata.capabilities.customAction':
    'Run a custom action',

  // Sidebar - Automation Menu Items
  'sidebar.agents': 'AI Agents',
  'sidebar.automations': 'Automations',

  // Sidebar - Analytics Menu Items
  'sidebar.calls': 'Calls',
  'sidebar.reports': 'Reports',
  'sidebar.report-dashboard': 'Reports',

  // Reports Dashboard
  'reports.dashboard.pageTitle': 'Reports',
  'reports.dashboard.pageDescription':
    'Build shared metric widgets and adjust filters so every admin can track operations clearly.',
  'reports.dashboard.description':
    'Add shared widgets, duplicate views, and adjust filters.',
  'reports.dashboard.defaultLayoutNotice':
    'This tenant is using the default layout because no shared dashboard has been saved yet.',
  'reports.dashboard.widgetFallbackTitle': 'Widget',
  'reports.dashboard.duplicateSuffix': '(copy)',
  'reports.dashboard.actions.addWidget': 'New widget',
  'reports.dashboard.actions.reset': 'Reset',
  'reports.dashboard.resetConfirm.title': 'Reset widgets',
  'reports.dashboard.resetConfirm.description':
    'This restores the shared dashboard to the default layout and removes saved changes for all admins in this tenant.',
  'reports.dashboard.resetConfirm.confirm': 'Reset',
  'reports.dashboard.resetConfirm.cancel': 'Cancel',
  'reports.calls.pageTitle': 'Call reports',
  'reports.calls.pageDescription':
    'Historical metrics and advanced analysis to understand call-channel performance.',
  'reports.calls.backLabel': 'Back to calls',
  'reports.calls.views': 'Views',
  'reports.calls.tabs.basic': 'Basic',
  'reports.calls.tabs.advanced': 'Advanced',
  'reports.calls.filters.allCalls': 'All calls',
  'reports.calls.filters.effective': 'Effective only',
  'reports.calls.filters.missed': 'Missed only',
  'reports.calls.filters.voicemail': 'Voicemail only',
  'reports.dashboard.actions.configure': 'Configure',
  'reports.dashboard.actions.cancel': 'Cancel',
  'reports.dashboard.actions.save': 'Save',
  'reports.dashboard.actions.drag': 'Drag',
  'reports.dashboard.actions.editConfiguration': 'Edit configuration',
  'reports.dashboard.alerts.updated': 'Dashboard updated.',
  'reports.dashboard.alerts.duplicated': 'Widget duplicated.',
  'reports.dashboard.alerts.removed': 'Widget removed.',
  'reports.dashboard.alerts.reset': 'Dashboard reset.',
  'reports.dashboard.errors.defaultWidgetNotFound':
    'The default widget template could not be found.',
  'reports.dashboard.errors.saveWidget': 'The widget could not be saved.',
  'reports.dashboard.errors.duplicateWidget':
    'The widget could not be duplicated.',
  'reports.dashboard.errors.removeWidget': 'The widget could not be removed.',
  'reports.dashboard.errors.resetDashboard':
    'The dashboard could not be reset.',
  'reports.dashboard.errors.reorderDashboard':
    'The dashboard could not be reordered.',
  'reports.dashboard.errors.loadDashboardTitle':
    'The dashboard could not be loaded',
  'reports.dashboard.errors.loadDashboardDescription':
    'Retry to load the widgets again.',
  'reports.dashboard.errors.widgetLoadTitle': 'The widget could not be loaded',
  'reports.dashboard.errors.widgetLoadDescription':
    'Review the filters or try again.',
  'reports.dashboard.catalog.title': 'Catalog',
  'reports.dashboard.catalog.description':
    'Choose a widget and then adjust its filters with a live preview.',
  'reports.dashboard.modal.configureTitle': 'Configure widget',
  'reports.dashboard.modal.addTitle': 'Add widget',
  'reports.dashboard.modal.configureDescription':
    'Adjust filters and review the live preview before saving.',
  'reports.dashboard.modal.addDescription':
    'Choose a widget and then adjust its filters in the preview.',
  'reports.dashboard.editor.mobile.settings': 'Configure',
  'reports.dashboard.editor.mobile.preview': 'Preview',
  'reports.dashboard.editor.title': 'Visual configuration',
  'reports.dashboard.editor.description':
    'Adjust filters and review the live preview before saving.',
  'reports.dashboard.warnings.noFunnelsTitle': 'No funnels available',
  'reports.dashboard.warnings.noFunnelsDescription':
    'This widget needs a funnel before it can be configured. Create a funnel before saving it.',
  'reports.dashboard.warnings.noStatusesTitle': 'The funnel has no statuses',
  'reports.dashboard.warnings.noStatusesDescription':
    'The selected funnel does not have any statuses configured yet. Add statuses before using this widget.',
  'reports.dashboard.fields.title.label': 'Title',
  'reports.dashboard.fields.title.hint':
    'This is the main widget name. If you leave it empty, the default title for the report type will be used.',
  'reports.dashboard.fields.title.helper':
    'Use it to distinguish similar widgets with different filters.',
  'reports.dashboard.fields.label.label': 'Label',
  'reports.dashboard.fields.label.hint':
    'This is an optional short badge shown above the title, for example to mark priority, stage, or audience.',
  'reports.dashboard.fields.label.placeholder': 'Ex. High priority',
  'reports.dashboard.fields.label.helper':
    'It works best with short one-to-three-word labels.',
  'reports.dashboard.fields.color.label': 'Widget color',
  'reports.dashboard.fields.color.hint':
    'Choose one of the system soft surfaces to differentiate the card. If you add a label, it will reuse the same color as its accent.',
  'reports.dashboard.fields.color.helper':
    'The color changes the card surface while keeping the text readable.',
  'reports.dashboard.fields.dateRange.label': 'Date range',
  'reports.dashboard.fields.dateRange.hint':
    'Define which period the widget uses. You can choose quick presets or a custom range.',
  'reports.dashboard.fields.dateRange.helper':
    'Changing this filter updates the preview with the same calculation users will see on the panel.',
  'reports.dashboard.fields.users.label': 'Users',
  'reports.dashboard.fields.users.hint':
    'Limit the widget to events recorded for specific assignees. Leave it empty to include everyone.',
  'reports.dashboard.fields.users.helper':
    'This filter uses the assignee captured when each report event happened.',
  'reports.dashboard.fields.users.loadingMessage': 'Loading users…',
  'reports.dashboard.fields.users.emptyMessage':
    'There are no users available for this filter.',
  'reports.dashboard.fields.funnel.label': 'Funnel',
  'reports.dashboard.fields.funnel.hint':
    'Choose the funnel that provides the statuses, conversations, and breakdown fields.',
  'reports.dashboard.fields.funnel.helper':
    'When you change the funnel, the available statuses and fields also change.',
  'reports.dashboard.fields.visibleStatuses.label': 'Visible statuses',
  'reports.dashboard.fields.visibleStatuses.helper':
    'Choose which statuses are included in the calculation and in which order they appear on the card.',
  'reports.dashboard.fields.statuses.loadingMessage': 'Loading statuses…',
  'reports.dashboard.fields.statuses.emptyMessage': 'No statuses available.',
  'reports.dashboard.fields.status.label': 'Status',
  'reports.dashboard.fields.status.placeholder': 'Select a status',
  'reports.dashboard.fields.status.helper':
    'This widget counts the first time a conversation enters the selected status.',
  'reports.dashboard.fields.visibleColumns.label': 'Visible columns',
  'reports.dashboard.fields.visibleColumns.helper':
    'Hide columns that do not help the comparison to keep the table readable.',
  'reports.dashboard.fields.breakdown.label': 'Breakdown',
  'reports.dashboard.fields.breakdown.hint':
    'Split the results by a funnel custom field to compare segments inside the same widget.',
  'reports.dashboard.fields.breakdown.none': 'No breakdown',
  'reports.dashboard.fields.breakdown.helper':
    'If you do not need segmentation, keep this option on “No breakdown”.',
  'reports.dashboard.fields.limit.label': 'Limit',
  'reports.dashboard.fields.limit.hint':
    'Control how many properties appear in the ranking to keep the card readable.',
  'reports.dashboard.fields.limit.helper':
    'Between 5 and 10 rows usually works best for compact dashboards.',
  'reports.dashboard.preview.title': 'Preview',
  'reports.dashboard.preview.description':
    'This card uses the same renderer and query as the final dashboard.',
  'reports.dashboard.preview.helper':
    'On small screens you can switch between configuration and preview using the tabs above.',
  'reports.dashboard.validation.invalidTitle': 'Invalid configuration',
  'reports.dashboard.validation.incompleteTitle': 'Complete the configuration',
  'reports.dashboard.empty.noDataTitle': 'No data',
  'reports.dashboard.empty.funnelStatusFunnel':
    'No entries to these statuses were recorded during the selected period.',
  'reports.dashboard.empty.timeseries':
    'There were no first entries during the selected period.',
  'reports.dashboard.empty.noPropertiesTitle': 'No properties',
  'reports.dashboard.empty.propertyTypeDistribution':
    'There are no active properties in the selected period.',
  'reports.dashboard.empty.noRankingTitle': 'No ranking',
  'reports.dashboard.empty.propertyInterestRanking':
    'There were no property-interest changes during the selected period.',
  'reports.dashboard.empty.noAssignmentsTitle': 'No assignments',
  'reports.dashboard.empty.userAssignmentRanking':
    'There were no assignments during the selected period or no visible statuses were selected.',
  'reports.dashboard.table.user': 'User',
  'reports.dashboard.table.property': 'Property',
  'reports.dashboard.table.consultations': 'Consultations',
  'reports.dashboard.table.total': 'Total',
  'reports.dashboard.setupIssues.selectFunnel':
    'Select a funnel to load statuses and calculate this report.',
  'reports.dashboard.setupIssues.selectAtLeastOneStatus':
    'Select at least one status to display the widget.',
  'reports.dashboard.setupIssues.selectTimeseriesStatus':
    'Select a status to display the time series.',
  'reports.dashboard.setupIssues.selectAssignmentFunnel':
    'Select a funnel to show assignments by status.',
  'reports.dashboard.setupIssues.selectStatusColumn':
    'Select at least one status column for the table.',
  'reports.dashboard.setupIssues.reviewConfiguration':
    'Review the widget configuration before trying to load it.',
  'reports.dashboard.thumbnail.property': 'Property',
  'reports.dashboard.thumbnail.consultations': 'Consultations',
  'reports.dashboard.thumbnail.user': 'User',
  'reports.dashboard.datePreset.today': 'Today',
  'reports.dashboard.datePreset.last7Days': 'Last 7 days',
  'reports.dashboard.datePreset.thisMonth': 'This month',
  'reports.dashboard.datePreset.last30Days': 'Last 30 days',
  'reports.dashboard.datePreset.customRange': 'Custom range',
  'reports.dashboard.dateRange.from': 'From',
  'reports.dashboard.dateRange.to': 'To',
  'reports.dashboard.dateRange.trigger': 'Change report date range',
  'reports.dashboard.dateRange.title': 'Select date range',
  'reports.dashboard.dateRange.close': 'Close date range picker',
  'reports.dashboard.dateRange.presets': 'Quick ranges',
  'reports.dashboard.dateRange.timezone': 'Dates use the {timezone} timezone.',
  'reports.dashboard.dateRange.currentSelection': 'Current selection:',
  'reports.dashboard.dateRange.errors.missing':
    'Select both a start and end date.',
  'reports.dashboard.dateRange.errors.invalid':
    'Enter valid custom dates using the YYYY-MM-DD format.',
  'reports.dashboard.dateRange.errors.order':
    'The custom range start date must be on or before the end date.',
  'reports.dashboard.dateRange.errors.beforeMin':
    'The selected range starts before the earliest available date.',
  'reports.dashboard.dateRange.errors.afterMax':
    'Future dates cannot be included in reports.',
  'reports.advanced.dateRange.title': 'Reporting period',
  'reports.advanced.dateRange.description':
    'This date range applies to every report on this page.',
  'reports.advanced.options.groupBy.day': 'Day',
  'reports.advanced.options.groupBy.week': 'Week',
  'reports.advanced.options.groupBy.month': 'Month',
  'reports.advanced.options.direction.all': 'All directions',
  'reports.advanced.options.direction.incoming': 'Incoming',
  'reports.advanced.options.direction.outgoing': 'Outgoing',
  'reports.advanced.options.profile.agentsOnly': 'Agents only',
  'reports.advanced.options.profile.activeUsersOnly': 'Active users only',
  'reports.advanced.options.profile.allUsers': 'All users',
  'reports.advanced.filters.teamsPlaceholder': 'Select teams',
  'reports.advanced.filters.agentsPlaceholder': 'Select agents',
  'reports.advanced.filters.allTeams': 'All teams',
  'reports.advanced.filters.unassignedTeam': 'No team',
  'reports.advanced.filters.teamFallback': 'Team #{id}',
  'reports.advanced.pagination.rowsPerPage': '{count} rows',
  'reports.advanced.pagination.summary': 'Showing {visible} of {total} rows',
  'reports.advanced.table.empty': 'No data found',
  'reports.advanced.table.sortBy': 'Sort by',
  'reports.advanced.table.ascending': 'ascending',
  'reports.advanced.table.descending': 'descending',
  'reports.advanced.table.headers.agent': 'Agent',
  'reports.advanced.table.headers.team': 'Team',
  'reports.advanced.table.headers.profile': 'Profile',
  'reports.advanced.table.headers.connected': 'Connected',
  'reports.advanced.table.headers.voicemail': 'Voicemail',
  'reports.advanced.table.headers.noAnswer': 'No answer',
  'reports.advanced.table.headers.rejected': 'Rejected',
  'reports.advanced.table.headers.averageDuration': 'Avg. duration',
  'reports.advanced.table.headers.minutesOnline': 'Minutes online',
  'reports.advanced.table.headers.totalCalls': 'Total calls',
  'reports.advanced.table.headers.leads': 'Leads',
  'reports.advanced.table.headers.leadContactability':
    'Lead contactability (%)',
  'reports.advanced.table.headers.callContactability':
    'Call contactability (%)',
  'reports.advanced.table.headers.callsPerLead': 'Calls / Lead',
  'reports.advanced.table.headers.expertise': 'Expertise',
  'reports.advanced.table.headers.confidence': 'Confidence',
  'reports.advanced.table.headers.objections': 'Objections',
  'reports.advanced.table.headers.closing': 'Closing',
  'reports.advanced.table.headers.performance': 'Performance',
  'reports.advanced.table.headers.total': 'Total',
  'reports.advanced.table.headers.average': 'Average',
  'reports.advanced.table.headers.timeRange': 'Time range',
  'reports.advanced.table.headers.date': 'Date',
  'reports.advanced.table.headers.objection': 'Objection',
  'reports.advanced.table.headers.contact': 'Contact',
  'reports.advanced.table.headers.phone': 'Phone',
  'reports.advanced.table.headers.open': 'Open',
  'reports.advanced.weekdays.monday': 'Monday',
  'reports.advanced.weekdays.tuesday': 'Tuesday',
  'reports.advanced.weekdays.wednesday': 'Wednesday',
  'reports.advanced.weekdays.thursday': 'Thursday',
  'reports.advanced.weekdays.friday': 'Friday',
  'reports.advanced.weekdays.saturday': 'Saturday',
  'reports.advanced.weekdays.sunday': 'Sunday',
  'reports.advanced.actions.viewContact': 'View contact',
  'reports.advanced.summary.agents': 'Agents',
  'reports.advanced.summary.totalCalls': 'Total calls',
  'reports.advanced.summary.averageCallsPerAgent': 'Avg. calls / agent',
  'reports.advanced.summary.minutesOnline': 'Minutes online',
  'reports.advanced.summary.averageConnectedPerAgent': 'Avg. connected / agent',
  'reports.advanced.summary.note':
    'Summary calculated from this table’s active filters.',
  'reports.advanced.metrics.exactMinutes': 'Exact minutes',
  'reports.advanced.metrics.roundedMinutes': 'Rounded minutes',
  'reports.advanced.metrics.extractions': 'Extractions',
  'reports.advanced.tabs.callVolume': '# calls',
  'reports.advanced.tabs.contactability': '% contactability',
  'reports.advanced.sections.agentPerformance.title': 'Agent performance',
  'reports.advanced.sections.agentPerformance.description':
    'Operational metrics and analysis scores by agent within the selected range.',
  'reports.advanced.sections.agentCalls.title': 'Calls by agent',
  'reports.advanced.sections.agentCalls.description':
    'Call time series by agent.',
  'reports.advanced.sections.featuredCalls.title': 'Featured calls by agent',
  'reports.advanced.sections.featuredCalls.description':
    'Count of calls with a featured analysis score.',
  'reports.advanced.sections.agentHourly.title':
    'Connected calls by hour and agent',
  'reports.advanced.sections.agentHourly.description':
    'Hourly distribution of completed calls by agent.',
  'reports.advanced.sections.outgoingHeatmap.title':
    'Outgoing activity by day and time',
  'reports.advanced.sections.outgoingHeatmap.description':
    'Distribution of outgoing calls by time block, with volume and contactability views.',
  'reports.advanced.sections.objections.title': 'Detected objections',
  'reports.advanced.sections.objections.description':
    'Recent objection extractions with contact access when available.',
  'reports.advanced.sections.leadQualification.title': 'Lead qualification',
  'reports.advanced.sections.leadQualification.description':
    'Lead classification distribution derived from the analysis.',
  'reports.advanced.sections.connectedMinutes.title': 'Connected minutes',
  'reports.advanced.sections.connectedMinutes.description':
    'Trend of minutes talked in completed calls.',
  'reports.advanced.sections.extractions.title': 'Analysis extractions',
  'reports.advanced.sections.extractions.description':
    'Most frequent extractions within the selected period.',
  'reports.advanced.sections.contactabilityByPhone.title':
    'Contactability by phone',
  'reports.advanced.sections.contactabilityByPhone.description':
    'Effectiveness ratio by source number on days with sufficient volume.',
  'reports.dashboard.color.primary': 'Primary',
  'reports.dashboard.color.secondary': 'Secondary',
  'reports.dashboard.color.neutral': 'Neutral',
  'reports.dashboard.color.danger': 'Red',
  'reports.dashboard.color.warning': 'Amber',
  'reports.dashboard.color.success': 'Green',
  'reports.dashboard.color.info': 'Blue',
  'reports.dashboard.color.whatsapp': 'WhatsApp',
  'reports.dashboard.color.call': 'Calls',
  'reports.dashboard.color.email': 'Email',
  'reports.advanced.agentPerformance.export.button': 'Download',
  'reports.advanced.agentPerformance.export.headers.index': 'No.',
  'reports.advanced.agentPerformance.export.headers.agent': 'Agent',
  'reports.advanced.agentPerformance.export.headers.connectedEffective':
    'Connected: Effective',
  'reports.advanced.agentPerformance.export.headers.connectedVoicemail':
    'Connected: Voicemail',
  'reports.advanced.agentPerformance.export.headers.noAnswer': 'No answer',
  'reports.advanced.agentPerformance.export.headers.rejected': 'Rejected',
  'reports.advanced.agentPerformance.export.headers.total': 'Total',
  'reports.advanced.agentPerformance.export.headers.averageDuration':
    'Average duration',
  'reports.advanced.agentPerformance.export.headers.minutesTalked':
    'Minutes talked',
  'reports.advanced.agentPerformance.export.headers.leadCount': '# Leads',
  'reports.advanced.agentPerformance.export.headers.leadContactability':
    'Lead contactability (%)',
  'reports.advanced.agentPerformance.export.headers.callContactability':
    'Call contactability (%)',
  'reports.advanced.agentPerformance.export.headers.callsPerLead':
    '# Calls/lead',
  'reports.advanced.agentPerformance.export.headers.expertise': 'Expertise',
  'reports.advanced.agentPerformance.export.headers.confidence': 'Confidence',
  'reports.advanced.agentPerformance.export.headers.objections': 'Objections',
  'reports.advanced.agentPerformance.export.headers.closing': 'Closing',
  'reports.advanced.agentPerformance.export.headers.totalPerformance':
    'Total performance',
  'reports.advanced.agentPerformance.export.headers.team': 'Team',

  // Sidebar - Catalog Menu Items
  'sidebar.products': 'Products',
  'sidebar.properties': 'Properties',

  // Sidebar - Settings Menu Items
  'sidebar.settings-communications': 'Funnels',
  'sidebar.settings-properties': 'Properties',
  'settings.properties.title': 'Properties',
  'settings.properties.description':
    'Property settings for everyone in your company.',
  'settings.properties.code.invalid':
    'The saved preference is invalid. Comos codes are shown until you save a valid choice or reset to default.',
  'settings.properties.code.label': 'Property code to display',
  'settings.properties.code.comos': 'Comos code',
  'settings.properties.code.external': 'External code',
  'settings.properties.code.help':
    'Choose the code shown across Comos. When an external code is missing or conflicting, the Comos code appears with a subtle Comos label.',
  'settings.properties.code.error':
    'The setting could not be loaded or saved. Please try again.',
  'settings.properties.code.saved': 'Property code preference saved.',
  'settings.properties.noPermission':
    'You do not have permission to manage these settings.',
  'sidebar.settings-preferences': 'Preferences',
  'sidebar.settings-users': 'Users',
  'sidebar.settings-integrations': 'Integrations',
  'sidebar.settings-custom-fields': 'Custom fields',
  'sidebar.settings-credentials': 'Credentials',

  // Settings - Employees
  'settings.employees.title': 'AI Agents',
  'settings.employees.description':
    'Configure shared behavior for your AI agents.',
  'settings.employees.responseWait.title': 'Response timing',
  'settings.employees.responseWait.description':
    'Group nearby messages before responding.',
  'settings.employees.responseWait.label': 'Wait time before agent response',
  'settings.employees.responseWait.help':
    'Seconds to wait before responding. Used to batch nearby events and avoid duplicate replies.',
  'settings.employees.responseWait.rangeWarning':
    'Use a whole number between {min} and {max} seconds.',
  'settings.employees.actions.save': 'Save changes',
  'settings.employees.actions.cancel': 'Cancel',
  'settings.employees.actions.reset': 'Reset to default',
  'settings.employees.update.success': 'AI agent settings updated.',
  'settings.employees.update.error': 'Could not update AI agent settings.',
  'settings.employees.error.title': 'Unable to load AI agent settings',
  'settings.employees.error.description':
    'Please refresh the page or try again later.',
  'sidebar.settings-notifications': 'Notifications',
  'settings.preferences.title': 'Preferences',
  'settings.preferences.description':
    'Manage personal app behavior and browser-level defaults for how you work inside comOS.',
  'settings.preferences.sections.messaging.title': 'Messaging',
  'settings.preferences.sections.messaging.description':
    'Personal defaults for composing and handling conversations in this browser.',

  // Settings - Integrations
  'settings.integrations.title': 'Integrations',
  'settings.integrations.forbidden':
    'You do not have permission to view integrations.',
  'settings.integrations.notAvailable': '—',
  'settings.integrations.status.connected': 'Connected',
  'settings.integrations.status.disabled': 'Disabled',
  'settings.integrations.status.disconnected': 'Not connected',
  'settings.integrations.status.error': 'Error',
  'settings.integrations.health.healthy': 'Healthy',
  'settings.integrations.health.paused': 'Paused',
  'settings.integrations.health.error': 'Needs attention',
  'settings.integrations.health.syncing': 'Syncing',
  'settings.integrations.sync.startingSoon': 'Starting soon',
  'settings.integrations.index.description':
    'Connect the tools your team already uses with Comos and manage each integration from a dedicated page.',
  'settings.integrations.index.back': 'All integrations',
  'settings.integrations.activity.title': 'Recent activity',
  'settings.integrations.activity.empty':
    'There is no activity for this integration yet.',
  'shared.activitySection.title': 'Activity',
  'settings.integrations.syncSummary.lastSuccess': 'Sync',
  'settings.integrations.syncSummary.lastAttempt': 'Try',
  'settings.integrations.syncSummary.next': 'Next',
  'settings.integrations.syncSummary.pausedUntil': 'Paused',
  'settings.integrations.syncSummary.lastError': 'Error',
  'settings.integrations.sync.editBlockedWhileSyncing':
    'This integration is syncing. Please wait for it to finish before saving changes.',
  'settings.integrations.sidebar.sections': 'Sections',
  'settings.integrations.sidebar.messaging': 'Messaging',
  'settings.integrations.sidebar.whatsapp': 'WhatsApp',
  'settings.integrations.sidebar.realEstate': 'Real estate',
  'settings.integrations.sidebar.realEstateProviders': 'Properties',
  'settings.integrations.whatsapp.title': 'WhatsApp',
  'settings.integrations.whatsapp.description':
    'Connect your Meta business portfolio so Comos can send and receive WhatsApp messages.',
  'settings.integrations.whatsapp.actions.connect': 'Connect with Facebook',
  'settings.integrations.whatsapp.actions.connectShort': 'Connect',
  'settings.integrations.whatsapp.warning.keepTabOpen':
    'When you start, a Meta window will open. Keep this tab open until Comos confirms the connection.',
  'settings.integrations.whatsapp.warning.adminRequired':
    'You need admin permissions to connect a Meta account.',
  'settings.integrations.whatsapp.warning.solutionAssociationVerification':
    'This account needs attention before it can be used. Follow the guidance below or contact Comos support.',
  'settings.integrations.whatsapp.warning.managedFunding':
    'This account uses Comos-managed billing. Contact Comos support if you need help with WhatsApp charges.',
  'settings.integrations.whatsapp.warning.managedDeletionBlocked':
    'This account uses Comos-managed billing. Contact Comos support to change billing or disconnect it.',
  'settings.integrations.whatsapp.billing.title': 'WhatsApp account billing',
  'settings.integrations.whatsapp.billing.label':
    'Use the Comos-managed credit line',
  'settings.integrations.whatsapp.billing.helper':
    'Enable, then complete Connect with Facebook to add a new account or move an existing account to Comos-managed billing. Changing this setting alone does not change connected accounts; disabling it does not remove managed billing.',
  'settings.integrations.whatsapp.billing.loading':
    'Loading WhatsApp billing policy',
  'settings.integrations.whatsapp.billing.loadError':
    'Comos could not load the billing policy. Managed billing remains unavailable until you retry.',
  'settings.integrations.whatsapp.billing.updateSuccess':
    'WhatsApp billing policy updated.',
  'settings.integrations.whatsapp.billing.updateError':
    'Comos could not update the billing policy. Reloaded the latest saved value; please try again.',
  'settings.integrations.whatsapp.errors.configuration':
    'The managed billing configuration is incomplete. The Meta signup window was not opened.',
  'settings.integrations.whatsapp.errors.onboardingConfiguration':
    'Comos could not prepare a secure WhatsApp onboarding attempt. No Meta window was opened; please try again.',
  'settings.integrations.whatsapp.errors.finalization':
    'Comos could not finish setup. Check this account below and follow its next step. If it already shows as connected, you do not need to connect it again.',
  'settings.integrations.whatsapp.errors.delete':
    'We could not finish disconnecting this account. Contact Comos support if trying again does not help.',
  'settings.integrations.whatsapp.errors.incompleteSession':
    'Meta did not return all the account information required to finish connecting WhatsApp. Please try again or contact support.',
  'settings.integrations.whatsapp.errors.unsupportedCompletion':
    'This WhatsApp signup flow is not supported yet. No partial integration was saved.',
  'settings.integrations.whatsapp.errors.metaSignup':
    'Meta could not complete WhatsApp signup. Please review the information in the signup window and try again.',
  'settings.integrations.whatsapp.errors.signupCancelled':
    'WhatsApp connection was cancelled. No changes were saved; you can try again when ready.',
  'settings.integrations.whatsapp.errors.signupTimeout':
    'The Meta window did not finish in time. Close any Meta signup window that is still open before trying again. No partial connection was saved.',
  'settings.integrations.whatsapp.progress.title': 'Connecting WhatsApp',
  'settings.integrations.whatsapp.progress.subtitle':
    'Keep this Comos tab open until both steps are complete.',
  'settings.integrations.whatsapp.progress.meta.label':
    'Complete the steps in Meta',
  'settings.integrations.whatsapp.progress.meta.active':
    'Complete every step in the Meta window, then click Finish on its final screen.',
  'settings.integrations.whatsapp.progress.meta.complete':
    'Meta returned the account details successfully.',
  'settings.integrations.whatsapp.progress.meta.notice':
    'To complete the connection, click Finish in Meta and wait for Comos. To cancel, close this dialog. Permissions already granted in Meta are not revoked.',
  'settings.integrations.whatsapp.progress.finalizing.label':
    'Let Comos finish the connection',
  'settings.integrations.whatsapp.progress.finalizing.pending':
    'This starts automatically after Meta is complete.',
  'settings.integrations.whatsapp.progress.finalizing.active':
    'Comos is configuring the account, phone numbers, and webhooks.',
  'settings.integrations.whatsapp.progress.finalizing.notice':
    'Comos is finishing the connection. Keep this tab open until you see the confirmation.',
  'settings.integrations.whatsapp.connection.linked': 'Integration linked',
  'settings.integrations.whatsapp.connection.created':
    'WhatsApp integration created successfully.',
  'settings.integrations.whatsapp.connection.quarantinedSaved':
    'The WhatsApp account was saved for review. Messaging remains blocked.',
  'settings.integrations.whatsapp.connection.provider': 'Provider',
  'settings.integrations.whatsapp.connection.id': 'Identifier',
  'settings.integrations.whatsapp.connection.activatedAt': 'Activated at',
  'settings.integrations.whatsapp.accounts.title': 'Connected accounts',
  'settings.integrations.whatsapp.accounts.defaultName': 'WhatsApp Business',
  'settings.integrations.whatsapp.errors.tenantUnavailable':
    'Your workspace is unavailable. Reload the page and try again.',
  'settings.integrations.whatsapp.accounts.identifier': 'ID: {id}',
  'settings.integrations.whatsapp.accounts.connectedAt': 'Connected on {date}',
  'settings.integrations.whatsapp.accounts.updatedAt': 'Updated on {date}',
  'settings.integrations.whatsapp.accounts.reason': 'Reason: {reason}',
  'settings.integrations.whatsapp.accounts.phoneCount':
    'Phone numbers ({count})',
  'settings.integrations.whatsapp.accounts.inactive': 'Inactive',
  'settings.integrations.whatsapp.accounts.connectedHeading':
    'Connected accounts ({count})',
  'settings.integrations.whatsapp.accounts.disconnectedHeading':
    'Disconnected accounts ({count})',
  'settings.integrations.whatsapp.accounts.emptyTitle':
    'No WhatsApp accounts connected',
  'settings.integrations.whatsapp.accounts.emptyDescription':
    'Use the “Connect with Facebook” button to add your first account',
  'settings.integrations.whatsapp.accounts.confirmRemoval':
    'Disconnect this account from Comos? You will no longer send or receive its messages in Comos. Your WhatsApp account and chat history will not be deleted.',
  'settings.integrations.whatsapp.accounts.confirmDisconnectedRemoval':
    'Finish disconnecting this account from Comos? Your WhatsApp account and chat history will not be deleted. If we cannot finish safely, we will keep the saved connection for support to help.',
  'settings.integrations.whatsapp.recovery.action': 'Verify connection',
  'communications.messageBox.whatsapp.connectionUnavailable':
    'This WhatsApp number is unavailable for sending. Check its connection in Settings → Integrations.',
  'communications.messageBox.whatsapp.availabilityError':
    'We could not verify this WhatsApp sender. Try again in a moment.',
  'communications.messageBox.whatsapp.openIntegrations': 'Open integrations',
  'communications.messageBox.whatsapp.queued': 'Queued',
  'communications.messageBox.whatsapp.sendError':
    'The message could not be sent. Please try again.',
  'settings.integrations.whatsapp.recovery.pending': 'Retrying setup…',
  'settings.integrations.whatsapp.recovery.helper':
    'Connection setup did not finish. Try again here; you do not need to repeat the Facebook steps.',
  'settings.integrations.whatsapp.recovery.success':
    'Your WhatsApp connection is ready.',
  'settings.integrations.whatsapp.recovery.error':
    'We could not finish setup. Check the account’s latest status below. If it still needs attention, contact Comos support.',
  'settings.integrations.whatsapp.recovery.importWarning':
    'Some contacts or past messages could not be imported. This is separate from your connection status. Contact Comos support if you need help with the import.',
  'settings.integrations.whatsapp.offboarding.title':
    'Need to change billing or disconnect?',
  'settings.integrations.whatsapp.offboarding.assisted':
    'To change who pays your WhatsApp charges or disconnect this account, contact Comos support using “I need help”. We’ll guide you through the process.',
  'settings.integrations.whatsapp.recovery.reconnect':
    'Comos cannot access this account. Use “Connect with Facebook” above to reconnect it. If Meta does not let you continue, contact Comos support.',
  'settings.integrations.whatsapp.recovery.support':
    'We need to check this account before setup can continue. Contact Comos support using “I need help”. You do not need to delete your WhatsApp account.',
  'settings.integrations.whatsapp.recovery.metaChange':
    'Meta reported a change to this account. Contact Comos support using “I need help” so we can help you reconnect safely.',
  'settings.integrations.whatsapp.recovery.adminRequired':
    'This connection needs attention. Ask someone who manages integrations in your workspace to help.',
  'settings.integrations.whatsapp.offboarding.pending':
    'Disconnection has not finished. Contact Comos support using “I need help” if you need assistance. Retrying connection setup will not complete disconnection.',
  'settings.integrations.whatsapp.phone.verified': 'Verified',
  'settings.integrations.whatsapp.phone.unverified': 'Unverified',
  'settings.integrations.whatsapp.phone.pending': 'Pending',
  'settings.integrations.whatsapp.phone.unknown': 'Unknown',
  'settings.integrations.whatsapp.phone.quality.high': 'High quality',
  'settings.integrations.whatsapp.phone.quality.medium': 'Medium quality',
  'settings.integrations.whatsapp.phone.quality.low': 'Low quality',
  'settings.integrations.whatsapp.phone.quality.unrated': 'Unrated',
  'settings.integrations.whatsapp.accounts.subtitle':
    'Manage your connected WhatsApp Business accounts and phone numbers.',
  'settings.integrations.whatsapp.accounts.connectedCount': '{count} connected',
  'settings.integrations.whatsapp.accounts.connectedCount.one':
    '{count} connected',
  'settings.integrations.whatsapp.accounts.connectedCount.other':
    '{count} connected',
  'settings.integrations.whatsapp.accounts.disconnectedCount':
    '{count} disconnected',
  'settings.integrations.whatsapp.accounts.disconnectedCount.one':
    '{count} disconnected',
  'settings.integrations.whatsapp.accounts.disconnectedCount.other':
    '{count} disconnected',
  'settings.integrations.realEstate.title': 'Properties',
  'settings.integrations.realEstate.description':
    'Connect a provider to import and keep your information in sync.',
  'settings.integrations.wasi.subtitle':
    'Connect Wasi via API to keep your properties in sync.',
  'settings.integrations.wasi.noCredentials':
    'No Wasi credentials available. Create an API key in Settings → Credentials, then come back to connect it.',
  'settings.integrations.wasi.companyId.label': 'id_company',
  'settings.integrations.wasi.companyId.placeholder': 'e.g. 12345',
  'settings.integrations.wasi.companyId.help':
    'Your company identifier in Wasi. You can find it in your Wasi account settings.',
  'settings.integrations.wasi.credential.label': 'Credential (API key)',
  'settings.integrations.wasi.credential.select': 'Select a credential',
  'settings.integrations.wasi.credential.actions.create.tooltip':
    'Add a new credential',
  'settings.integrations.wasi.credential.help':
    'Select the credential that contains your Wasi API key.',
  'settings.integrations.wasi.autoAssign.label': 'Auto-assignment',
  'settings.integrations.wasi.autoAssign.help':
    'Use the seller contact to associate Comos users automatically when there is a clear match.',
  'settings.integrations.wasi.syncMissingPolicy.label':
    'If a listing stops arriving',
  'settings.integrations.wasi.syncMissingPolicy.help':
    'Choose whether to keep it or disable it when it stops arriving from the integration.',
  'settings.integrations.wasi.syncMissingPolicy.option.upsert': 'Keep it',
  'settings.integrations.wasi.syncMissingPolicy.option.replace': 'Disable it',
  'settings.integrations.wasi.propertyScope.label': 'Which properties to sync',
  'settings.integrations.wasi.propertyScope.help':
    'Choose whether sync should consider all seller properties or only active ones.',
  'settings.integrations.wasi.propertyScope.option.all': 'All',
  'settings.integrations.wasi.propertyScope.option.active': 'Only active',
  'settings.integrations.wasi.autoSync.label.enabled': 'Syncing',
  'settings.integrations.wasi.autoSync.label.paused': 'Paused',
  'settings.integrations.wasi.syncFrequency.label': 'Frequency (minutes)',
  'settings.integrations.wasi.syncFrequency.help':
    'How often automatic sync runs. Minimum {min} minutes.',
  'settings.integrations.wasi.actions.connect': 'Connect',
  'settings.integrations.wasi.actions.connect.tooltip':
    'Connect using this API key and company id',
  'settings.integrations.wasi.actions.saveChanges': 'Save changes',
  'settings.integrations.wasi.actions.saveChanges.tooltip':
    'Save changes to this connection',
  'settings.integrations.wasi.actions.disconnect': 'Disconnect',
  'settings.integrations.wasi.actions.disconnect.tooltip':
    'Disconnect and stop automatic sync',
  'settings.integrations.wasi.actions.syncNow': 'Sync now',
  'settings.integrations.wasi.actions.syncNow.tooltip':
    'Start a sync right now',
  'settings.integrations.wasi.sync.lastSuccess': 'Last successful sync:',
  'settings.integrations.wasi.sync.lastAttempt': 'Last sync attempt:',
  'settings.integrations.wasi.sync.next': 'Next sync:',
  'settings.integrations.wasi.sync.pausedUntil': 'Paused until:',
  'settings.integrations.wasi.sync.lastError': 'Last error:',
  'settings.integrations.wasi.health.error.message':
    'There was a problem during sync. Check your credentials and configuration, then save changes.',
  'settings.integrations.wasi.health.error.messageWithDetails':
    'There was a problem during sync. Check your credentials and configuration, then save changes. Error detail: {message}.',
  'settings.integrations.wasi.health.error.cta': 'Fix connection',
  'settings.integrations.wasi.health.paused.message':
    'There was a temporary problem during sync. It will retry automatically.',
  'settings.integrations.wasi.health.paused.messageWithDetails':
    'There was a temporary problem during sync. It will retry automatically. Error detail: {message}.',
  'settings.integrations.wasi.disconnectDialog.title': 'Disconnect Wasi',
  'settings.integrations.wasi.disconnectDialog.description':
    'This will disconnect Wasi and stop future automatic syncs. You can reconnect at any time.',
  'settings.integrations.wasi.disconnectDialog.cancel': 'Cancel',
  'settings.integrations.wasi.disconnectDialog.confirm': 'Disconnect',
  'settings.integrations.wasi.disconnect.success': 'Wasi disconnected.',
  'settings.integrations.wasi.disconnect.error':
    'Could not disconnect Wasi. Please try again.',
  'settings.integrations.permissions.readRequired':
    'You do not have permission to view integrations.',

  'settings.integrations.meli.title': 'Mercado Libre',
  'settings.integrations.meli.subtitle':
    'Connect Mercado Libre to keep your properties in sync.',
  'settings.integrations.meli.connectedAccount.label': 'Connected account',
  'settings.integrations.meli.connectedAccount.loading':
    'Loading connected account…',
  'settings.integrations.meli.connectedAccount.loadError':
    'We could not verify which Mercado Libre account is currently connected.',
  'settings.integrations.meli.connectedAccount.mismatch':
    'The authorized account (ID {currentId}) differs from the configured account (ID {configuredId}). Reconnect Mercado Libre before syncing or publishing.',
  'settings.integrations.meli.actions.connect': 'Connect with MercadoLibre',
  'settings.integrations.meli.actions.connectShort': 'Connect',
  'settings.integrations.meli.actions.disconnect': 'Disconnect',
  'settings.integrations.meli.actions.syncNow': 'Sync now',
  'settings.integrations.meli.actions.reauthorize': 'Reauthorize Mercado Libre',
  'settings.integrations.meli.actions.retrySync': 'Retry synchronization',
  'settings.integrations.meli.health.authorizationFailed':
    'Mercado Libre could not renew authorization for this connection.',
  'settings.integrations.meli.health.permissionDenied':
    'Mercado Libre restricted access to this operation. Review your account permissions, then try again.',
  'settings.integrations.meli.actions.syncNow.success':
    'MercadoLibre sync requested successfully',
  'settings.integrations.meli.connect.started':
    'Mercado Libre authorization started. Complete it in the opened tab.',
  'settings.integrations.meli.connect.error':
    'Failed to start Mercado Libre authorization: {message}',
  'settings.integrations.meli.disconnected.help':
    'Click Connect to authorize Mercado Libre. You will be redirected to Mercado Libre to grant access.',
  'settings.integrations.meli.connected.help':
    'Mercado Libre is connected. Your properties will stay in sync.',
  'settings.integrations.meli.mode.label': 'Integration mode',
  'settings.integrations.meli.mode.description':
    'Choose whether Comos publishes listings or only syncs the existing Mercado Libre catalog.',
  'settings.integrations.meli.mode.options.publish': 'Publish from Comos',
  'settings.integrations.meli.mode.options.sync': 'Sync from Mercado Libre',
  'settings.integrations.meli.mode.save': 'Save',
  'settings.integrations.meli.mode.saveTooltip':
    'Save the current Mercado Libre configuration.',
  'settings.integrations.meli.mode.confirm.title':
    'Confirm integration mode change',
  'settings.integrations.meli.mode.confirm.toSyncDescription':
    'With "Sync" mode, Mercado Libre becomes the main source. Comos will only import your listings from Mercado Libre and won’t allow new listings to be published from here.',
  'settings.integrations.meli.mode.confirm.toPublishDescription':
    'With "Publish" mode, Comos becomes the main source. You’ll only be able to publish from Comos, and no new listings will be imported from Mercado Libre except those already linked.',
  'settings.integrations.meli.mode.confirm.warning':
    'Choose "Sync" if you still manage your properties in Mercado Libre. Choose "Publish" if you prefer to manage and update your listings directly in Comos.',
  'settings.integrations.meli.mode.confirm.cancel': 'Cancel',
  'settings.integrations.meli.mode.confirm.confirm': 'Confirm and save',
  'settings.integrations.meli.mode.saved': 'Mercado Libre mode updated.',
  'settings.integrations.meli.mode.error':
    'Could not update Mercado Libre mode: {message}',
  'settings.integrations.meli.mode.missingCredential':
    'Mercado Libre is missing a credential. Reconnect the integration.',
  'settings.integrations.meli.autoAssign.label': 'Auto-assignment',
  'settings.integrations.meli.autoAssign.help':
    'Use the seller contact to associate Comos users automatically when there is a clear match.',
  'settings.integrations.meli.syncMissingPolicy.label':
    'If a listing stops arriving',
  'settings.integrations.meli.syncMissingPolicy.help':
    'Choose whether to keep it or disable it when it stops arriving from Mercado Libre.',
  'settings.integrations.meli.syncMissingPolicy.option.upsert': 'Keep it',
  'settings.integrations.meli.syncMissingPolicy.option.replace': 'Disable it',
  'settings.integrations.meli.propertyScope.label': 'Which listings to sync',
  'settings.integrations.meli.propertyScope.help':
    'Choose whether sync should consider all seller listings or only active ones.',
  'settings.integrations.meli.propertyScope.option.all': 'All',
  'settings.integrations.meli.propertyScope.option.active': 'Only active',
  'settings.integrations.meli.sellerContactWhatsApp.label': 'Contact WhatsApp',
  'settings.integrations.meli.sellerContactWhatsApp.select':
    'Select a WhatsApp account',
  'settings.integrations.meli.sellerContactWhatsApp.help':
    'This central account is published with the assigned property user’s name and email.',
  'settings.integrations.meli.sellerContactWhatsApp.loading':
    'Loading connected WhatsApp accounts…',
  'settings.integrations.meli.sellerContactWhatsApp.loadError':
    'Connected WhatsApp accounts could not be loaded. Retry before publishing to Mercado Libre.',
  'settings.integrations.meli.sellerContactWhatsApp.emailOnly':
    'No WhatsApp accounts are connected. Listings will use only the assigned user’s name and email.',
  'settings.integrations.meli.sellerContactWhatsApp.required':
    'Multiple accounts are connected. Select the one to publish on Mercado Libre.',
  'settings.integrations.meli.sellerContactWhatsApp.stale':
    'The selected WhatsApp account is no longer connected. Connect a WhatsApp account before publishing.',
  'settings.integrations.meli.sellerContactWhatsApp.staleWithConnectedAccounts':
    'The selected WhatsApp account is no longer connected. Select another connected account before publishing.',
  'settings.integrations.meli.disconnect.title': 'Disconnect Mercado Libre',
  'settings.integrations.meli.disconnect.description':
    'This will disconnect Mercado Libre and stop future automatic syncs. You can reconnect at any time.',
  'settings.integrations.meli.disconnect.confirm': 'Disconnect',
  'settings.integrations.meli.disconnect.cancel': 'Cancel',
  'settings.integrations.meli.disconnect.success':
    'Mercado Libre integration disconnected.',
  'settings.integrations.meli.disconnect.error':
    'Failed to disconnect Mercado Libre: {message}',
  'settings.integrations.wasi.title': 'Wasi',
  'settings.integrations.2clics.title': '2clics',
  'settings.integrations.2clics.subtitle':
    'Import your properties from 2clics (API)',
  'settings.integrations.2clics.noCredentials':
    'No 2clics credentials available. Create an API key in Settings → Credentials, then come back to connect it.',
  'settings.integrations.2clics.credential.label': 'Credential (API key)',
  'settings.integrations.2clics.credential.select': 'Select a credential',
  'settings.integrations.2clics.credential.actions.create.tooltip':
    'Add a new credential',
  'settings.integrations.2clics.credential.help':
    'Select the credential that contains your 2clics API key.',
  'settings.integrations.2clics.autoAssign.label': 'Auto-assignment',
  'settings.integrations.2clics.autoAssign.help':
    'Use the seller contact to associate Comos users automatically when there is a clear match.',
  'settings.integrations.2clics.syncMissingPolicy.label':
    'If a listing stops arriving',
  'settings.integrations.2clics.syncMissingPolicy.help':
    'Choose whether to keep it or disable it when it stops arriving from the integration.',
  'settings.integrations.2clics.syncMissingPolicy.option.upsert': 'Keep it',
  'settings.integrations.2clics.syncMissingPolicy.option.replace': 'Disable it',
  'settings.integrations.2clics.propertyScope.label':
    'Which properties to sync',
  'settings.integrations.2clics.propertyScope.help':
    'Choose whether sync should consider all seller properties or only active ones.',
  'settings.integrations.2clics.propertyScope.option.all': 'All',
  'settings.integrations.2clics.propertyScope.option.active': 'Only active',
  'settings.integrations.2clics.autoSync.label.enabled': 'Syncing',
  'settings.integrations.2clics.autoSync.label.paused': 'Paused',
  'settings.integrations.2clics.syncFrequency.label': 'Frequency (minutes)',
  'settings.integrations.2clics.syncFrequency.help':
    'How often automatic sync runs. Minimum {min} minutes.',
  'settings.integrations.2clics.actions.connect': 'Connect',
  'settings.integrations.2clics.actions.connect.tooltip':
    'Connect using this API key',
  'settings.integrations.2clics.actions.saveChanges': 'Save changes',
  'settings.integrations.2clics.actions.saveChanges.tooltip':
    'Save changes to this connection',
  'settings.integrations.2clics.actions.disconnect': 'Disconnect',
  'settings.integrations.2clics.actions.disconnect.tooltip':
    'Disconnect and stop automatic sync',
  'settings.integrations.2clics.actions.syncNow': 'Sync now',
  'settings.integrations.2clics.actions.syncNow.tooltip':
    'Start a sync right now',
  'settings.integrations.2clics.sync.lastSuccess': 'Last successful sync:',
  'settings.integrations.2clics.sync.lastAttempt': 'Last sync attempt:',
  'settings.integrations.2clics.sync.next': 'Next sync:',
  'settings.integrations.2clics.sync.pausedUntil': 'Paused until:',
  'settings.integrations.2clics.sync.lastError': 'Last error:',
  'settings.integrations.2clics.health.error.message':
    'There was a problem during sync. Check your credentials and configuration, then save changes.',
  'settings.integrations.2clics.health.error.messageWithDetails':
    'There was a problem during sync. Check your credentials and configuration, then save changes. Error detail: {message}.',
  'settings.integrations.2clics.health.error.cta': 'Fix connection',
  'settings.integrations.2clics.health.paused.message':
    'There was a temporary problem during sync. It will retry automatically.',
  'settings.integrations.2clics.health.paused.messageWithDetails':
    'There was a temporary problem during sync. It will retry automatically. Error detail: {message}.',
  'settings.integrations.2clics.disconnectDialog.title': 'Disconnect 2clics',
  'settings.integrations.2clics.disconnectDialog.description':
    'This will disconnect 2clics and stop future automatic syncs. You can reconnect at any time.',
  'settings.integrations.2clics.disconnectDialog.cancel': 'Cancel',
  'settings.integrations.2clics.disconnectDialog.confirm': 'Disconnect',
  'settings.integrations.2clics.disconnect.success': '2clics disconnected.',
  'settings.integrations.2clics.disconnect.error':
    'Could not disconnect 2clics. Please try again.',
  'settings.integrations.toppropiedades.title': 'Top Propiedades',
  'settings.integrations.toppropiedades.subtitle':
    'Import your properties from TopPropiedades (API)',
  'settings.integrations.toppropiedades.noCredentials':
    'No TopPropiedades credentials available. Create a bearer token in Settings → Credentials, then come back to connect it.',
  'settings.integrations.toppropiedades.credential.label':
    'Credential (bearer token)',
  'settings.integrations.toppropiedades.credential.select':
    'Select a credential',
  'settings.integrations.toppropiedades.credential.actions.create.tooltip':
    'Add a new credential',
  'settings.integrations.toppropiedades.credential.help':
    'Select the credential that contains your TopPropiedades bearer token.',
  'settings.integrations.toppropiedades.autoAssign.label': 'Auto-assignment',
  'settings.integrations.toppropiedades.autoAssign.help':
    'Use the seller contact to associate Comos users automatically when there is a clear match.',
  'settings.integrations.toppropiedades.syncMissingPolicy.label':
    'If a listing stops arriving',
  'settings.integrations.toppropiedades.syncMissingPolicy.help':
    'Choose whether to keep it or disable it when it stops arriving from the integration.',
  'settings.integrations.toppropiedades.syncMissingPolicy.option.upsert':
    'Keep it',
  'settings.integrations.toppropiedades.syncMissingPolicy.option.replace':
    'Disable it',
  'settings.integrations.toppropiedades.propertyScope.label':
    'Which properties to sync',
  'settings.integrations.toppropiedades.propertyScope.help':
    'Choose whether sync should consider all seller properties or only active ones.',
  'settings.integrations.toppropiedades.propertyScope.option.all': 'All',
  'settings.integrations.toppropiedades.propertyScope.option.active':
    'Only active',
  'settings.integrations.toppropiedades.autoSync.label.enabled': 'Syncing',
  'settings.integrations.toppropiedades.autoSync.label.paused': 'Paused',
  'settings.integrations.toppropiedades.syncFrequency.label':
    'Frequency (minutes)',
  'settings.integrations.toppropiedades.syncFrequency.help':
    'How often automatic sync runs. Minimum {min} minutes.',
  'settings.integrations.toppropiedades.actions.connect': 'Connect',
  'settings.integrations.toppropiedades.actions.connect.tooltip':
    'Connect using this bearer token',
  'settings.integrations.toppropiedades.actions.saveChanges': 'Save changes',
  'settings.integrations.toppropiedades.actions.saveChanges.tooltip':
    'Save changes to this connection',
  'settings.integrations.toppropiedades.actions.disconnect': 'Disconnect',
  'settings.integrations.toppropiedades.actions.disconnect.tooltip':
    'Disconnect and stop automatic sync',
  'settings.integrations.toppropiedades.actions.syncNow': 'Sync now',
  'settings.integrations.toppropiedades.actions.syncNow.tooltip':
    'Start a sync right now',
  'settings.integrations.toppropiedades.sync.lastSuccess':
    'Last successful sync:',
  'settings.integrations.toppropiedades.sync.lastAttempt': 'Last sync attempt:',
  'settings.integrations.toppropiedades.sync.next': 'Next sync:',
  'settings.integrations.toppropiedades.sync.pausedUntil': 'Paused until:',
  'settings.integrations.toppropiedades.sync.lastError': 'Last error:',
  'settings.integrations.toppropiedades.health.error.message':
    'There was a problem during sync. Check your credentials and configuration, then save changes.',
  'settings.integrations.toppropiedades.health.error.messageWithDetails':
    'There was a problem during sync. Check your credentials and configuration, then save changes. Error detail: {message}.',
  'settings.integrations.toppropiedades.health.error.cta': 'Fix connection',
  'settings.integrations.toppropiedades.health.paused.message':
    'There was a temporary problem during sync. It will retry automatically.',
  'settings.integrations.toppropiedades.health.paused.messageWithDetails':
    'There was a temporary problem during sync. It will retry automatically. Error detail: {message}.',
  'settings.integrations.toppropiedades.disconnectDialog.title':
    'Disconnect TopPropiedades',
  'settings.integrations.toppropiedades.disconnectDialog.description':
    'This will disconnect TopPropiedades and stop future automatic syncs. You can reconnect at any time.',
  'settings.integrations.toppropiedades.disconnectDialog.cancel': 'Cancel',
  'settings.integrations.toppropiedades.disconnectDialog.confirm': 'Disconnect',
  'settings.integrations.toppropiedades.disconnect.success':
    'TopPropiedades disconnected.',
  'settings.integrations.toppropiedades.disconnect.error':
    'Could not disconnect TopPropiedades. Please try again.',
  'settings.integrations.kiteprop.title': 'KiteProp',
  'settings.integrations.kiteprop.subtitle':
    'Import your properties from KiteProp (API)',
  'settings.integrations.kiteprop.noCredentials':
    'No KiteProp credentials available. Create an API key in Settings → Credentials, then come back to connect it.',
  'settings.integrations.kiteprop.credential.label': 'Credential (API key)',
  'settings.integrations.kiteprop.credential.select': 'Select a credential',
  'settings.integrations.kiteprop.credential.actions.create.tooltip':
    'Add a new credential',
  'settings.integrations.kiteprop.credential.help':
    'Select the credential that contains your KiteProp API key.',
  'settings.integrations.kiteprop.autoAssign.label': 'Auto-assignment',
  'settings.integrations.kiteprop.autoAssign.help':
    'Use the listing agent to associate Comos users automatically when there is a clear match.',
  'settings.integrations.kiteprop.syncMissingPolicy.label':
    'If a listing stops arriving',
  'settings.integrations.kiteprop.syncMissingPolicy.help':
    'Choose whether to keep it or disable it when it stops arriving from the integration.',
  'settings.integrations.kiteprop.syncMissingPolicy.option.upsert': 'Keep it',
  'settings.integrations.kiteprop.syncMissingPolicy.option.replace':
    'Disable it',
  'settings.integrations.kiteprop.propertyScope.label':
    'Which properties to sync',
  'settings.integrations.kiteprop.propertyScope.help':
    'Choose whether sync should consider all KiteProp properties or only active ones.',
  'settings.integrations.kiteprop.propertyScope.option.all': 'All',
  'settings.integrations.kiteprop.propertyScope.option.active': 'Only active',
  'settings.integrations.kiteprop.autoSync.label.enabled': 'Syncing',
  'settings.integrations.kiteprop.autoSync.label.paused': 'Paused',
  'settings.integrations.kiteprop.syncFrequency.label': 'Frequency (minutes)',
  'settings.integrations.kiteprop.syncFrequency.help':
    'How often automatic sync runs. Minimum {min} minutes.',
  'settings.integrations.kiteprop.actions.connect': 'Connect',
  'settings.integrations.kiteprop.actions.connect.tooltip':
    'Connect using this API key',
  'settings.integrations.kiteprop.actions.saveChanges': 'Save changes',
  'settings.integrations.kiteprop.actions.saveChanges.tooltip':
    'Save changes to this connection',
  'settings.integrations.kiteprop.actions.disconnect': 'Disconnect',
  'settings.integrations.kiteprop.actions.disconnect.tooltip':
    'Disconnect and stop automatic sync',
  'settings.integrations.kiteprop.actions.syncNow': 'Sync now',
  'settings.integrations.kiteprop.actions.syncNow.tooltip':
    'Start a sync right now',
  'settings.integrations.kiteprop.sync.lastSuccess': 'Last successful sync:',
  'settings.integrations.kiteprop.sync.lastAttempt': 'Last sync attempt:',
  'settings.integrations.kiteprop.sync.next': 'Next sync:',
  'settings.integrations.kiteprop.sync.pausedUntil': 'Paused until:',
  'settings.integrations.kiteprop.sync.lastError': 'Last error:',
  'settings.integrations.kiteprop.health.error.message':
    'There was a problem during sync. Check your credentials and configuration, then save changes.',
  'settings.integrations.kiteprop.health.error.messageWithDetails':
    'There was a problem during sync. Check your credentials and configuration, then save changes. Error detail: {message}.',
  'settings.integrations.kiteprop.health.error.cta': 'Fix connection',
  'settings.integrations.kiteprop.health.paused.message':
    'There was a temporary problem during sync. It will retry automatically.',
  'settings.integrations.kiteprop.health.paused.messageWithDetails':
    'There was a temporary problem during sync. It will retry automatically. Error detail: {message}.',
  'settings.integrations.kiteprop.disconnectDialog.title':
    'Disconnect KiteProp',
  'settings.integrations.kiteprop.disconnectDialog.description':
    'This will disconnect KiteProp and stop future automatic syncs. You can reconnect at any time.',
  'settings.integrations.kiteprop.disconnectDialog.cancel': 'Cancel',
  'settings.integrations.kiteprop.disconnectDialog.confirm': 'Disconnect',
  'settings.integrations.kiteprop.disconnect.success': 'KiteProp disconnected.',
  'settings.integrations.kiteprop.disconnect.error':
    'Could not disconnect KiteProp. Please try again.',

  // Tools
  'tools.toolConfig.aliasPlaceholder.listProperties': 'Ex: List properties',

  // Settings - Funnels
  'settings.funnels.statusDelete.confirm.title': 'Confirm deletion',
  'settings.funnels.statusDelete.confirm.body':
    'Do you want to delete this funnel status?',
  'settings.funnels.statusDelete.error.linkedConversations':
    'You cannot delete this status because it has associated conversations. Reassign those conversations to another status before deleting it.',
  'settings.funnels.statusDescription.example.main':
    '\n1. Greet and confirm the reason\n\t- If they mention a property, schedule a visit and continue to step 2\n\t- If they do not mention one, ask for area, budget, name, and phone number\n2. Review requirements\n\t- If they qualify, move the conversation to the "Management" stage\n\t- If they do not qualify, move the conversation to the "Unqualified" stage',

  // Settings - Credentials
  'settings.credentials.title': 'Credentials',
  'settings.credentials.create.button': 'New credential',
  'settings.credentials.all': 'All kinds',
  'settings.credentials.yes': 'Yes',
  'settings.credentials.no': 'No',
  'settings.credentials.loading': 'Loading…',
  'settings.credentials.loadingMore': 'Loading more…',
  'settings.credentials.empty': 'No credentials yet.',
  'settings.credentials.forbidden.title': 'No access',
  'settings.credentials.forbidden.description':
    'You do not have permission to view credentials.',
  'settings.credentials.error.title': 'Something went wrong',
  'settings.credentials.error.description':
    'We could not load your credentials.',
  'settings.credentials.error.retry': 'Retry',
  'settings.credentials.alerts.created': 'Credential created.',
  'settings.credentials.alerts.updated': 'Credential updated.',
  'settings.credentials.alerts.rotated': 'Secret updated.',
  'settings.credentials.alerts.deleted': 'Credential deleted.',
  'settings.credentials.alerts.error': 'Something went wrong.',
  'settings.credentials.filters.kind': 'Kind',
  'settings.credentials.filters.clear': 'Clear',
  'settings.credentials.provider.select': 'Select provider',
  'settings.credentials.provider.other': 'Other',
  'settings.credentials.provider.prop360': 'Prop360',
  'settings.credentials.provider.kutt': 'Kutt',
  'settings.credentials.provider.2clics': '2clics',
  'settings.credentials.provider.toppropiedades': 'TopPropiedades',
  'settings.credentials.provider.kiteprop': 'KiteProp',
  'settings.credentials.provider.wasi': 'Wasi',
  'settings.credentials.provider.mercadolibre': 'Mercado Libre',
  'settings.credentials.kind.apiKey': 'API key',
  'settings.credentials.kind.bearer': 'Bearer token',
  'settings.credentials.kind.basic': 'Basic (username/password)',
  'settings.credentials.kind.custom': 'Custom (JSON)',
  'settings.credentials.kind.oauth': 'OAuth',
  'settings.credentials.status.active': 'Active',
  'settings.credentials.status.disabled': 'Disabled',
  'settings.credentials.table.name': 'Name',
  'settings.credentials.table.provider': 'Provider',
  'settings.credentials.table.kind': 'Kind',
  'settings.credentials.table.status': 'Status',
  'settings.credentials.table.shared': 'Shared',
  'settings.credentials.table.actions': 'Actions',
  'settings.credentials.table.emptyState.title': 'No credentials found',
  'settings.credentials.table.emptyState.description':
    'Create a credential to start using integrations.',
  'settings.credentials.actions.edit': 'Edit',
  'settings.credentials.actions.rotate': 'Update secret',
  'settings.credentials.actions.delete': 'Delete',
  'settings.credentials.actions.revealSecret': 'Reveal secret',
  'settings.credentials.actions.cancel': 'Cancel',
  'settings.credentials.actions.create': 'Create',
  'settings.credentials.actions.save': 'Save',
  'settings.credentials.actions.close': 'Close',
  'settings.credentials.create.title': 'New credential',
  'settings.credentials.edit.title': 'Edit credential',
  'settings.credentials.rotate.title': 'Update secret',
  'settings.credentials.reveal.title': 'Reveal secret',
  'settings.credentials.provider.all': 'All providers',
  'settings.credentials.delete.title': 'Delete credential',
  'settings.credentials.delete.warning': 'This action cannot be undone.',
  'settings.credentials.form.provider': 'Provider',
  'settings.credentials.form.name': 'Name',
  'settings.credentials.form.kind': 'Kind',
  'settings.credentials.form.status': 'Status',
  'settings.credentials.form.sharedWithTenant': 'Shared with tenant',
  'settings.credentials.form.sharedWithUsers': 'Shared with other users',
  'settings.credentials.form.sharedInfo':
    'Other users can use this credential, but they will not be able to see the secret.',
  'settings.credentials.form.encryptionInfo':
    'Credentials are stored encrypted and securely. For your security, secrets are never displayed after you save them — you can update the secret at any time.',
  'settings.credentials.reveal.warning':
    'This is sensitive information. Do not share it. Secrets are stored encrypted and access is restricted to super admins.',
  'settings.credentials.form.otherProvider': 'Provider ID',
  'settings.credentials.form.otherProviderPlaceholder':
    "e.g. 'hubspot', 'pipedrive'",
  'settings.credentials.form.apiKey': 'API key',
  'settings.credentials.form.bearerToken': 'Bearer token',
  'settings.credentials.form.username': 'Username',
  'settings.credentials.form.password': 'Password',
  'settings.credentials.form.secretJson': 'Secret (JSON object)',
  'settings.credentials.validation.required': 'Required',
  'settings.credentials.validation.jsonObject': 'Must be a JSON object',
  'settings.notifications.title': 'Notifications',
  'settings.notifications.inApp.title': 'Website preferences',
  'settings.notifications.inApp.alert': 'Alert type',
  'settings.notifications.inApp.alert.helper':
    'Choose between a banner alert or badge-only.',
  'settings.notifications.inApp.alert.option.alert': 'Banner alert',
  'settings.notifications.inApp.alert.option.badge': 'Badge only',
  'settings.notifications.inApp.sound': 'Sound',
  'settings.notifications.inApp.sound.helper':
    'Choose whether to play a sound for new notifications.',
  'settings.notifications.inApp.sound.option.on': 'Play sound',
  'settings.notifications.inApp.sound.option.off': 'No sound',
  'settings.notifications.alerts.updated': 'Notification preferences updated.',
  'settings.notifications.alerts.error': 'Something went wrong.',
  'settings.notifications.error.title': 'Something went wrong',
  'settings.notifications.error.description':
    'Unable to load notification preferences.',
  'settings.notifications.error.retry': 'Retry',
  'settings.notifications.description':
    'Control alerts, device routing, and quiet hours for notifications.',
  'settings.notifications.actions.save': 'Save changes',
  'settings.notifications.actions.reset': 'Reset',
  'settings.notifications.sections.inApp.description':
    'Choose whether the website shows alerts or plays a sound.',
  'settings.notifications.sections.app.title': 'Website notifications',
  'settings.notifications.sections.app.description':
    'Defaults for alerts, sounds, and website activity.',
  'settings.notifications.sections.app.toggle': 'Enable website notifications',
  'settings.notifications.sections.app.advanced.toggle':
    'Show advanced settings',
  'settings.preferences.messaging.writing.title': 'Enter ↵ to send',
  'settings.preferences.messaging.writing.description':
    'Turn this off to insert a new line when pressing Enter.',
  'settings.preferences.messaging.writing.helper':
    'This preference is saved immediately in this browser. Automatic uses newline on touch-first devices.',
  'settings.preferences.messaging.writing.options.auto': 'Automatic',
  'settings.preferences.messaging.writing.options.send': 'Send message',
  'settings.preferences.messaging.writing.options.newline': 'New line',
  'settings.notifications.sections.marketing.title': 'Marketing notifications',
  'settings.notifications.sections.marketing.description':
    'Enable announcements and product updates.',
  'settings.notifications.sections.marketing.toggle': 'Enable marketing alerts',
  'settings.notifications.sections.marketing.advanced.toggle':
    'Show advanced settings',
  'settings.notifications.sections.advanced.title': 'Advanced settings',
  'settings.notifications.sections.advanced.description':
    'Fine-tune event rules and quiet hours.',
  'settings.notifications.sections.channels.title': 'Channel preferences',
  'settings.notifications.sections.channels.description':
    'Decide which channels can notify you.',
  'settings.notifications.sections.routing.title': 'Device routing',
  'settings.notifications.sections.routing.description':
    'Choose which device receives notifications.',
  'settings.notifications.sections.dnd.title': 'Do Not Disturb',
  'settings.notifications.sections.dnd.description':
    'Quiet hours and exceptions.',
  'settings.notifications.eventRules.title': 'Event rules',
  'settings.notifications.eventRules.description':
    'Override defaults for specific notification events.',
  'settings.notifications.eventRules.loading': 'Loading event catalog…',
  'settings.notifications.eventRules.error':
    'Unable to load event definitions.',
  'settings.notifications.eventRules.empty': 'No events available yet.',
  'settings.notifications.eventRules.group.app': 'Website events',
  'settings.notifications.eventRules.group.marketing': 'Marketing events',
  'settings.notifications.eventRules.enabled': 'Enabled',
  'settings.notifications.eventRules.alert.label': 'Alert override',
  'settings.notifications.eventRules.alert.inherit': 'Use default',
  'settings.notifications.eventRules.alert.alert': 'Show alert',
  'settings.notifications.eventRules.alert.badge': 'Badge only',
  'settings.notifications.eventRules.sound.label': 'Sound override',
  'settings.notifications.eventRules.sound.inherit': 'Use default',
  'settings.notifications.eventRules.sound.on': 'Play sound',
  'settings.notifications.eventRules.sound.off': 'No sound',
  'settings.notifications.eventRules.deliveryChannels.label':
    'Delivery channels',
  'settings.notifications.eventRules.deliveryChannels.phoneRequired':
    'Add a phone number to enable WhatsApp or SMS notifications.',
  'settings.notifications.deliveryChannels.inApp': 'Website (in-app)',
  'settings.notifications.deliveryChannels.push': 'Push notification',
  'settings.notifications.deliveryChannels.email': 'Email',
  'settings.notifications.deliveryChannels.sms': 'SMS',
  'settings.notifications.deliveryChannels.whatsapp': 'WhatsApp',
  'settings.notifications.eventRules.deviceRouting.title': 'Device routing',
  'settings.notifications.eventRules.deviceRouting.description':
    'Override which device receives this event.',
  'settings.notifications.eventRules.deviceRouting.mode.label':
    'Device selection',
  'settings.notifications.eventRules.deviceRouting.mode.inherit':
    'Use global routing',
  'settings.notifications.eventRules.deviceRouting.primaryEndpoint.helper':
    'Used only when device selection is Primary device only.',
  'notifications.events.messaging.message.received.label': 'New message',
  'notifications.events.messaging.message.received.description':
    'Incoming message assigned to you.',
  'notifications.events.conversation.escalated.label': 'Conversation escalated',
  'notifications.events.conversation.escalated.description':
    'An employee needs human assistance with a contact.',
  'notifications.events.conversation.marked-ready-to-visit.label':
    'Contact ready to schedule visit',
  'notifications.events.conversation.marked-ready-to-visit.description':
    'An employee handed off a contact ready to schedule a visit.',
  'notifications.events.conversation.table-export.ready.label':
    'Conversation export ready',
  'notifications.events.conversation.table-export.ready.description':
    'Your conversations table export is ready to download.',
  'notifications.events.marketing.campaign.dispatch.label':
    'Marketing campaign',
  'notifications.events.marketing.campaign.dispatch.description':
    'Product announcements and marketing updates.',
  'settings.notifications.channels.messaging': 'Messaging',
  'settings.notifications.channels.marketing': 'Marketing',
  'settings.notifications.channels.calls': 'Calls',
  'settings.notifications.routing.mode.label': 'Device selection',
  'settings.notifications.routing.advanced.toggle': 'Show advanced settings',
  'settings.notifications.routing.advanced.title': 'Device overrides by event',
  'settings.notifications.routing.advanced.description':
    'Customize which device receives specific events.',
  'settings.notifications.routing.primaryEndpoint': 'Primary device',
  'settings.notifications.routing.primaryEndpoint.placeholder':
    'Select a primary device',
  'settings.notifications.routing.primaryEndpoint.none': 'No primary device',
  'settings.notifications.routing.primaryEndpoint.empty':
    'No devices registered yet.',
  'settings.notifications.routing.primaryEndpoint.error':
    'Unable to load registered devices.',
  'settings.notifications.routing.primaryEndpoint.helper':
    'Used only when routing mode is Primary device only.',
  'settings.notifications.routing.mode.lastActive': 'Last active device',
  'settings.notifications.routing.mode.ringAll': 'Notify all devices',
  'settings.notifications.routing.mode.primaryOnly': 'Primary device only',
  'settings.notifications.dnd.enabled': 'Enable DND',
  'settings.notifications.dnd.timezone': 'Timezone',
  'settings.notifications.dnd.timezone.placeholder': 'America/Mexico_City',
  'settings.notifications.dnd.snoozeUntil': 'Snooze until',
  'settings.notifications.dnd.behavior.default': 'Default behavior',
  'settings.notifications.dnd.behavior.messaging':
    'Messaging behavior override',
  'settings.notifications.dnd.behavior.marketing':
    'Marketing behavior override',
  'settings.notifications.dnd.behavior.calls': 'Calls behavior override',
  'settings.notifications.dnd.behavior.createInboxItem':
    'Always create inbox items',
  'settings.notifications.dnd.behavior.inherit': 'Inherit default',
  'settings.notifications.dnd.behavior.suppressPush': 'Suppress push only',
  'settings.notifications.dnd.behavior.suppressAll': 'Suppress all delivery',
  'settings.notifications.dnd.behavior.allowBadgeOnly': 'Allow badge only',
  'settings.notifications.dnd.behavior.allowCallRing': 'Allow call ring',
  'settings.notifications.dnd.behavior.allowAll': 'Allow all',
  'settings.notifications.dnd.schedules.title': 'Weekly schedules',
  'settings.notifications.dnd.schedules.add': 'Add schedule',
  'settings.notifications.dnd.schedules.empty': 'No schedules created yet.',
  'settings.notifications.dnd.schedules.range': 'Quiet hours',
  'settings.notifications.dnd.schedules.item': 'Schedule {index}',
  'settings.notifications.dnd.schedules.untitled': 'Untitled schedule',
  'settings.notifications.dnd.schedules.name': 'Schedule name',
  'settings.notifications.dnd.schedules.enabled': 'Schedule enabled',
  'settings.notifications.dnd.schedules.days': 'Days of week',
  'settings.notifications.dnd.schedules.start': 'Start time',
  'settings.notifications.dnd.schedules.end': 'End time',
  'settings.notifications.dnd.schedules.dateRange.title':
    'Date range (optional)',
  'settings.notifications.dnd.schedules.dateRange.start': 'Start date',
  'settings.notifications.dnd.schedules.dateRange.end': 'End date',
  'settings.notifications.dnd.schedules.channels': 'Channels',
  'settings.notifications.dnd.schedules.behavior': 'Behavior override',
  'settings.notifications.dnd.schedules.priority': 'Priority',
  'settings.notifications.dnd.deviceOverrides.title': 'Device overrides',
  'settings.notifications.dnd.deviceOverrides.add': 'Add device override',
  'settings.notifications.dnd.deviceOverrides.untitled': 'New override',
  'settings.notifications.dnd.deviceOverrides.endpointId': 'Endpoint ID',
  'settings.notifications.dnd.deviceOverrides.channels': 'Channels',
  'settings.notifications.dnd.deviceOverrides.behavior': 'Behavior override',
  'settings.notifications.dnd.days.mon': 'Mon',
  'settings.notifications.dnd.days.tue': 'Tue',
  'settings.notifications.dnd.days.wed': 'Wed',
  'settings.notifications.dnd.days.thu': 'Thu',
  'settings.notifications.dnd.days.fri': 'Fri',
  'settings.notifications.dnd.days.sat': 'Sat',
  'settings.notifications.dnd.days.sun': 'Sun',
  'settings.notifications.alerts.missingTimezone':
    'Timezone is required when DND is enabled.',
  'notifications.alerts.new': 'You have a new notification{title}',
  'notifications.prompt.title': 'Welcome!',
  'notifications.prompt.description':
    "Turn on notifications so you don't miss any important messages.",
  'notifications.prompt.actions.enable': 'Turn on notifications',
  'notifications.prompt.actions.notNow': 'Not now',
  'notifications.prompt.actions.dismiss': "Don't show again",
  'notifications.prompt.actions.close': 'Close',
  'notifications.prompt.alerts.enabled': 'Notifications turned on.',
  'notifications.prompt.alerts.permissionDenied':
    'Enable notifications in your browser settings and try again.',
  'notifications.prompt.alerts.unsupported':
    'This browser does not support push notifications.',
  'notifications.prompt.alerts.unavailable':
    'Notifications are not available right now.',
  'notifications.prompt.alerts.subscriptionFailed':
    'Could not prepare the browser subscription. Try again.',
  'notifications.prompt.alerts.endpointRegistrationFailed':
    'Could not register this device for notifications. Try again.',
  'notifications.prompt.alerts.timeout':
    'Notification activation is taking too long. Try again in a few seconds.',
  'communications.table.export.button': 'Export file',
  'communications.table.export.alert.inProgress':
    'Export is in progress. You will receive a notification when it is ready.',
  'communications.table.export.alert.error':
    'Could not start the export. Please try again.',
  'communications.table.export.dialog.title': 'Export conversations',
  'communications.table.export.dialog.description':
    'Select the file format to export the current table.',
  'communications.table.export.dialog.confirm': 'Export',
  'communications.table.export.dialog.cancel': 'Cancel',
  'communications.table.export.format.xlsx': 'Excel (.xlsx)',
  'communications.table.export.format.csv': 'CSV (.csv)',
  'communications.dropdown.status.mobileTitle': 'Change status',
  'communications.dropdown.assignee.mobileTitle': 'Assign conversation',
  'communications.dropdown.savedViews.mobileTitle': 'Saved views',
  'communications.dropdown.bulkActions.mobileTitle': 'Bulk actions',
  'communications.dropdown.bulkActions.assign.mobileTitle':
    'Assign conversations',
  'communications.dropdown.bulkActions.move.mobileTitle': 'Move conversations',
  'communications.dropdown.funnel.mobileTitle': 'Select a funnel',

  // Websites - Settings
  'websites.settings.title': 'Websites',
  'websites.settings.error.title': 'We could not load the site configuration',
  'websites.settings.error.description':
    'Try again in a few seconds or review the template configuration.',
  'websites.settings.actions.previewDraft': 'Preview',
  'websites.settings.actions.saveDraft': 'Save draft',
  'websites.settings.actions.saveAndDeploy': 'Publish changes',
  'websites.settings.alerts.deploySuccess': 'Site published successfully.',
  'websites.settings.alerts.deployFailed': 'The site publication failed.',
  'websites.settings.alerts.deployFailedWithError':
    'Publication failed: {errorMessage}',
  'websites.settings.alerts.saveDraftSuccess': 'Site draft saved.',
  'websites.settings.alerts.saveDraftError': 'Could not save the site.',
  'websites.settings.alerts.provisionalSlugUnavailable':
    'That provisional slug is already in use. Choose another one.',
  'websites.settings.alerts.previewBlocked':
    'The preview was created, but the browser blocked the new tab.',
  'websites.settings.alerts.previewError': 'Could not open the draft preview.',
  'websites.settings.alerts.deployStarted':
    'Publication started. We are publishing the site.',
  'websites.settings.alerts.deployStartError':
    'Could not start the site publication.',
  'websites.settings.alerts.logoDurabilityPending':
    'The draft was saved, but the logo is still being prepared. Try publishing again shortly.',
  'websites.settings.template.private': 'Private',
  'websites.settings.template.public': 'Public',
  'websites.settings.template.technicalConfigDescription':
    'Completed automatically when selecting a template. Edit only for testing or support.',
  'websites.settings.template.keyLabel': 'Template key',
  'websites.settings.template.versionLabel': 'Version',
  'websites.settings.provisionalSlug.label': 'Provisional address name',
  'websites.settings.logo.label': 'Website logo',
  'websites.settings.logo.help':
    'Upload a PNG, JPEG, WebP, or SVG file up to 5 MB.',
  'websites.settings.logo.inactive':
    'This template does not support logos. Your saved logo is retained and will become active again on a supporting template.',
  'websites.settings.logo.remove': 'Remove logo',
  'websites.settings.logo.upload': 'Upload logo',
  'websites.settings.logo.change': 'Change',
  'websites.settings.logo.changeLabel': 'Change logo',
  'websites.settings.logo.empty': 'No logo',
  'websites.settings.logo.dimensions': '{width} × {height} px',
  'websites.settings.logo.check.ideal':
    'Good size and shape for the header of every design.',
  'websites.settings.logo.check.square':
    'It is almost square, so we show it smaller, next to your agency name.',
  'websites.settings.logo.check.small':
    'At {width} × {height} px it may look blurry on high-resolution screens. Upload one of at least {minWidth} × {minHeight} px.',
  'websites.settings.logo.specs.title': 'To look good in every design',
  'websites.settings.logo.specs.shape':
    'Horizontal, about 4:1, for example 800 × 200 px. The designs show it about 45 px tall and up to 200 px wide.',
  'websites.settings.logo.specs.background':
    'A transparent background (SVG or PNG) and no empty margins around it, because they make it smaller.',
  'websites.settings.logo.specs.colors':
    'Made for a white background, so it works in every design. Ónix places it on a light plate.',
  'websites.settings.logo.specs.square':
    'If it is square or round, we show it next to your agency name.',
  'websites.settings.logo.previewAlt': 'Current website logo preview',
  'websites.settings.logo.progressLabel': 'Website logo upload progress',
  'websites.settings.logo.saveBeforeTemplateChange':
    'Save or remove the uploaded logo before changing templates.',
  'websites.settings.logo.deferredCleanup':
    'The currently published logo will remain available until the next successful publication, then storage cleanup will run.',
  'websites.settings.logo.status.preparing': 'Preparing and validating logo…',
  'websites.settings.logo.status.uploading': 'Uploading logo…',
  'websites.settings.logo.status.finalizing': 'Validating uploaded logo…',
  'websites.settings.logo.status.waitingForDurability':
    'Draft saved. Finishing logo storage before publication…',
  'websites.settings.logo.status.durabilityPending':
    'Draft saved. The logo is still being prepared; try publishing again shortly.',
  'websites.settings.logo.status.ready':
    'Logo uploaded. Save the draft to keep this change.',
  'websites.settings.logo.status.removed':
    'Logo removed from the draft. Save to keep this change.',
  'websites.settings.logo.errors.empty': 'Choose a non-empty logo file.',
  'websites.settings.logo.errors.tooLarge':
    'The logo is larger than 5 MB. Choose a smaller file.',
  'websites.settings.logo.errors.unsupportedType':
    'Choose a PNG, JPEG, WebP, or SVG logo.',
  'websites.settings.logo.errors.extensionMismatch':
    'The filename extension does not match the logo format.',
  'websites.settings.logo.errors.uploadFailed':
    'The logo could not be uploaded or validated. The previous logo is still selected.',
  'websites.settings.status.title': 'Current status',
  'websites.settings.status.labels.status': 'Status',
  'websites.settings.status.labels.liveUrl': 'Live address',
  'websites.settings.status.labels.provisionalUrl': 'Provisional address',
  'websites.settings.status.labels.primaryDomain': 'Primary domain',
  'websites.settings.status.labels.latestDeployment': 'Latest publication',
  'websites.settings.status.labels.deploymentError': 'Publication error',
  'websites.settings.status.deploymentSummary': 'v{version} · {status}',
  'websites.settings.status.pendingFirstDeploy': 'Pending first publication',
  'websites.settings.status.pending': 'Pending',
  'websites.settings.websiteStatus.draft': 'Draft',
  'websites.settings.websiteStatus.publishing': 'Publishing',
  'websites.settings.websiteStatus.published': 'Published',
  'websites.settings.websiteStatus.failed': 'Failed',
  'websites.settings.deploymentStatus.queued': 'Queued',
  'websites.settings.deploymentStatus.running': 'Running',
  'websites.settings.deploymentStatus.succeeded': 'Completed',
  'websites.settings.deploymentStatus.failed': 'Failed',
  'websites.settings.navigation.home': 'Home',
  'websites.settings.navigation.properties': 'Properties',
  'websites.settings.navigation.contact': 'Contact',
  'websites.settings.analytics.title': 'WhatsApp analytics',
  'websites.settings.analytics.description':
    'Clicks recorded on the public site in the last 30 days.',
  'websites.settings.analytics.clicksCount': '{count} clicks',
  'websites.settings.analytics.alerts.noRecentClicks.title': 'No recent clicks',
  'websites.settings.analytics.alerts.noRecentClicks.message':
    'Your site has no WhatsApp clicks in the last 7 days. Check its traffic, tracking and visibility.',
  'websites.settings.analytics.alerts.clickVolumeDrop.title':
    'Activity dropped',
  'websites.settings.analytics.alerts.clickVolumeDrop.message':
    'WhatsApp clicks dropped sharply compared with the previous week. Check for changes in traffic, campaigns or CTAs.',
  'websites.settings.analytics.error.title': 'We could not load analytics',
  'websites.settings.analytics.error.description':
    'Try again in a few seconds.',
  'websites.settings.analytics.empty.description':
    'Save and publish a site to start consolidating analytics.',
  'websites.settings.analytics.emptyValue': 'No data',
  'websites.settings.analytics.totalClicks': 'Total clicks',
  'websites.settings.analytics.bestCta': 'Best CTA',
  'websites.settings.analytics.propertiesConsulted': 'Consulted properties',
  'websites.settings.analytics.ctaBySlot': 'CTA by slot',
  'websites.settings.analytics.dailyActivity': 'Daily activity',
  'websites.settings.analytics.dailyActivity.empty':
    'No activity in the current range.',
  'websites.settings.analytics.topProperties': 'Most consulted properties',
  'websites.settings.analytics.topProperties.empty':
    'There are no clicks associated with properties yet.',
  'websites.settings.analytics.propertyFallback': 'Property {id}',
  'websites.settings.analytics.recentClicks': 'Recent clicks',
  'websites.settings.analytics.recentClicks.empty':
    'There are no recent events yet.',
  'websites.settings.analytics.recentClicks.noProperty':
    'Click without an associated property',
  'websites.settings.brochure.faqs.placeholder':
    'How do I schedule a visit? | Write us on WhatsApp and we will coordinate with you.\nDo you publish properties on portals? | Yes, depending on each property commercial plan.',
  'websites.settings.brochure.externalLinks.placeholder':
    'Property portal | https://portal.example.com\nPartner site | https://partner.example.com',
  'websites.settings.contact.title': 'Contact information',
  'websites.settings.contact.description':
    'Optional public details that compatible website templates can display.',
  'websites.settings.contact.address.label': 'Address',
  'websites.settings.contact.email.label': 'Email',
  'websites.settings.contact.phone.label': 'Visible phone number',
  'websites.settings.contact.businessHours.label': 'Business hours',
  'websites.settings.contact.instagramUrl.label': 'Instagram URL',
  'websites.settings.contact.facebookUrl.label': 'Facebook URL',
  'websites.settings.contact.tiktokUrl.label': 'TikTok URL',
  'websites.settings.contact.validation.email': 'Enter a valid email address.',
  'websites.settings.contact.validation.socialUrl':
    'Enter a complete URL beginning with http:// or https://.',
  'websites.settings.whatsApp.title': 'WhatsApp',
  'websites.settings.whatsApp.description':
    'The number that receives messages from the site and the starting text of each button.',
  'websites.settings.whatsApp.phoneNumber.label': 'WhatsApp number',
  'websites.settings.whatsApp.availableTokens':
    'Available tokens: {tenantName}, {propertyTitle}, {propertyCode}, {propertyUrl}, {siteUrl}.',
  'websites.settings.whatsApp.cta.generalContact.label': 'General contact',
  'websites.settings.whatsApp.cta.generalContact.defaultMessage':
    'Hello, I came from {siteUrl} and want more information about {tenantName}.',
  'websites.settings.whatsApp.cta.propertyCard.label': 'Property card',
  'websites.settings.whatsApp.cta.propertyCard.defaultMessage':
    'Hello, I am interested in the property {propertyTitle} ({propertyCode}) that I saw on {siteUrl}.',
  'websites.settings.whatsApp.cta.propertyDetail.label': 'Property detail',
  'websites.settings.whatsApp.cta.propertyDetail.defaultMessage':
    'Hello, I want to ask about {propertyTitle} ({propertyCode}) at {propertyUrl}.',
  'websites.settings.whatsApp.cta.scheduleVisit.label': 'Schedule visit',
  'websites.settings.whatsApp.cta.scheduleVisit.defaultMessage':
    'Hello, I want to schedule a visit for {propertyTitle} ({propertyCode}).',
  'websites.settings.whatsApp.cta.aiHandoff.label': 'AI handoff',
  'websites.settings.defaultContent.headline':
    'Find your next property with {siteName}',
  'websites.settings.defaultContent.description':
    'Real estate agency. Sales and rentals of houses, apartments, land and offices.',
  'websites.settings.defaultContent.services.appraisal':
    'Market appraisal with data from your area',
  'websites.settings.defaultContent.services.listing':
    'Photos and listing on this site and on the main property portals',
  'websites.settings.defaultContent.services.visits':
    'Coordinated, accompanied viewings',
  'websites.settings.defaultContent.services.closing':
    'Legal review and support through signing',
  'websites.settings.defaultContent.legalText':
    'Published prices, areas, availability and features are for reference only and must be confirmed with the agency before any transaction.',
  'websites.settings.defaultContent.privacyText':
    'When you message us on WhatsApp from this site, we receive your number, your name and your message. We use them only to answer your inquiry and arrange viewings, and we never sell them.\n\nThis site runs on Comos, which processes this data on our behalf and records clicks on the WhatsApp buttons to learn which properties bring inquiries. You can read the Comos privacy policy at comos.ai.\n\nTo ask for access to your data, or to correct or delete it, write to us on WhatsApp or through the contact details on this site.',
  'websites.templatePreview.title': 'Preview with your details',
  'websites.templatePreview.iframeTitle': 'Preview {templateName}',
  'websites.templatePreview.fallbackNotice':
    'This template does not expose a package preview yet. Showing a fallback with registry metadata.',
  'websites.settings.page.notPublishedYet': 'Not published yet',
  'websites.settings.page.unpublishedChanges': 'You have unpublished changes',
  'websites.settings.page.publishingChanges':
    'Publishing your changes: your site updates in a few minutes',
  'websites.settings.actions.openPreviewSheet': 'Preview',
  'websites.settings.actions.publishShort': 'Publish',
  'websites.settings.actions.publishing': 'Publishing…',
  'websites.settings.actions.saveDraftShort': 'Save',
  'websites.settings.steps.label': 'Sections',
  'websites.settings.steps.design': 'Design',
  'websites.settings.steps.brand': 'Brand',
  'websites.settings.steps.contact': 'Contact and WhatsApp',
  'websites.settings.steps.content': 'Content',
  'websites.settings.steps.address': 'Web address',
  'websites.settings.design.title': 'Choose a design',
  'websites.settings.design.description':
    'Every design uses your listings, your logo and your color. Try as many as you like: nothing changes on your site until you press Publish changes.',
  'websites.settings.design.empty':
    'There are no designs available for your account yet.',
  'websites.settings.design.badge.recommended': 'Recommended',
  'websites.settings.design.badge.new': 'New',
  'websites.settings.design.badge.inUse': 'In use',
  'websites.settings.design.actions.try': 'Try this design',
  'websites.settings.design.actions.tryNamed': 'Try {templateName}',
  'websites.settings.design.actions.viewExample': 'View example',
  'websites.settings.design.selected': 'In the preview',
  'websites.settings.design.thumbnailTitle': '{templateName} thumbnail',
  'websites.settings.design.technical.title':
    'Technical options · Comos team only',
  'websites.settings.design.technical.renderer': 'Renderer: {renderer}',
  'websites.settings.design.technical.registry':
    'Registry: {visibility} · {registryTemplateId}',
  'websites.settings.brand.title': 'Your brand',
  'websites.settings.brand.description':
    'Your logo and one color are enough: the design adapts on its own.',
  'websites.settings.brand.color.title': 'Your brand color',
  'websites.settings.brand.color.description':
    'Used for buttons, links and details across the site. One color is enough.',
  'websites.settings.brand.color.swatch.green': 'Green',
  'websites.settings.brand.color.swatch.blue': 'Blue',
  'websites.settings.brand.color.swatch.terracotta': 'Terracotta',
  'websites.settings.brand.color.swatch.yellow': 'Yellow',
  'websites.settings.brand.color.swatch.violet': 'Violet',
  'websites.settings.brand.color.swatch.black': 'Black',
  'websites.settings.brand.color.sample': 'This is how your buttons look',
  'websites.settings.brand.color.contrastLight':
    'White text reads well on your color.',
  'websites.settings.brand.color.contrastDark':
    'Your color is light: dark text reads better on it.',
  'websites.settings.brand.color.invalid':
    'Enter a valid HEX color, for example #1E6B52.',
  'websites.settings.brand.secondaryColors.title':
    'Secondary colors (optional)',
  'websites.settings.brand.secondaryColors.description':
    'Some designs use a secondary and an accent color. If you do not need them, leave them as they are.',
  'websites.settings.brand.secondaryColor.label': 'Secondary color',
  'websites.settings.brand.accentColor.label': 'Accent color',
  'websites.settings.brand.siteName.label': 'Name on the site',
  'websites.settings.brand.headline.label': 'Main headline',
  'websites.settings.brand.headline.help':
    'Shown large on the home page. Say what you do and where.',
  'websites.settings.brand.headline.tooLong':
    'More than {max} characters can look long on the home page.',
  'websites.settings.brand.headline.count': '{count} / {max}',
  'websites.settings.brand.description.label': 'Short description',
  'websites.settings.brand.texts.title': 'Home page text',
  'websites.settings.brand.texts.description':
    'The name, headline and description visitors see first.',
  'websites.settings.brand.heroImage.title': 'Cover image',
  'websites.settings.brand.heroImage.optional': '(optional)',
  'websites.settings.brand.heroImage.help':
    'Paste the link of a landscape image. If you leave it empty, the design picks the image for you.',
  'websites.settings.brand.heroImage.label': 'Image link',
  'websites.settings.contactStep.title': 'Contact and WhatsApp',
  'websites.settings.contactStep.description':
    'How clients reach you from the site and which contact details they see.',
  'websites.settings.content.title': 'Content',
  'websites.settings.content.description':
    'Optional sections of your site. Empty sections are not shown.',
  'websites.settings.content.sections.title': 'Site sections',
  'websites.settings.content.neighborhoods.label': 'Featured areas',
  'websites.settings.content.neighborhoods.placeholder':
    'Santiago\nPuerto Varas\nValdivia',
  'websites.settings.content.services.label': 'Services',
  'websites.settings.content.services.placeholder':
    'Appraisal\nViewing management\nLegal support',
  'websites.settings.content.faqs.label': 'Frequently asked questions',
  'websites.settings.content.externalLinks.label': 'External links',
  'websites.settings.content.legal.label': 'Legal text',
  'websites.settings.content.legal.placeholder':
    'Published information is for reference and may change without notice.',
  'websites.settings.content.legalPage.title': 'Legal and privacy',
  'websites.settings.content.legalPage.description':
    'Text for the Legal and privacy page of your site.',
  'websites.settings.content.privacy.label': 'Privacy text',
  'websites.settings.content.privacy.help':
    'Explain what data you receive from visitors, what you use it for, who else receives it, and how they can ask for access, correction or deletion.',
  'websites.settings.content.formatHint':
    'Use one line per item. For questions and links use the format Title | Content.',
  'websites.settings.address.title': 'Web address',
  'websites.settings.address.provisional.title': 'Provisional address',
  'websites.settings.address.description':
    'Where people find your site, your domains, and the publishing status.',
  'websites.settings.address.provisionalUrl': 'Your site lives at {url}',
  'websites.settings.address.provisionalNotConfigured':
    'Provisional address not configured',
  'websites.settings.noAccess.title': "You don't have access to websites",
  'websites.settings.noAccess.description':
    'You need the websites permission to see these settings.',
  'websites.settings.previewSheet.title': 'Preview · {templateName}',
  'websites.settings.previewSheet.close': 'Close preview',
  'websites.settings.previewSheet.hint':
    'Browse like a client would: search, open listings, and try WhatsApp.',
  'websites.settings.previewSheet.realPreview': 'See it with your listings',
  'websites.settings.previewSheet.keepEditing': 'Keep editing',
  'websites.settings.previewSheet.publish': 'Publish',
  'websites.templatePreview.caption':
    'This is how {templateName} looks with your logo and color, using sample listings. Browse the preview to check the catalog and listing pages.',
  'websites.templatePreview.captionLive':
    'This is how {templateName} will look when published, with your text, logo, color and listings. Browse the preview to check the catalog and listing pages.',
  'websites.templatePreview.pendingPublish':
    'These changes go live when you press Publish changes.',
  'websites.templatePreview.publishing':
    "We're publishing these changes. Your site updates in a few minutes.",
  'websites.templatePreview.device.desktop': 'Desktop',
  'websites.templatePreview.device.mobile': 'Phone',
  'websites.templatePreview.noDesign':
    'Choose a design to see how it looks with your details.',
  'websites.templatePreview.openInNewTab': 'Open in a new tab',

  // Websites - Domain setup
  'websites.settings.domains.title': 'Domains',
  'websites.settings.domains.instructions.title':
    'How to connect your own domain',
  'websites.settings.domains.instructions.description':
    "You need access to your domain's DNS settings, where you bought or manage it. For now you can connect subdomains, such as www.yourdomain.com.",
  'websites.settings.domains.instructions.publish':
    'Publish your site. A domain can only be connected to a published site.',
  'websites.settings.domains.instructions.addSubdomain':
    "Type the subdomain you want to use, for example www.yourdomain.com, and press Add domain. Type only the address, without https:// or slashes. The domain without www (yourdomain.com) can't be connected yet.",
  'websites.settings.domains.instructions.certificateRecord':
    "Within a few minutes the security certificate record appears below; if you don't see it, press Check status. Create it in your DNS as a CNAME record, copying the name and value exactly as shown.",
  'websites.settings.domains.instructions.siteRecord':
    'Once the certificate is approved, your site record appears. Create it as a CNAME too: it is the one that makes your subdomain open your site.',
  'websites.settings.domains.instructions.automaticCheck':
    "We check your domain automatically every 15 minutes for 6 hours, so you don't need to stay on this page. When the status says Active, your site opens on your domain. If you already fixed something and don't want to wait, press Check status.",
  'websites.settings.domains.instructions.tip':
    'If your provider adds your domain to the end of the name on its own, type only the first part. For example, www instead of www.yourdomain.com.',
  'websites.settings.domains.newDomain.label': 'New custom domain',
  'websites.settings.domains.newDomain.placeholder': 'www.yourdomain.com',
  'websites.settings.domains.publishFirst':
    'Publish your site to connect a domain.',
  'websites.settings.domains.errors.hostnameOnly':
    'Type only the address, without https:// or slashes.',
  'websites.settings.domains.errors.wildcard':
    "You can't use * in the domain. Type the exact subdomain, for example www.",
  'websites.settings.domains.errors.subdomainRequired':
    "Add a subdomain in front of your domain, for example www. The domain without www can't be connected yet.",
  'websites.settings.domains.errors.invalidCharacters':
    'Use only unaccented letters, numbers, hyphens and dots.',
  'websites.settings.domains.actions.add': 'Add domain',
  'websites.settings.domains.actions.reviewStatus': 'Check status',
  'websites.settings.domains.type.provisional': 'Provisional',
  'websites.settings.domains.type.custom': 'Custom',
  'websites.settings.domains.status.provisional': 'Provisional',
  'websites.settings.domains.status.pendingDns': 'Waiting for the certificate',
  'websites.settings.domains.status.pendingValidation': 'Connecting',
  'websites.settings.domains.status.active': 'Active',
  'websites.settings.domains.status.error': 'Error',
  'websites.settings.domains.domainStatus': '{type} · {status}',
  'websites.settings.domains.provisionalManaged':
    'Provisional address. We set it up for you, so there are no DNS records to create.',
  'websites.settings.domains.records.certificate':
    'Security certificate record',
  'websites.settings.domains.records.site': 'Site record',
  'websites.settings.domains.records.type': 'Type',
  'websites.settings.domains.records.name': 'Name',
  'websites.settings.domains.records.value': 'Value',
  'websites.settings.domains.hints.preparingCertificate':
    "We're requesting the security certificate. Its record appears here within a few minutes; if you don't see it, press Check status.",
  'websites.settings.domains.hints.waitingCertificate':
    'Waiting for the certificate to be approved. Check that the certificate record exists in your DNS exactly as shown. DNS changes can take a while to show up.',
  'websites.settings.domains.hints.siteRecordReady':
    'The certificate is approved. Create your site record while we finish preparing your domain.',
  'websites.settings.domains.hints.waitingSiteRecord':
    "Your subdomain doesn't open your site yet. Check that the site record exists in your DNS exactly as shown. DNS changes can take a while to show up.",
  'websites.settings.domains.hints.finishingHttps':
    'Your site record works. We are finishing the secure connection (HTTPS).',
  'websites.settings.domains.hints.active':
    "Your domain is active. Don't delete these records from your DNS: they keep your domain and its certificate working.",
  'websites.settings.domains.hints.timedOut':
    'We stopped checking after 6 hours. Check that the records exist exactly as shown and press Check status to try again.',
  'websites.settings.domains.hints.certificateFailed':
    "The security certificate couldn't be approved. Contact us and we'll restart it.",
  'websites.settings.domains.hints.unknownError':
    "We couldn't finish verifying your domain. Press Check status to try again; if the problem continues, contact us.",
  'websites.settings.domains.hints.detail': 'Technical detail: {detail}',
  'websites.settings.domains.alerts.createSuccess':
    'Domain added. The security certificate record appears within a few minutes.',
  'websites.settings.domains.alerts.createError': 'Could not add the domain.',
  'websites.settings.domains.alerts.verifySuccess':
    "We're checking your domain again.",
  'websites.settings.domains.alerts.verifyError':
    'Could not verify the domain.',

  // Sidebar - Support & Navigation
  'support.shortLabel': 'Help',
  'support.unreadLabel': '{label}, {count} unread messages',
  'support.loading': 'Connecting you with support…',
  'support.unavailable':
    'We couldn’t open the chat. Try again or contact us on WhatsApp.',
  'support.whatsapp': 'Contact us on WhatsApp',
  'support.retry': 'Reload page',
  'sidebar.support.tooltip': 'Open help',
  'sidebar.support.label': 'I need help',
  'sidebar.pinToggle.pin': 'Pin sidebar',
  'sidebar.pinToggle.unpin': 'Collapse navigation',
  'sidebar.openNavigation': 'Open navigation',
  'sidebar.closeNavigation': 'Close navigation',
  'sidebar.collapseMenu': 'Collapse menu',
  'sidebar.expandMenu': 'Expand menu',
  'sidebar.loading': 'Loading menu',
  'sidebar.support.message':
    'Hello, I am {userName} (ID: {userId}). I need help with the platform',
  'sidebar.support.message.default': 'Hello, I need help with the platform',
  'sidebar.logout': 'Logout',
};
